import "../../../pages/AdmissionForm.css";
import "./MockInterview.css";
import "../payment/Payment.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Creatable from "react-select/creatable";
import Razorpay from "react-razorpay";
import intlTelInput from "intl-tel-input";
import {
  Alarm,
  ConstructionOutlined,
  CurrencyRupee,
  Download,
  LaptopChromebook,
  Today,
} from "@mui/icons-material";
import React, { useState, useEffect, useRef, useContext } from "react";
import $ from "jquery";
/// import files

import { AxiosInstance } from "../../../axios/index";
import { validateFields, validateFields_mock } from "./Validation";
import { TechQualification } from "../../../pages/TechnicalQualification";
import {
  GSTPRICE,
  ImageUrlPrefix,
  LBL_BASIC_DETAILS,
  LBL_CONTACT_DETAILS,
  LBL_ID_PROOFS,
  PaymentSKey,
} from "../../../labels/index.js";
import Subnav from "../../../features/Core/Header/Subnav";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SpecialPrefrence from "../../../pages/dashboard/SpecialPrefrence";
import MultiSelect from "multiselect-react-dropdown";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import { object } from "yup";
import SpecialPre from "../../../pages/dashboard/SpecialPre";
// import { PictureAsPdfIcon } from '@mui/icons-material'
import facebook from "../../../img/socialicons/facebook.png";
import insta from "../../../img/socialicons/insta.png";
import linkedin from "../../../img/socialicons/linkedin.png";
import twitter from "../../../img/socialicons/twitter.svg";
import whatsapp from "../../../img/socialicons/whastapp.png";
import youtube from "../../../img/socialicons/youtube.png";
import Select, { components } from "react-select";
// function start
// import { toWords } from "number-to-words";
import { ToWords } from "to-words";
import { customStyles } from "../../../pages/customStyles";
import { multiCusutomStyle } from "../../../pages/Multicustomstyles";
import { CommonOption, CustomCOption } from "../../../labels/Lableoption";
import DatePickerSample from "../DatePicker";
import MonthDatePicker from "../MonthDatePicker";
import { UserContext } from "../../../context/UserDetails.js";
import { Dialog, DialogContent } from "@mui/material";
import DropdownHeader from "../BackOffice/CourseBatch/DropdownHeader.js";

function MockInterview() {
  const navigate = useNavigate();
  const location = useLocation();
  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
      currencyOptions: {
        // can be used to override defaults for the selected locale
        name: "Rupee",
        plural: "Rupees",
        symbol: "₹",
        fractionalUnit: {
          name: "Paisa",
          plural: "Paise",
          symbol: "",
        },
      },
    },
  });
  //useState for all dropdown , input fields
  const stateRefreshs_mock = sessionStorage.getItem("stateRefreshs_mock");
  //fields use current fields focus
  const { user, logout } = useContext(UserContext);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const txtAdFname = useRef(null);
  const txtAppSpeCat = useRef(null);
  const txtAdLname = useRef(null);
  const txtAdAge = useRef(null);
  const txtAdMDob = useRef(null);
  const txtAdMStatus = useRef(null);
  const txtAdGender = useRef(null);
  const txtAdFath = useRef(null);
  const txtAdMoth = useRef(null);
  const txtAdPSize = useRef(null);
  const txtbatchDet = useRef(null);
  const txtAdAno = useRef(null);
  const txtAdApath = useRef(null);
  const txtAdCno = useRef(null);
  const txtAdCpath = useRef(null);
  const txtAdSpc = useRef(null);
  const txtAdPno = useRef(null);
  const txtAdWno = useRef(null);
  const txtAdFpo = useRef(null);
  const txtAdEmail = useRef(null);
  const txtAdPhno = useRef(null);
  const txtAdPsname = useRef(null);
  const txtAdParea = useRef(null);
  const txtAdPland = useRef(null);
  const txtAdPpost = useRef(null);
  const txtAdPtaluk = useRef(null);
  const txtAdPpincode = useRef(null);
  const txtAdPcity = useRef(null);
  const txtAdPstate = useRef(null);
  const txtAdPdistrict = useRef(null);
  const txtAdPerhno = useRef(null);
  const txtAdPersname = useRef(null);
  const txtAdPerarea = useRef(null);
  const txtAdPerland = useRef(null);
  const txtAdPererpost = useRef(null);
  const txtAdPertaluk = useRef(null);
  const txtAdPerpincode = useRef(null);
  const txtAdPercity = useRef(null);
  const txtAdPerstate = useRef(null);
  const txtAdPerdistrict = useRef(null);

  const txtAdEduc = useRef(null);
  const txtAdSslc = useRef(null);
  const txtAdSpass = useRef(null);
  const txtAdSmarks = useRef(null);
  const txtAdSboard = useRef(null);
  const txtAdSschool = useRef(null);
  const txtAdSins = useRef(null);
  const txtAdSfile = useRef(null);
  const txtAdHslc = useRef(null);
  const txtAdHpass = useRef(null);
  const txtAdHmarks = useRef(null);
  const txtAdHboard = useRef(null);
  const txtAdHschool = useRef(null);
  const txtAdHins = useRef(null);
  const txtAdHfile = useRef(null);
  const txtAdUCer = useRef(null);
  const txtAdUpass = useRef(null);
  const txtAdUmarks = useRef(null);
  const txtAdUdeg = useRef(null);
  const txtAdUMaj = useRef(null);
  const txtAdUMajOther = useRef(null);
  const txtAdUclass = useRef(null);
  const txtAdUins = useRef(null);
  const txtAdUfile = useRef(null);
  const txtAdPCer = useRef(null);
  const txtAdPpass = useRef(null);
  const txtAdPmarks = useRef(null);
  const txtAdPdeg = useRef(null);
  const txtAdPMaj = useRef(null);
  const txtAdPMajOther = useRef(null);
  const txtAdIMajOther = useRef(null);
  const txtAdDMajOther = useRef(null);
  const txtAdCMajOther = useRef(null);
  const txtadVerifyHere = useRef(null);
  const txtAdPclass = useRef(null);
  const txtAdPins = useRef(null);
  const txtAdPfile = useRef(null);
  const txtAdICer = useRef(null);
  const txtAdIpass = useRef(null);
  const txtAdImarks = useRef(null);
  const txtAdIdeg = useRef(null);
  const txtAdIMaj = useRef(null);
  const txtAdIclass = useRef(null);
  const txtAdIins = useRef(null);
  const txtAdIfile = useRef(null);
  const txtAdDCer = useRef(null);
  const txtAdDpass = useRef(null);
  const txtAdDmarks = useRef(null);
  const txtAdDdeg = useRef(null);
  const txtAdDMaj = useRef(null);
  const txtAdDclass = useRef(null);
  const txtAdDins = useRef(null);
  const txtAdDfile = useRef(null);
  const txtAdCCer = useRef(null);
  const txtAdCpass = useRef(null);
  const txtAdCmarks = useRef(null);
  const txtAdCdeg = useRef(null);
  const txtAdCMaj = useRef(null);
  const txtAdCclass = useRef(null);
  const txtAdCins = useRef(null);
  const txtAdCfile = useRef(null);
  const txtAdOCer = useRef(null);
  const txtAdOpass = useRef(null);
  const txtAdOmarks = useRef(null);
  const txtAdOdeg = useRef(null);
  const txtAdOMaj = useRef(null);
  const txtAdOclass = useRef(null);
  const txtAdOins = useRef(null);
  const txtAdOfile = useRef(null);
  const txtAdCate = useRef(null);
  const txtAdExamPassed = useRef(null);
  const txtAdExamRegno = useRef(null);
  const txtAdLoca = useRef(null);
  const txtAdGovtInteDate = useRef(null);
  const txtAdcMode = useRef(null);
  const txtAdSub = useRef(null);
  const txtAdExam = useRef(null);
  const txtAdinsu = useRef(null);
  const txtAdEdetail = useRef(null);
  const txtAdPDates = useRef(null);
  const txtAdEclear = useRef(null);
  const txtAdDesg = useRef(null);
  const txtAdDep = useRef(null);
  const txtAdDjoin = useRef(null);
  const txtAdayear = useRef(null);
  const txtAdacate = useRef(null);
  const txtAdacourse = useRef(null);
  const txtAdaIdnum = useRef(null);
  const txtAdafile = useRef(null);
  const txtAdPPayment = useRef(null);
  const txtAdPPaymentMode = useRef(null);
  const hasInfoViewAdmBeenCalled = useRef(false);

  const txtAdCourse = useRef(null);
  const refCourseName = useRef(null);
  const refCoreSubject = useRef(null);
  const refMediumStudied = useRef(null);
  const refGovtExamName = useRef(null);
  const refGovtExamRegisternumber = useRef(null);
  const refPreferredBranchLocation = useRef(null);
  const placeBirthRef = useRef(null);
  const districtRef = useRef(null);

  //multiple dropdown chip

  const [selectedPrev, setSelectedPrev] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [pgDegree, setPGDegree] = useState([]);
  const [ipgDegree, setIPGDegree] = useState([]);
  const [readbatch, setReadbatch] = useState([]);
  const [readSpecialpre, setReadSpecialpre] = useState([]);
  const [step, setStep] = useState(1);
  const [cOption, setCOption] = useState([]);
  const [catOption, setCatOption] = useState([]);
  const [teachMedium, setTeachMedium] = useState([]);
  const [department, setDepartment] = useState([]);
  const [examination, setExamination] = useState([]);
  const [previousexam, setPreviousexam] = useState([]);
  const [educationOptions, setEducationOptions] = useState([]);
  const [technicalOption, setTechnicalOption] = useState([]);
  const [pcDegree, setPCDegree] = useState([]);
  const [diplomaDegree, setDiplomaDegree] = useState([]);
  const [categoryOption, setCategoryOption] = useState([]);
  const [coursesCate, setCoursesCate] = useState([]);
  const [preDates, setPreDates] = useState([]);
  const [selectedPreDate, setSelectedPreDate] = useState([]);
  const [city, setCity] = useState([]);
  const [major, setMajor] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [specialPrefrence, setSpecialPrefrence] = useState([]);
  const [ugDegree, setUGDegree] = useState([]);
  const [pgMajor, setPgMajor] = useState([]);
  const [ipMajor, setIpMajor] = useState([]);
  const [dmajor, setDmajor] = useState([]);
  const [pcMajor, setPcmajor] = useState([]);
  const [otMajor, setOTmajor] = useState([]);
  const [listErrors, setListErrors] = useState({});
  const [classOption, setClassOption] = useState([]);
  const [batchDetails, setBatchDetails] = useState([]);
  const [courseAias, setCourseAias] = useState([]);
  const [mockInterviewCourse, setMockInterviewCourse] = useState([]);
  const [locations, setLocations] = useState([]);
  const [offSpl, setOffSpl] = useState(0);
  const [message, setMessage] = useState("");
  const [stepperButton, setStepperButton] = useState(false);
  const [offSplDisplayType, setOffSplDisplayType] = useState(0);
  const [tagsList, setTagsList] = useState([]);
  //admission id  after the step 4 api call
  const [admissionID, setAdmissionID] = useState({
    adId: 0,
    is_paid: null,
    batch_id: null,
  });
  const [infoBatch, setInfoBatch] = useState(null);
  const [appcategoryOption, setAppCategoryOption] = useState([]);
  const [appCastLable, setAppCastLable] = useState([]);
  const [selectAll, setSelectAll] = useState(false); // select all batches globally
  const [scp_stt, setScp_stt] = useState(false);
  let ActualFees = 0; // for exam fees selected panel maintain step 7
  const [batchMessage, setBatchMessage] = useState(null);
  //get user_id from localhost and set global
  const [dis, setDis] = useState(null);
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, [step]);
  const currentDate_Join = moment().format("YYYY-MM-DD"); // step 4 join govt date
  //coupon code applied usestate
  const [couponApplied, setCouponApplied] = useState({
    coupon_status: false,
    amount: 0,
    coupon_code: "",
  });
  //education useState
  const [educationQualification, setEducationQualification] = useState([
    "SSLC",
  ]);
  const [uGisOther, setUGIsOther] = useState(false);
  const [pGisOther, setPGIsOther] = useState(false);
  const [iPGisOther, setIPGIsOther] = useState(false);
  const [dipisOther, setDipIsOther] = useState(false);
  const [pCisOther, setPCIsOther] = useState(false);

  const [ugOption, setUgOption] = useState({
    UG: null,
    PG: null,
    Integrated_PG: null,
    Diploma: null,
    Professional_Courses: null,
  });

  const [mOption, setMOption] = useState({
    UGMajor: null,
    UGClassName: null,
    PGMajor: null,
    PGClassName: null,
    IPMajor: null,
    IPClassName: null,
    DMajor: null,
    DClassName: null,
    PCMajor: null,
    PCClassName: null,
    OtClassName: null,
  });
  //education useState
  const [sslcCerficates, setSslcCerficates] = useState([
    {
      name: "sslc",
      SSLC_CNo: "",
      SSLC_Year: "",
      SSLC_Marks: "",
      SSLC_Eboard: "",
      SSLC_Scl: "",
      SSLC_MI: "",
      SSLC_Path: null,
      original_file_path: null,
    },
    {
      name: "hsc",
      HSC_CNo: "",
      HSC_Year: "",
      HSC_Marks: "",
      HSC_Ebaord: "",
      HSC_Scl: "",
      HSC_MI: "",
      HSC_Path: null,
      original_file_path: null,
    },
    {
      name: "UG",
      UGCertificateNumber: "",
      UGYearpassing: "",
      UGDegree: "",
      UGMajor: "",
      UGMajor_Other: "",
      UGMarksPercentage: "",
      UGClassName: "",
      UGNameInstitute: "",
      UG_Path: null,
      original_file_path: null,
    },
    {
      name: "PG",
      PGCertificateNumber: "",
      PGYearpassing: "",
      PGDegree: "",
      PGMajor: "",
      PGMajor_Other: "",
      PGMarksPercentage: "",
      PGClassName: "",
      PGNameInstitute: "",
      PG_Path: null,
      original_file_path: null,
    },
    {
      name: "Integrated PG",
      IPCertificateNumber: "",
      IPYearpassing: "",
      IPDegree: "",
      IPMajor: "",
      IPMajor_Other: "",
      IPMarksPercentage: "",
      IPClassName: "",
      IPNameInstitute: "",
      IP_Path: null,
      original_file_path: null,
    },
    {
      name: "Diploma",
      DCertificateNumber: "",
      DYearpassing: "",
      DDegree: "",
      DMajor: "",
      DMajor_other: "",
      DMarksPercentage: "",
      DClassName: "",
      DNameInstitute: "",
      D_Path: null,
      original_file_path: null,
    },
    {
      name: "Professional Courses",
      PCCertificateNumber: "",
      PCYearpassing: "",
      PCDegree: "",
      PCMajor: "",
      PCMajor_Other: "",
      PCMarksPercentage: "",
      PCClassName: "",
      PCNameInstitute: "",
      PC_Path: null,
      original_file_path: null,
    },
    {
      name: "Others",
      OtCertificateNumber: "",
      OtYearpassing: "",
      OtDegree: "",
      OtMajor: "",
      OtMarksPercentage: "",
      OtClassName: "",
      OtNameInstitute: "",
      Ot_Path: null,
      original_file_path: null,
    },
  ]);
  //specialPreference
  const [specialAdmissionPre, setSpecialAdmissionPre] = useState([
    // {
    //   id: 1,
    //   name: "",
    //   file: "",
    // },
  ]);
  //technical qualification
  const [techQualification, setTechQualification] = useState([
    {
      id: 0,
      name: "",
      level: "",
      lang: "",
      Cnum: "",
      grade: "",
      year: "",
      file: "",
      error_name: "",
      edu_medium: "",
      error_certificate_no: "",
      error_year_of_passing: "",
      error_level: "",
      error_grade: "",
      error_certificate_path: "",
      original_file_path: "",
    },
  ]);
  const [dropdown, setDropDown] = useState({
    Cast: null,
    ExamName: null,
  });
  //list of inputs
  const [list, setList] = useState({
    FirstName: "",
    LastName: "",
    Fathername: "",
    MotherName: "",
    Profilephoto: null,
    DOB: "",
    age: 0,
    gender: "Male",
    MaritalStatus: "Single/Unmarried",
    aadharNo: "",
    aadharCardphoto: null,
    original_aadhar_path: null,
    original_profile_path: null,
    original_caste_path: null,
    Mobile: "",
    MobileCode: "",
    WhatsAppNumberCode: "",
    ParentMobileNoCode: "",
    WhatsAppNumber: "",
    ParentMobileNo: "",
    ContactNumber: false,
    SamePresentAddress: false,
    emailaddress: "",
    BuildingNumberPresent: "",
    StreetNamePresent: "",
    AreaPresent: "",
    LandmarkPresent: "",
    districtPresent: "",
    CityPresent: "",
    statePresent: "",
    PostPresent: "",
    TalukPresent: "",
    PincodePresent: 0,
    BuildingNumberPermanent: "",
    StreetNamePermanent: "",
    AreaPermanent: "",
    LandmarkPermanent: "",
    CityPermanent: "",
    districtPermanent: "",
    statePermanent: "",
    PincodePermanent: 0,
    PostPermanent: "",
    TalukPermanent: "",
    PresentAddress: false,
    Cast: "",
    CastFile: null,
    // STEP 4
    category: "",
    courseId: "",
    courseName: "",
    mockInterviewType: "0",
    modeOfInterview: "0",
    coreSubject: [],
    mediumStudied: "",
    govtExamName: "",
    govtExamRegisternumber: "",
    medium: "",
    preferredBranchLocation: "",
    preferredBranchLocation_id: "",
    SPCcategory: "",
    CompetitiveExamination: "Yes",
    CompetitiveExamName: "",
    Institute: "",
    ExamPreviously: "Yes",
    ExamDetailsRes: "",
    ExamWrite: "",
    workingRes: "Yes",
    Designation: "",
    Department: "",
    JoinGovt: "",
    AIASAStudent: "Yes",
    Year: "",
    CategoryAias: "",
    CourseAias: "",
    IDPhoto: null,
    original_aiasa_id_path: null,
    IDNumber: "",
    ClassType: "",
    CourseCate: "",
    CouresName: "",
    TeachMedium: "",
    Verify: false,
    location: "2",
    admission_status: "",
    ExamName_passed: "",
    location_name: "",
    writtenexammark: "",
    Interviewmarks: "",
    overallrank: "",
    communalrank: "",
    typistrank: "",
    tamilrank: "",
    preferredpost: "",
    GovtInterDate: "",
    PPayment: "",
    PPaymentMode: "",
    place_birth: "",
    district_id: "",
    district_name: "",
  });
  const [examDetailsExam, setExamDetailsExam] = useState([]);
  //when course category select batch details fill with ui
  // admission form read api for all steps
  // useEffect(() => {
  //   const userJSON = sessionStorage.getItem("userDetails");
  //   if (userJSON) {
  //     const user = JSON.parse(userJSON);
  //     if (user && user.user_id) {
  //       const userid = user.user_id;

  //       if (stateRefreshs_mock !== null) {
  //         Info_View(userid);
  //       }
  //     }
  //   }
  // }, [stateRefreshs_mock]);

  useEffect(() => {
    AxiosInstance.get("api/codevalues?type=4")
      .then((res) => {
        const appcategoryOption = res.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));

        // Sort the options alphabetically, ignoring "Nil"
        const sortedOptions = appcategoryOption
          .filter((item) => item.value !== "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        const NilOption = appcategoryOption
          .filter((item) => item.value === "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        // Set the sorted list to the state
        sortedOptions.push(...NilOption);
        setAppCategoryOption(sortedOptions);
        // setAppCategoryOptionAll(sortedOptions);
      })
      .catch((error) => {
        return error;
      });
  }, []);

  useEffect(() => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const userid = user.user_id;

        if (scp_stt) {
          AxiosInstance.post(`api/modelexam/info_view/${userid}/5`)
            .then((res) => {
              const userinfo = res.data.data;
              const SpecPrefrence = userinfo.scp;
              setSpecialAdmissionPre(SpecPrefrence);
            })
            .catch((error) => {
              return error;
            });
        }
      }
    }
  }, [scp_stt]);

  useEffect(() => {
    Info_View(userid);
  }, []);

  const Info_View = (userid) => {
    AxiosInstance.post(`api/modelexam/info_view/${userid}/5`)
      .then((res) => {
        if (res.data.status !== true) {
          Swal.fire({
            title: "Warning",
            text: res.data.message,
            icon: "warning",
            confirmButtonText: "Ok",
          });
          logout();
          return;
        }

        const userinfo = res.data?.data ?? {};

        // ----- Courses handling (object | array | null safe) -----
        const coursesRaw = userinfo?.Courses;
        const courseItem = Array.isArray(coursesRaw)
          ? coursesRaw[0] ?? {}
          : coursesRaw ?? {};

        // ----- Batch details SAFE -----
        const batchDetails = courseItem?.batch_details ?? null;
        setInfoBatch(batchDetails);

        // ----- SCP -----
        if (Array.isArray(userinfo?.scp) && userinfo.scp.length > 0) {
          setAppCastLable(
            userinfo.scp.map((el) => ({
              value: el,
              label: el,
            }))
          );
        } else {
          setAppCastLable([]);
        }

        // ----- Admission ID -----
        const admiId = batchDetails?.ID ?? null;

        if (admiId && !hasInfoViewAdmBeenCalled.current) {
          InfoViewAdm(admiId, userid);
          hasInfoViewAdmBeenCalled.current = true;
        }

        // ----- Person Details (NULL SAFE) -----
        const PersonDetails = {
          FirstName: userinfo?.first_name ?? "",
          LastName: userinfo?.last_name ?? "",
          Fathername: userinfo?.father_name ?? "",
          MotherName: userinfo?.mother_name ?? "",
          Profilephoto: userinfo?.profile_path ?? null,
          original_profile_path: userinfo?.original_profile_path ?? null,
          original_aadhar_path: userinfo?.original_aadhar_path ?? null,

          DOB: userinfo?.dob ? dobCon(userinfo.dob) : "",
          age: userinfo?.age ?? "",
          gender: userinfo?.gender ?? "",
          MaritalStatus: userinfo?.marital_status ?? "",
          aadharNo: userinfo?.aadhar_no ?? "",
          aadharCardphoto: userinfo?.aadhar_path ?? null,
          Cast: userinfo?.community ?? "",
          CastFile: userinfo?.community_path ? userinfo.community_path : "",
          original_caste_path: userinfo?.original_caste_path
            ? userinfo.original_caste_path
            : "",
          Mobile: userinfo?.phone_no ?? "",
          WhatsAppNumber: userinfo?.whatsapp_no ?? "",
          ContactNumber: userinfo?.contact_type === 1,
          ParentMobileNo: userinfo?.parent_mob_no ?? "",
          MobileCode: userinfo?.country_code ?? "+91",
          WhatsAppNumberCode: userinfo?.country_code ?? "+91",
          ParentMobileNoCode: userinfo?.country_code ?? "+91",
          emailaddress: userinfo?.email ?? "",

          // ----- Batch safe mapping -----
          courseId: batchDetails?.course_id ?? "",
          courseName: batchDetails?.course_name ?? "",
          category: batchDetails?.category ?? "",
          modeOfInterview:
            batchDetails?.class_mode === "Online"
              ? "0"
              : batchDetails?.class_mode === "ClassRoom"
              ? "1"
              : "0",
          mockInterviewType: Number(batchDetails?.paper_type) === 1 ? "1" : "0",

          coreSubject: courseItem?.core_subject
            ? {
                value: courseItem.core_subject,
                label: courseItem.core_subject,
              }
            : [],

          mediumStudied: courseItem?.medium_studied ?? "",
          govtExamName: courseItem?.government_exam_name ?? "",
          govtExamRegisternumber: courseItem?.govt_reg_no ?? "",
          preferredBranchLocation: courseItem?.location ?? "",
          preferredBranchLocation_id: courseItem?.location_id ?? "",
          place_birth: courseItem?.place_birth ?? "",
          district: batchDetails?.district ? Number(batchDetails.district) : "",
          district_name: batchDetails?.district_name ?? "",
        };

        // ----- Community dropdown -----
        if (userinfo?.community) {
          setDropDown((prev) => ({
            ...prev,
            Cast: {
              value: userinfo.community,
              label: userinfo.community,
            },
          }));
        }

        setSpecialAdmissionPre(userinfo?.scp ?? []);

        // ----- Address SAFE -----
        if (Array.isArray(userinfo?.address)) {
          userinfo.address.forEach((obj) => {
            const isPresent = obj.address_type === 1;
            const key = isPresent ? "Present" : "Permanent";

            PersonDetails.SamePresentAddress = obj.same_address === 0;

            PersonDetails[`BuildingNumber${key}`] = obj.address1 ?? "";
            PersonDetails[`StreetName${key}`] = obj.address2 ?? "";
            PersonDetails[`Area${key}`] = obj.address3 ?? "";
            PersonDetails[`Landmark${key}`] = obj.landmark ?? "";
            PersonDetails[`district${key}`] = obj.district_name ?? "";
            PersonDetails[`City${key}`] = obj.city ?? "";
            PersonDetails[`state${key}`] = obj.state_name ?? "";
            PersonDetails[`Post${key}`] = obj.post_name ?? "";
            PersonDetails[`Taluk${key}`] = obj.taluk ?? "";
            PersonDetails[`Pincode${key}`] = obj.postal_code ?? "";
          });
        }

        // ----- Course flags -----
        PersonDetails.CompetitiveExamination =
          courseItem?.competitive_exam === 1 ? "Yes" : "NO";
        PersonDetails.ExamPreviously =
          courseItem?.cleared_any_exam === 1 ? "Yes" : "NO";
        PersonDetails.workingRes = courseItem?.govt_emp === 1 ? "Yes" : "NO";
        PersonDetails.AIASAStudent =
          courseItem?.aiasa_student === 1 ? "Yes" : "NO";
        PersonDetails.admission_status = courseItem?.admission_status ?? 0;

        // ----- Preferred Dates -----
        if (courseItem?.preferred_dt) {
          setSelectedPreDate(
            courseItem.preferred_dt.split(",").map((d) => ({
              label: d.trim(),
              value: d.trim(),
            }))
          );
        }

        // ----- Payment -----
        PersonDetails.PPayment =
          Number(batchDetails?.partial_payment) === 1 ? "1" : "0";

        setAdmissionID({
          adId: admiId,
          is_paid: courseItem?.is_paid ?? 0,
          batch_id: batchDetails?.batch_id ?? null,
        });

        setList(PersonDetails);

        if (batchDetails?.batch_id) {
          getSpeciOfferDis(batchDetails.batch_id);
          getOldStudDisocount(batchDetails.batch_id);
        }

        // ---------- SAFE EDU ARRAY ----------
        const eduList = Array.isArray(userinfo?.edu) ? userinfo.edu : [];

        // ---------- EDUCATION QUALIFICATION (EDQ) ----------
        const edq = eduList
          .filter((item) => item?.qualification_type === "EDQ")
          .map((obj) => {
            if (!obj?.name) return "";

            if (obj.name === "sslc") return "SSLC";
            if (obj.name === "hsc") return "HSC";
            return obj.name;
          })
          .filter(Boolean);

        setEducationQualification(edq);

        // ---------- EDUCATION CERTIFICATES ----------
        eduList
          .filter((item) => item?.qualification_type === "EDQ")
          .forEach((el) => {
            if (!el?.name) return;

            const matchingCertificate = {
              name: el.name,
              original_file_path: el?.original_file_path ?? null,
            };

            // -------- SSLC --------
            if (el.name === "sslc") {
              Object.assign(matchingCertificate, {
                SSLC_CNo: el?.certificate_no ?? "",
                SSLC_Year: el?.year_of_passing ?? "",
                SSLC_Marks: el?.marks_percentage ?? null,
                SSLC_Eboard: el?.edu_board ?? "",
                SSLC_Scl: el?.institute ?? "",
                SSLC_MI: el?.edu_medium ?? "",
                SSLC_Path: el?.certificate_path ?? null,
              });
            }

            // -------- HSC --------
            else if (el.name === "hsc") {
              Object.assign(matchingCertificate, {
                HSC_CNo: el?.certificate_no ?? "",
                HSC_Year: el?.year_of_passing ?? "",
                HSC_Marks: el?.marks_percentage ?? null,
                HSC_Ebaord: el?.edu_board ?? "",
                HSC_Scl: el?.institute ?? "",
                HSC_MI: el?.edu_medium ?? "",
                HSC_Path: el?.certificate_path ?? null,
              });
            }

            // -------- UG --------
            else if (el.name === "UG") {
              const isOther = Number(el?.type_of_degree) === 1;
              setUGIsOther(isOther);

              setUgOption((prev) => ({
                ...prev,
                UG: {
                  value: el?.degree_name ?? "",
                  label: el?.degree_name ?? "",
                },
              }));

              setMOption((prev) => ({
                ...prev,
                UGMajor: {
                  value: isOther ? "Others" : el?.major_subject ?? "",
                  label: isOther ? "Others" : el?.major_subject ?? "",
                },
                UGClassName: {
                  value: el?.grade ?? "",
                  label: el?.grade ?? "",
                },
              }));

              Object.assign(matchingCertificate, {
                UGCertificateNumber: el?.certificate_no ?? "",
                UGYearpassing: el?.year_of_passing ?? "",
                UGDegree: el?.degree_name ?? "",
                UGMajor: isOther ? "Others" : el?.major_subject ?? "",
                UGMajor_Other: el?.major_subject ?? "",
                UGMarksPercentage: el?.marks_percentage ?? "",
                UGClassName: el?.grade ?? "",
                UGNameInstitute: el?.institute ?? "",
                UG_Path: el?.certificate_path ?? null,
              });
            }

            // -------- PG --------
            else if (el.name === "PG") {
              const isOther = Number(el?.type_of_degree) === 1;
              setPGIsOther(isOther);

              setUgOption((prev) => ({
                ...prev,
                PG: {
                  value: el?.degree_name ?? "",
                  label: el?.degree_name ?? "",
                },
              }));

              setMOption((prev) => ({
                ...prev,
                PGMajor: {
                  value: isOther ? "Others" : el?.major_subject ?? "",
                  label: isOther ? "Others" : el?.major_subject ?? "",
                },
                PGClassName: {
                  value: el?.grade ?? "",
                  label: el?.grade ?? "",
                },
              }));

              Object.assign(matchingCertificate, {
                PGCertificateNumber: el?.certificate_no ?? "",
                PGYearpassing: el?.year_of_passing ?? "",
                PGMarksPercentage: el?.marks_percentage ?? "",
                PGDegree: el?.degree_name ?? "",
                PGMajor: isOther ? "Others" : el?.major_subject ?? "",
                PGMajor_Other: el?.major_subject ?? "",
                PGClassName: el?.grade ?? "",
                PGNameInstitute: el?.institute ?? "",
                PG_Path: el?.certificate_path ?? null,
              });
            }

            // -------- OTHERS / DIPLOMA / IPG / PC --------
            else {
              Object.assign(matchingCertificate, {
                CertificateNumber: el?.certificate_no ?? "",
                Yearpassing: el?.year_of_passing ?? "",
                Degree: el?.degree_name ?? "",
                Major: el?.major_subject ?? "",
                MarksPercentage: el?.marks_percentage ?? "",
                ClassName: el?.grade ?? "",
                NameInstitute: el?.institute ?? "",
                Path: el?.certificate_path ?? null,
              });
            }

            setSslcCerficates((prevState) =>
              prevState.map((q) =>
                q.name === el.name ? matchingCertificate : q
              )
            );
          });

        // ---------- TECHNICAL / TEACHING QUALIFICATION (THQ) ----------
        const teachList = eduList.filter(
          (item) => item?.qualification_type === "THQ"
        );

        const teach =
          teachList.length > 0
            ? teachList.map((el) => ({
                id: el?.id ?? 0,
                name: el?.name ?? "",
                level: el?.level ?? "",
                lang: el?.edu_medium ?? "",
                Cnum: el?.certificate_no ?? "",
                grade: el?.grade ?? "",
                year: el?.year_of_passing ?? "",
                file: el?.certificate_path ?? "",
                original_file_path: el?.original_file_path ?? "",

                error_name: "",
                error_certificate_no: "",
                error_year_of_passing: "",
                error_level: "",
                error_grade: "",
                error_certificate_path: "",
              }))
            : [
                {
                  id: 0,
                  name: "",
                  level: "",
                  lang: "",
                  Cnum: "",
                  grade: "",
                  year: "",
                  file: "",
                  original_file_path: "",

                  error_name: "",
                  error_certificate_no: "",
                  error_year_of_passing: "",
                  error_level: "",
                  error_grade: "",
                  error_certificate_path: "",
                },
              ];

        setTechQualification(teach);
      })
      .catch((error) => {
        console.error("Info_View Error:", error);
      });
  };

  const InfoViewAdm = async (AdmisId, user_iddd) => {
    try {
      if (AdmisId) {
        const admissionResponse = await AxiosInstance.post(
          `api/course/admission/getOrderby/rpay`,
          { admission_id: AdmisId }
        );

        if (admissionResponse.data.status === true) {
          let lastIndexCaptured = {};
          const lastIndexCaptureds =
            admissionResponse.data.data.items.length > 0 &&
            admissionResponse.data.data.items
              .filter((el, inex) => el.status === "captured")
              .map((el) => el);
          if (lastIndexCaptureds.length > 0) {
            lastIndexCaptured = lastIndexCaptureds[0];
          } else {
            lastIndexCaptured =
              admissionResponse.data.data.items[
                admissionResponse.data.data.items.length - 1
              ];
          }

          let payment_status_info_ko = "";
          if (lastIndexCaptured.status === "failed") {
            payment_status_info_ko = 0;
          } else if (lastIndexCaptured.status === "created") {
            payment_status_info_ko = 1;
          } else if (lastIndexCaptured.status === "authenticated") {
            payment_status_info_ko = 2;
          } else if (lastIndexCaptured.status === "authorized") {
            payment_status_info_ko = 3;
          } else if (lastIndexCaptured.status === "captured") {
            payment_status_info_ko = 4;
          } else if (lastIndexCaptured.status === "refunded") {
            payment_status_info_ko = 5;
          }

          const lastIndexreqdata = admissionResponse.data.basic_info;
          if (payment_status_info_ko === 4) {
            const dats = {
              id: lastIndexreqdata.admission_history_id
                ? lastIndexreqdata.admission_history_id
                : "",
              step: 7,
              location_id: lastIndexreqdata.location
                ? lastIndexreqdata.location
                : "",
              category: lastIndexreqdata.category_code
                ? lastIndexreqdata.category_code
                : "",
              subject: lastIndexreqdata.subject ? lastIndexreqdata.subject : [], //send  if subject having only
              type: 5,
              Isverify: lastIndexreqdata.Isverify
                ? lastIndexreqdata.Isverify
                : true,
              AdmissionID: AdmisId,
              CouresName: lastIndexreqdata.course_name
                ? lastIndexreqdata.course_name
                : "",
              discountAmount: lastIndexreqdata.discount_amt,
              gst: lastIndexreqdata.gst_percent,
              SpecialOffer: lastIndexreqdata.special_offer,
              spc_offer_type: lastIndexreqdata.spc_offer_type,
              batch_id: lastIndexreqdata.batch_id
                ? lastIndexreqdata.batch_id
                : "",
              coures_id: lastIndexreqdata.course_id
                ? lastIndexreqdata.course_id
                : "",
              user_id: lastIndexreqdata.user_id ? lastIndexreqdata.user_id : "",
              old_stud_disc_perc: lastIndexreqdata.old_stud_disc_perc,
              old_stud_disc: lastIndexreqdata.old_stud_disc,
              iscoupon: lastIndexreqdata.is_coupon,
              couponAmount: lastIndexreqdata.coupon_amount,
              couponcode: lastIndexreqdata.coupon_code,
              Netamount: lastIndexreqdata.trans_amount
                ? lastIndexreqdata.trans_amount
                : "",
              status: payment_status_info_ko,
              transaction_id: lastIndexreqdata.trans_id
                ? lastIndexreqdata.trans_id
                : "",
              razorpay_order_id: lastIndexreqdata.order_id
                ? lastIndexreqdata.order_id
                : "",
              razorpay_signature: "",
              created_at: moment
                .unix(lastIndexCaptured.created_at)
                .format("YYYY-MM-DD HH:mm:ss"),
              installment_type:
                lastIndexreqdata.partial_payment === "1" ? [1] : [1, 2, 3],
              // partial_payment:  lastIndexreqdata.partial_payment,
              // old_stud_disc_applied: lastIndexreqdata.old_stud_disc_applied,
              // tot_amt:lastIndexreqdata.tot_amt,
              // gst_amt:lastIndexreqdata.gst_amt,
              // payment_type:list.PPaymentMode === "0" ? 0 : 1,
              // created_by:user_iddd,
              // updated_by:user_iddd
            };
            const RegsisteRes = await AxiosInstance.post(
              `api/course/admission/register`,
              dats
            );
            if (RegsisteRes.data.status === true) {
              await new Promise((resolve) => setTimeout(resolve, 1000));
              const findPayIdResponse = await AxiosInstance.post(
                `api/course/admission/findPayId/byAdmId`,
                { admission_id: AdmisId }
              );

              if (findPayIdResponse.data.status === true) {
                const userDt = findPayIdResponse.data.data;

                if (userDt.status === 4 && userDt.pay_pdf_email_sent === 0) {
                  const downloadResponse = await AxiosInstance.post(
                    "api/purchase/payment/download",
                    {
                      trans_id: userDt.trans_id,
                      type: 5,
                    }
                  );
                  const actual_amt = downloadResponse.data.data[0].actual_amt;
                  const coupon_amount =
                    downloadResponse.data.data[0].coupon_amount;
                  const special_offer =
                    downloadResponse.data.data[0].special_offer;
                  const old_stud_disc =
                    downloadResponse.data.data[0].old_stud_disc;
                  const gst_percent = downloadResponse.data.data[0].gst_percent;

                  const subtotal =
                    list.PPayment !== "1"
                      ? (
                          actual_amt -
                          (coupon_amount + special_offer + old_stud_disc)
                        ).toFixed(2)
                      : (actual_amt - (coupon_amount + special_offer)).toFixed(
                          2
                        );
                  const gst_amt = ((subtotal * gst_percent) / 100).toFixed(2);
                  const tot_amt = Number(subtotal) + Number(gst_amt);

                  const paydt = {
                    user_id: user_iddd,
                    email: downloadResponse.data.data[0].email,
                    subject: "Payment Invoice",
                    subject_rec: "Payment Receipt",
                    type: 5,
                    email_data: {
                      type: 5,
                      first_name: downloadResponse.data.data[0].first_name,
                      last_name: downloadResponse.data.data[0].last_name,
                      student_id: downloadResponse.data.data[0].student_id,
                      admission_id: downloadResponse.data.data[0].admission_id,
                      profile_path: downloadResponse.data.data[0].profile_path,
                      email: downloadResponse.data.data[0].email,
                      batch_name: downloadResponse.data.data[0].batch_name,
                      start_date: moment(
                        downloadResponse.data.data[0].batch_start_dt
                      ).format("DD-MMM-YYYY"),
                      time: downloadResponse.data.data[0].batch_timing,
                      duration: downloadResponse.data.data[0].duration,
                      class_mode: downloadResponse.data.data[0].class_mode,
                      location: downloadResponse.data.data[0].location,
                      amount_paid: downloadResponse.data[0].paid_amount,
                      amount_paid_words: toWords.convert(
                        downloadResponse.data[0].paid_amount
                      ),
                      payment_method: downloadResponse.data.data[0].method,
                      transaction_id: downloadResponse.data.data[0].trans_id,
                      payment_time: moment(
                        downloadResponse.data.data[0].transaction_date
                      ).format("DD/MM/YYYY hh:mm A"),
                      actual_amt: actual_amt,
                      coupon_amount: coupon_amount,
                      special_offer: special_offer,
                      old_stud_disc: old_stud_disc,
                      subtotal: subtotal,
                      gst_amt: gst_amt,
                      tot_amt: tot_amt,
                      parentage: list.gender === "Female" ? "D/O" : "S/O",
                      father_name: downloadResponse.data.data[0].father_name,
                      address1: downloadResponse.data.data[0].address1,
                      address2: downloadResponse.data.data[0].address2,
                      address3: downloadResponse.data.data[0].address3,
                      city: downloadResponse.data.data[0].city,
                      pincode: downloadResponse.data.data[0].postal_code,
                      mob_no: downloadResponse.data.data[0].phone_no,
                      district: downloadResponse.data.data[0].district_name,
                      state: downloadResponse.data.data[0].state_name,
                      batch_type: downloadResponse.data.data[0].batch_type,
                      admission_dt:
                        downloadResponse.data.data[0].transaction_date !== null
                          ? moment(
                              downloadResponse.data.data[0].transaction_date,
                              "YYYY-MM-DD HH:mm:ss"
                            ).format("DD/MM/YYYY")
                          : "",
                      receipt_no: downloadResponse.data.data[0].receipt_no,
                      balance_amt: downloadResponse.data.data[0].balance_amt,
                      course_name: `${downloadResponse.data.data[0].category_code} - ${downloadResponse.data.data[0].course_name}`,
                    },
                  };

                  const sentPaymentInvoiceResponse = await AxiosInstance.post(
                    `api/all/sentPaymentInvoice`,
                    paydt
                  );

                  if (sentPaymentInvoiceResponse.data[0].status === true) {
                    const updatePdfEmailResponse = await AxiosInstance.post(
                      "api/course/admission/update/pdf_email",
                      {
                        id: userDt.trans_id,
                      }
                    );

                    if (updatePdfEmailResponse.data.status === true) {
                      Info_View(user_iddd);
                    }
                  } else {
                    Info_View(user_iddd);
                  }
                } else {
                  Info_View(user_iddd);
                }
              } else {
                Info_View(user_iddd);
              }
            } else {
              Info_View(user_iddd);
            }
          } else {
            Info_View(user_iddd);
          }
        } else {
          Info_View(user_iddd);
        }
      } else {
        Info_View(user_iddd);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    AxiosInstance.post("api/branch/list")
      .then((res) => {
        // console.log(res,"locations")
        if (res.data.data.length > 0) {
          let locations = res.data.data.map((item, index) => (
            <option key={index} id={item.name} value={item.id}>
              {item.name}
            </option>
          ));
          setLocations(locations);
        } else {
          let locations = <option value="select"> Please select </option>;
          setLocations(locations);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);

  useEffect(() => {
    if (step === 2) {
      // Initialize intl-tel-input on component mount
      const iti = intlTelInput(txtAdPno.current, {
        // Add options as needed, refer to the intl-tel-input documentation
        initialCountry: "in",
        separateDialCode: true,
      });
      // You can listen for changes if needed
      txtAdPno.current.addEventListener("countrychange", () => {
        // console.log('Country changed:', iti.getSelectedCountryData());
        const selectedCountryData = iti.getSelectedCountryData();
        setList((prevFields) => ({
          ...prevFields,
          MobileCode: `+${selectedCountryData.dialCode}`, // Update phone number with the new country code
        }));
      });

      const iti_wha = intlTelInput(txtAdWno.current, {
        // Add options as needed, refer to the intl-tel-input documentation
        initialCountry: "in",
        separateDialCode: true,
      });
      // You can listen for changes if needed
      txtAdWno.current.addEventListener("countrychange", () => {
        // console.log('Country changed:', iti_wha.getSelectedCountryData());
        const selectedCountryData = iti_wha.getSelectedCountryData();
        setList((prevFields) => ({
          ...prevFields,
          WhatsAppNumberCode: `+${selectedCountryData.dialCode}`, // Update phone number with the new country code
        }));
      });

      const iti_whaParent = intlTelInput(txtAdFpo.current, {
        // Add options as needed, refer to the intl-tel-input documentation
        initialCountry: "in",
        separateDialCode: true,
      });
      // You can listen for changes if needed
      txtAdFpo.current.addEventListener("countrychange", () => {
        // console.log('Country changed:', iti_whaParent.getSelectedCountryData());
        const selectedCountryData = iti_whaParent.getSelectedCountryData();
        setList((prevFields) => ({
          ...prevFields,
          ParentMobileNoCode: `+${selectedCountryData.dialCode}`, // Update phone number with the new country code
        }));
      });

      // Clean up on component unmount
      return () => {
        iti.destroy();
        iti_wha.destroy();
        iti_whaParent.destroy();
      };
    }
  }, [step]);

  //date and time convert to normal data
  const dobCon = (userdate) => {
    if (!userdate) {
      return ""; // Handle empty input
    }
    const date = new Date(userdate);
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return ""; // Handle invalid date
    }
    // Extract the year, month, and day components
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const day = String(date.getUTCDate()).padStart(2, "0");
    // Format the date as "YYYY-MM-DD"
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const getOldStudDisocount = (batchId) => {
    // alert(batchId);
    const df = {
      user_id: userid,
      // type: 5,
      batch_id: batchId,
    };
    AxiosInstance.post("api/all/getOldStudDisc", df)
      .then((res) => {
        // console.log(res, "discount batch");
        if (res.data.status === true) {
          let discount = res.data.old_stud_disc;
          // console.log(discount, "discount");
          setDis(discount);
        } else {
          setDis(null); // or set a default value for no discount
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getSpeciOfferDis = (batchId) => {
    const df = {
      user_id: userid,
      type: 5,
      batch_id: batchId,
    };

    // discount_type → 0:stud_enrolled 1:ongoing_batch 2:n_num_stud 3:none
    AxiosInstance.post("api/all/getSpcOfferDisc", df)
      .then((res) => {
        if (res.data.status === true) {
          let SpeciaOffer = res.data.data;
          setOffSpl(SpeciaOffer.offer_perc);
          // 0:stud_enrolled 1:ongoing_batch 2:n_num_stud 3:none
          let speType = 0;
          if (SpeciaOffer.discount_type === 0) {
            speType = 4;
          } else if (SpeciaOffer.discount_type === 1) {
            speType = 1;
          } else if (SpeciaOffer.discount_type === 2) {
            speType = 2;
          } else if (SpeciaOffer.discount_type === 3) {
            speType = 3;
          }
          // 4:stud_enrolled 1:ongoing_batch 2:n_num_stud 3: none 0:Nil

          setOffSplDisplayType(speType);
          // setOffSpl(2); // or set a default value for no discount
        } else {
          setOffSpl(0); // or set a default value for no discount
          setOffSplDisplayType(0);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const res = await AxiosInstance.post("api/all/district", {
          id: 31,
        });

        const districts = (res.data || []).map((d) => ({
          value: d.id,
          label: d.name,
        }));

        setDistrictOptions(districts);
      } catch (err) {
        console.error("District API error", err);
      }
    };

    fetchDistricts();
  }, []);

  useEffect(() => {
    if (!list.category) return;

    const fetchCourses = async () => {
      try {
        const res = await AxiosInstance.get(
          `api/all/getCourses/${list.category}/5`
        );

        const data = res.data.data || [];

        const transformedData = data.reduce((acc, item) => {
          //  FIX: handle null subcategory
          const groupLabel = item.subcategory_code || "Others";

          const option = {
            value: item.id,
            label: item.course_name,
            category_code: item.category_code,
            name: item.name,
            subcategory_code: item.subcategory_code,
          };

          const group = acc.find((g) => g.label === groupLabel);

          if (!group) {
            acc.push({
              label: groupLabel,
              options: [option],
            });
          } else {
            group.options.push(option);
          }

          return acc;
        }, []);

        //  FIX: no filtering out null groups
        const sortedGroups = transformedData.sort((a, b) =>
          a.label.localeCompare(b.label)
        );

        setMockInterviewCourse(sortedGroups);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCourses();
  }, [list.category]);

  // get batch details
  const fetchBatches = async () => {
    try {
      const payload = {
        medium: "",
        class_mode:
          list.modeOfInterview === "0"
            ? "Online"
            : list.modeOfInterview === "1"
            ? "ClassRoom"
            : "",
        location: list.preferredBranchLocation_id
          ? Number(list.preferredBranchLocation_id)
          : "",
        batch_type: "",
        preferred_date: [],
        preferred_dept: [],
        category_course_id: Number(list.courseId),
        passed_exam_name: "",
        district: "",
        subject: "",
        paper_type: list.mockInterviewType === "1" ? 1 : 0,
      };

      const res = await AxiosInstance.post(
        "api/all/getCourseBatchesList/5",
        payload
      );

      const apiBatches = res.data?.data || [];

      if (apiBatches.length > 0) {
        getSpeciOfferDis(apiBatches[0]?.id);
        getOldStudDisocount(apiBatches[0]?.id);
      }

      if (infoBatch && infoBatch?.exam_details?.exam_details) {
        // ---- Build lookup from infoBatch ----
        const infoExamMap = new Map(
          infoBatch.exam_details.exam_details.map((ex) => [
            ex.exam_detail_id,
            Number(ex.is_selected_exam) === 1,
          ])
        );

        const updatedBatches = apiBatches.map((batch) => {
          const exams = Array.isArray(batch.exam_details)
            ? batch.exam_details
            : [];

          let selectedCount = 0;

          const updatedExams = exams.map((exam) => {
            const isSelected = infoExamMap.get(exam.pk) === true;

            if (isSelected) selectedCount++;

            return {
              ...exam,
              is_selected_exam: isSelected,
            };
          });

          const allSelected =
            exams.length > 0 && selectedCount === exams.length;

          return {
            ...batch,
            exam_details: updatedExams,
            is_selected: selectedCount > 0,
            is_selected_all: allSelected,
          };
        });

        setBatchDetails(updatedBatches);
      } else {
        setBatchDetails(apiBatches);
      }
    } catch (err) {
      console.error("fetchBatches err", err);
    }
  };

  useEffect(() => {
    if (step === 4) {
      fetchBatches();
    }
  }, [
    list.courseId,
    list.modeOfInterview,
    list.preferredBranchLocation_id,
    list.mockInterviewType,
    list.category,
    step,
  ]);

  useEffect(() => {
    if (!list.courseId) {
      setBatchDetails([]);
      return;
    }
    fetchBatches();
  }, [
    list.courseId,
    list.modeOfInterview,
    list.preferredBranchLocation_id,
    list.mockInterviewType,
    list.category,
  ]);

  useEffect(() => {
    if (list.CategoryAias) {
      AxiosInstance.get(`api/all/getCourses/${list.CategoryAias}/5`)
        .then((res) => {
          const courseAias = res.data.data.map((item, index) => ({
            value: item.name,
            label: item.name,
          }));
          setCourseAias(courseAias);
        })
        .catch((error) => {
          return error;
        });
    }
  }, [list.CategoryAias]);

  const mockInterviewCourseSorted = mockInterviewCourse
    ?.filter((g) => g && g.label)
    ?.sort((a, b) => a.label.localeCompare(b.label))
    ?.map((group) => ({
      ...group,
      options: group.options.sort((a, b) => a.label.localeCompare(b.label)),
    }));

  const handleChangeCheckbox = (e) => {
    if (e) {
      setList((prev) => ({
        ...prev,
        courseId: e.value,
        courseName: e.label,
        courseSubCate: e.subcategory_code,
      }));

      setListErrors((prev) => ({
        ...prev,
        courseId: "",
      }));
    } else {
      setList((prev) => ({
        ...prev,
        courseId: "",
        courseName: "",
        courseSubCate: "",
      }));

      setListErrors((prev) => ({
        ...prev,
        courseId: "Please select course for respective category",
      }));
    }
  };

  useEffect(() => {
    fetchCoreSubjects();
  }, []);

  const fetchCoreSubjects = async () => {
    try {
      const res = await AxiosInstance.post("/api/all/getCoreSubject");
      const list = res?.data?.data || [];

      const formatted = list.map((item) => ({
        value: item.subject,
        label: item.subject,
        id: item.id,
      }));

      setTagsList(formatted);
    } catch (error) {
      console.error("Error fetching core subjects:", error);
    }
  };

  const handleCreateCoreSubject = async (inputValue) => {
    if (!inputValue?.trim()) return;

    try {
      const payload = {
        subject: inputValue,
        type: 5,
        created_by: userid,
      };

      const res = await AxiosInstance.post("/api/all/coreSubject", payload);

      if (res?.data?.status === true || res?.data) {
        // Option 1 (BEST): Reload dropdown from API
        await fetchCoreSubjects();

        // Set selected value
        const newOption = {
          value: inputValue,
          label: inputValue,
        };

        setList((prev) => ({
          ...prev,
          coreSubject: newOption,
        }));

        setListErrors((prev) => ({
          ...prev,
          coreSubject: "",
        }));
      }
    } catch (error) {
      console.error("Error adding core subject:", error);
    }
  };

  const handlechangeCoreSubject = (selectedOption) => {
    setList((prev) => ({
      ...prev,
      coreSubject: selectedOption,
    }));

    setListErrors((prev) => ({
      ...prev,
      coreSubject: "",
    }));
  };

  useEffect(() => {
    if (stateRefreshs_mock) {
      setStep(1);
    }
  }, [stateRefreshs_mock]);

  //when pincode enter city dropdown , state , district  fill with ui
  useEffect(() => {
    if (list.PincodePresent !== "") {
      AxiosInstance.get(`api/all/getAddress/${list.PincodePresent}`)
        .then((res) => {
          let code = res.data.data;
          const city = code.map((item, index) => ({
            value: item.city,
            label: item.city,
          }));
          setCity(city);
          list.statePresent = code[0].state;
          list.districtPresent = code[0].district;
        })
        .catch((error) => {
          return error;
        });
    }
  }, [list.PincodePresent]);

  useEffect(() => {
    if (list.PincodePermanent !== "") {
      AxiosInstance.get(`api/all/getAddress/${list.PincodePermanent}`)
        .then((res) => {
          let code = res.data.data;
          const city = code.map((item, index) => ({
            value: item.city,
            label: item.city,
          }));
          setCity(city);
          list.statePermanent = code[0].state;
          list.districtPermanent = code[0].district;
        })
        .catch((error) => {
          return error;
        });
    }
  }, [list.PincodePermanent]);
  //when pincode enter city dropdown , state , district  fill with ui -- end

  useEffect(() => {
    if (sslcCerficates[2].UGDegree !== "") {
      const dat = {
        degree_name: sslcCerficates[2].UGDegree,
        type: "UG",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, dat)
        .then((res) => {
          if (res.data.data.length > 0) {
            // in response duplicate entry come means its showing extra data in next api call option
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const majorOptions = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const majorOptions = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            // const additionalOptions = [
            //   { value: "Others", label: "Others" },
            // ];
            // // Append the additional objects to the majorOptions array
            // const updatedMajorOptions = majorOptions.concat(additionalOptions);
            // // Set the state with the updated array
            setMajor(majorOptions);
          } else {
            setMajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[2].UGDegree]);

  useEffect(() => {
    if (sslcCerficates[3].PGDegree !== "") {
      const dats = {
        degree_name: sslcCerficates[3].PGDegree,
        type: "PG",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, dats)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const pgMajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const pgMajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            setPgMajor(pgMajor);
          } else {
            setPgMajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[3].PGDegree]);

  useEffect(() => {
    if (sslcCerficates[4].IPDegree !== "") {
      const datss = {
        degree_name: sslcCerficates[4].IPDegree,
        type: "IPG",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, datss)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const IpMajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const IpMajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            setIpMajor(IpMajor);
          } else {
            setIpMajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[4].IPDegree]);

  useEffect(() => {
    if (sslcCerficates[5].DDegree !== "") {
      const datsss = {
        degree_name: sslcCerficates[5].DDegree,
        type: "diploma",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, datsss)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const dmajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const dmajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            setDmajor(dmajor);
          } else {
            setDmajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[5].DDegree]);

  useEffect(() => {
    if (sslcCerficates[6].PCDegree !== "") {
      const datssss = {
        degree_name: sslcCerficates[6].PCDegree,
        type: "PC",
      };
      AxiosInstance.post(`api/all/getDegreeMajor/`, datssss)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            // const pcMajor = uniqueMajorData.map((item) => (
            //   <option key={item.name} value={item.name}>
            //     {item.name}
            //   </option>
            // ));
            const pcMajor = uniqueMajorData.map((item, index) => ({
              value: item.name,
              label: item.name,
            }));
            setPcmajor(pcMajor);
          } else {
            setPcmajor(
              []
              //   [
              //   <option key="select" disabled value="select">
              //     Please select
              //   </option>,
              // ]
            );
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[6].PCDegree]);

  useEffect(() => {
    if (sslcCerficates[7].OtDegree !== "") {
      AxiosInstance.get(`api/all/getDegreeMajor/${sslcCerficates[7].OtDegree}`)
        .then((res) => {
          if (res.data.data.length > 0) {
            const uniqueMajorData = res.data.data.filter(
              (item, index, self) =>
                self.findIndex((i) => i.name === item.name) === index
            );
            const OtMajor = uniqueMajorData.map((item) => (
              <option key={item.name} value={item.name}>
                {item.name}
              </option>
            ));
            setOTmajor(OtMajor);
          } else {
            setOTmajor([
              <option key="select" disabled value="select">
                Please select
              </option>,
            ]);
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [sslcCerficates[7].OtDegree]);

  //major,designation , department , exam details , degree  dropdown
  useEffect(() => {
    AxiosInstance.get("api/all/getDesignation/2")
      .then((res) => {
        const designation = res.data.data
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item, index) => ({
            value: item.name,
            label: item.name,
          }));
        setDesignation(designation);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDepartment/2")
      .then((res) => {
        const department = res.data.data
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item, index) => ({
            value: item.name,
            label: item.name,
          }));
        setDepartment(department);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.post("api/all/getPreviousExam")
      .then((res) => {
        const previousexam = res.data.data.map((item, index) => (
          // { key: index, value: item.name }
          <option key={item.name} value={item.name}>
            {item.name}
          </option>
        ));
        setPreviousexam(previousexam);

        const examination = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));

        setExamination(examination);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/UG")
      .then((res) => {
        // const ugDegree = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        // setUGDegree(ugDegree);

        const ugDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));

        // const ugDegree = res.data.data.map((item) => item.name);
        setUGDegree(ugDegree);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/PG")
      .then((res) => {
        // const pgDegree = res.data.data.map((item, index) => (
        //   <option key={index} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const pgDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setPGDegree(pgDegree);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/IPG")
      .then((res) => {
        // const ipgDegree = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const ipgDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setIPGDegree(ipgDegree);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/diploma")
      .then((res) => {
        // const diplomaDegree = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const diplomaDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setDiplomaDegree(diplomaDegree);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/all/getDegreeNames/PC")
      .then((res) => {
        // const pcDegree = res.data.data.map((item) => (
        //   <option key={item.name} value={item.name}>
        //     {item.name}
        //   </option>
        // ));
        const pcDegree = res.data.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setPCDegree(pcDegree);
      })
      .catch((error) => {
        return error;
      });
  }, []);

  const handleExamPrev = (e, index) => {
    const { name, value } = e.target;
    setExamDetailsExam((prevDetails) => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index] = { examvalue: value, error_name_exam: "" }; // Update other properties if needed
      return updatedDetails;
    });
  };

  const specialAdmissionHandleChanges = (option, id, spename) => {
    setSpecialAdmissionPre((prevState) => {
      // Check if the name already exists in prevState (excluding current id)
      const isNameExists = prevState.some(
        (q) => q.id !== id && q.name === option.value
      );

      if (isNameExists) {
        alert("Name already exists");
        return prevState; // no update
      }

      // Update the matching ID with new name
      return prevState.map((q) => {
        if (q.id === id) {
          return { ...q, name: option.value, error_name: "" };
        }
        return q;
      });
    });
  };

  //special preference handle change
  const specialAdmissionHandleChange = (e, id, spename) => {
    const { name, value, files, checked } = e.target;
    if (name === "file" && files && files.length > 0) {
      const pref_path = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("pref_path", pref_path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSpecialAdmissionPre((prevState) => {
                return prevState.map((q) => {
                  if (q.id === id) {
                    return {
                      ...q,
                      file: res.data.path,
                      original_pref_path: res.data.originalname,
                    };
                  }

                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          alert("File must be less than 2 mb");
        }
      }
    } else if (name === "path_sslc" && files && files.length > 0) {
      // console.log("sdsf");
      const scp_path_sslc = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("scp_path_sslc", scp_path_sslc);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSpecialAdmissionPre((prevState) => {
                return prevState.map((q) => {
                  if (q.id === id) {
                    return {
                      ...q,
                      path_sslc: res.data.path,
                      original_path_sslc: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          alert("File must be less than 2 mb");
        }
      }
    } else if (name === "path_hsc" && files && files.length > 0) {
      const scp_path_hsc = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("scp_path_hsc", scp_path_hsc);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSpecialAdmissionPre((prevState) => {
                return prevState.map((q) => {
                  if (q.id === id) {
                    return {
                      ...q,
                      path_hsc: res.data.path,
                      original_path_hsc: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          alert("File must be less than 2 mb");
        }
      }
    } else if (name === "path_ug" && files && files.length > 0) {
      const scp_path_ug = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("scp_path_ug", scp_path_ug);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSpecialAdmissionPre((prevState) => {
                return prevState.map((q) => {
                  if (q.id === id) {
                    return {
                      ...q,
                      path_ug: res.data.path,
                      original_path_ug: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          alert("File must be less than 2 mb");
        }
      }
    } else if (name === "path_pg" && files && files.length > 0) {
      const scp_path_pg = files[0];
      if (files[0].type == "application/pdf") {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("scp_path_pg", scp_path_pg);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSpecialAdmissionPre((prevState) => {
                return prevState.map((q) => {
                  if (q.id === id) {
                    return {
                      ...q,
                      path_pg: res.data.path,
                      original_path_pg: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          alert("File must be less than 2 mb");
        }
      }
    } else if (name === "pstm_type") {
      // console.log(value, name , checked);
      if (checked) {
        const psctm = [];
        setSpecialAdmissionPre((prevState) => {
          return prevState.map((q) => {
            if (q.id === id) {
              // console.log(value, "0 type");
              if (value == 0) {
                psctm.push = value;
                // console.log("0 type", psctm);
                return {
                  ...q,
                  [name]: psctm,
                  pstm_type: [0, ...q.pstm_type],
                  error_path_sslc: "",
                };
              } else if (value == 1) {
                if (q.pstm_type.includes(0)) {
                  psctm.push = value;
                  return {
                    ...q,
                    [name]: psctm,
                    pstm_type: [1, ...q.pstm_type],
                    error_path_sslc: "",
                  };
                }
                return {
                  ...q,
                  [name]: psctm,
                  error_path_sslc: "Please select sslc",
                };
              } else if (value == 2) {
                if (q.pstm_type.includes(0, 1)) {
                  psctm.push = value;
                  return {
                    ...q,
                    [name]: psctm,
                    pstm_type: [2, ...q.pstm_type],
                    error_path_sslc: "",
                  };
                }
                return {
                  ...q,
                  [name]: psctm,
                  error_path_sslc: "Please select sslc , hsc",
                };
              } else if (value == 3) {
                // console.log(q.pstm_type,"q.pstm_type");
                const valueTocheck = [0, 1, 2];
                if (
                  valueTocheck.every((values) => q.pstm_type.includes(values))
                ) {
                  psctm.push = value;
                  return {
                    ...q,
                    [name]: psctm,
                    pstm_type: [3, ...q.pstm_type],
                    error_path_sslc: "",
                  };
                }
                return {
                  ...q,
                  [name]: psctm,
                  error_path_sslc: "Please select sslc , hsc , ug",
                };
              }
            }
            return q;
          });
        });
      } else {
        const psctm = [];
        psctm.push = value;
        setSpecialAdmissionPre((prevState) => {
          return prevState.map((q) => {
            if (q.id === id) {
              if (value == 0) {
                return {
                  ...q,
                  [name]: psctm,
                  pstm_type: [],
                };
              } else if (value == 1) {
                return {
                  ...q,
                  [name]: psctm,
                  pstm_type: q.pstm_type.filter(
                    (item) => item !== 2 && item !== 1 && item !== 3
                  ),
                };
              } else if (value == 2) {
                return {
                  ...q,
                  [name]: psctm,
                  pstm_type: q.pstm_type.filter(
                    (item) => item !== 2 && item !== 3
                  ),
                };
              } else {
                return {
                  ...q,
                  [name]: psctm,
                  pstm_type: q.pstm_type.filter(
                    (item) => item !== parseInt(value)
                  ),
                };
              }
            }
            return q;
          });
        });
      }
    } else {
      setSpecialAdmissionPre((prevState) => {
        // Check if name already exists in prevState
        const isNameExists = prevState.some(
          (q) => q.id !== id && q.name === value
        );
        if (isNameExists) {
          alert("Name already exists");
          return prevState;
        }
        // Update the name if it doesn't already exist
        return prevState.map((q) => {
          if (q.id === id) {
            return { ...q, [name]: value };
          }
          return q;
        });
      });
      // setListErrors({
      //   ...listErrors,aaf
      //   ["spc"]:"",
      // });
    }
  };
  //special preference delete function
  const DeleteAdmissionspre = (id, name, spc_id) => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const userid = user.user_id;
        AxiosInstance.post("api/course/admission/delete/scp", {
          user_id: userid,
          name: name,
          id: spc_id,
          type: 5,
        })
          .then((res) => {
            if (res.status === 200) {
              setSpecialAdmissionPre((prevState) =>
                prevState
                  .filter((item) => item.id !== id)
                  .map((item, index) => ({ ...item, id: index + 1 }))
              );

              // Swal.fire({
              //   title: "success",
              //   text: "Deleted Successfully",
              //   icon: "success",
              //   confirmButtonText: "Ok",
              // }).then((result) => {
              //   if (result.isConfirmed) {

              //   }
              // });
            }
            // console.log(res);
          })
          .catch((error) => {
            return error;
          });
      }
    } else {
      console.log("User Id cannot avaliable in session storage");
    }
  };
  //special preference Add function
  const AddPrefrence = () => {
    if (specialPrefrence.length > specialAdmissionPre.length) {
      setSpecialAdmissionPre((prevState) => [
        ...prevState,
        {
          id: prevState.length > 0 ? prevState.length + 1 : 1,
          name: "",
          file: "",
          scp_pk: "",
          path_sslc: "",
          path_hsc: "",
          path_ug: "",
          path_pg: "",
          original_pref_path: null,
          original_path_sslc: null,
          original_path_hsc: null,
          original_path_ug: null,
          original_path_pg: null,
          error_name: "",
          error_path_sslc: "",
          error_path_hsc: "",
          error_path_ug: "",
          error_path_pg: "",
          pstm_type: [],
        },
      ]);
      setListErrors({
        ...listErrors,
        ["SPCcategory"]: "",
      });
    } else {
      if (list.SPCcategory) {
        Swal.fire({
          title: "Warning",
          text: "you reach more Special Preferences",
          icon: "warning",
          confirmButtonText: "Ok",
        });
      } else {
        setListErrors({
          ...listErrors,
          ["SPCcategory"]: "Please select at least one category",
        });
      }
    }
  };
  //dob convert to age function
  const DobCovertAge = (dob) => {
    var ageInYears = moment().diff(dob, "years", false);

    // const dobDate = new Date(dob);
    // const now = new Date();
    // const ageInMs = now - dobDate;
    // const ageInYears = Math.floor(ageInMs / 31536000000); // 1 year ≈ 31536000000 ms

    return ageInYears;
  };
  //handlechange event

  const handleChangeDate = (date, name) => {
    const dateDOB = moment(date).format("YYYY-MM-DD");
    // console.log(name, "name", dateDOB);
    if (name === "DOB") {
      const age = DobCovertAge(date);
      if (age >= 18 && age <= 60) {
        setList({
          ...list,
          [name]: dateDOB,
          ["age"]: age,
        });
        setListErrors({
          ...listErrors,
          [name]: "",
          ["age"]: "",
        });
      } else {
        const err =
          "Please enter a valid date of birth. age should be between 18 and 60 years";
        setList({
          ...list,
          age: "",
        });
        setListErrors({
          ...listErrors,
          DOB: err,
        });
      }
    } else {
      setList({
        ...list,
        [name]: dateDOB,
      });
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    }
  };
  const handleYearChange = (year, dname) => {
    if (dname === "DOB") {
      if (list.DOB !== null && list.DOB !== "") {
        const currentDate = new Date(list.DOB);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        const age = DobCovertAge(currentDate_moment);
        if (age >= 18 && age <= 60) {
          setList({
            ...list,
            ["DOB"]: currentDate_moment,
            ["age"]: age,
          });
          setListErrors({
            ...listErrors,
            ["DOB"]: "",
            ["age"]: "",
          });
        } else {
          const err =
            "Please enter a valid date of birth. age should be between 18 and 60 years";
          setList({
            ...list,
            age: "",
          });
          setListErrors({
            ...listErrors,
            DOB: err,
          });
        }
      }
    } else if (dname === "JoinGovt") {
      if (
        list.JoinGovt !== null &&
        list.JoinGovt !== "" &&
        list.JoinGovt !== undefined
      ) {
        const currentDate = new Date(list.JoinGovt);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        setList({
          ...list,
          ["JoinGovt"]: currentDate_moment,
        });
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        setList({
          ...list,
          ["JoinGovt"]: currentDate_moment,
        });
      }
    }
  };

  const handleMonthChange = (month, dname) => {
    // console.log(month, "month");
    if (dname === "DOB") {
      if (list.DOB !== null && list.DOB !== "") {
        const currentDate = new Date(list.DOB);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        const age = DobCovertAge(currentDate_moment);
        if (age >= 18 && age <= 60) {
          setList({
            ...list,
            ["DOB"]: currentDate_moment,
            ["age"]: age,
          });
          setListErrors({
            ...listErrors,
            ["DOB"]: "",
            ["age"]: "",
          });
        } else {
          const err =
            "Please enter a valid date of birth. age should be between 18 and 60 years";
          setList({
            ...list,
            age: "",
          });
          setListErrors({
            ...listErrors,
            DOB: err,
          });
        }
      }
    } else if (dname === "JoinGovt") {
      if (
        list.JoinGovt !== null &&
        list.JoinGovt !== "" &&
        list.JoinGovt !== undefined
      ) {
        const currentDate = new Date(list.JoinGovt);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        setList({
          ...list,
          ["JoinGovt"]: currentDate_moment,
        });
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const currentDate_moment = moment(currentDate).format("YYYY-MM-DD");
        setList({
          ...list,
          ["JoinGovt"]: currentDate_moment,
        });
      }
    }
  };

  const validateFieldsPayment = (data) => {
    const errors = {};
    if (!data.PPayment) {
      errors.PPayment = "please select Payment Type";
    } else if (!data.PPaymentMode) {
      errors.PPaymentMode = "please select Payment Mode";
    }
    validateFieldsPaymentF(data);
    return errors;
  };

  const validateFieldsPaymentF = (data) => {
    if (!data.PPayment) {
      txtAdPPayment.current.focus();
    } else if (!data.PPaymentMode) {
      txtAdPPaymentMode.current.focus();
    }
  };

  //technical qualification add function
  const AddQualification = () => {
    if (technicalOption.length > techQualification.length) {
      setTechQualification((prevState) => [
        ...prevState,
        {
          id: 0,
          name: "",
          level: "",
          lang: "",
          Cnum: "",
          grade: "",
          year: "",
          file: "",
          error_name: "",
          edu_medium: "",
          error_certificate_no: "",
          error_year_of_passing: "",
          error_level: "",
          error_grade: "",
          error_certificate_path: "",
          original_file_path: "",
        },
      ]);
    } else {
      Swal.fire({
        title: "Warning",
        text: "you reach more Technical Qualification",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }
  };

  const setMaxMonthYearTec = (value) => {
    // console.log(value);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Month is zero-based

    // Format the current month and year as "yyyy-MM"
    const maxMonthYear = `${currentYear}-${currentMonth
      .toString()
      .padStart(2, "0")}`;
    // Parse the provided value into a JavaScript Date object
    const selectedDate = new Date(value);

    if (selectedDate > currentDate) {
      alert("Year of passing should be in past");
    } else {
      // Return the value because it's not in the future
      return value;
    }
  };

  //technical qualification delete function
  const DeleteQual = (id, name) => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const userid = user.user_id;
        AxiosInstance.post("api/course/admission/delete/qualifications", {
          user_id: userid,
          name: name,
          qualification_type: "THQ",
          id: id,
        })
          .then((res) => {
            if (res.status === 200) {
              const val = techQualification
                .filter((item) => item.id !== id)
                .map((item, index) => ({ ...item, id: index + 1 }));
              setTechQualification(val);
            }
          })
          .catch((error) => {
            return error;
          });
      }
    } else {
      console.log("User Id cannot avaliable in session storage");
    }
  };

  const TechhandleChanges = (option, id, index) => {
    setTechQualification((prevState) => {
      const isNameExists = prevState.some(
        (q, i) =>
          (id !== 0 ? q.id !== id : i !== index) && q.name === option.value
      );

      return prevState.map((q, i) => {
        const match = id !== 0 ? q.id === id : i === index;

        if (match) {
          if (isNameExists) {
            return { ...q, name: "", error_name: "Name Already exist" };
          } else {
            return { ...q, name: option.value, error_name: "" };
          }
        }

        return q;
      });
    });
  };

  const TechhandleChange_date = (date, id, name, index) => {
    const dateEYD = moment(date).format("YYYY-MM");

    if (setMaxMonthYearTec(dateEYD)) {
      setTechQualification((prevState) => {
        return prevState.map((q, i) => {
          if (id === 0) {
            return i === index
              ? { ...q, [name]: dateEYD, error_year_of_passing: "" }
              : q;
          } else {
            return q.id === id
              ? { ...q, [name]: dateEYD, error_year_of_passing: "" }
              : q;
          }
        });
      });
    }
  };

  //technical qualification handle change  function
  const TechhandleChange = (e, id, index) => {
    const { name, value, files } = e.target;

    const updateState = (updatedFields) => {
      setTechQualification((prevState) => {
        return prevState.map((q, i) => {
          if (id === 0) {
            return i === index ? { ...q, ...updatedFields } : q;
          } else {
            return q.id === id ? { ...q, ...updatedFields } : q;
          }
        });
      });
    };

    if (name === "file" && files && files.length > 0) {
      const TQ_path = files[0];
      const validTypes = [
        "image/png",
        "image/jpg",
        "image/jpeg",
        "application/pdf",
      ];

      if (validTypes.includes(files[0].type)) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("TQ_path", TQ_path);

          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              updateState({
                file: res.data.path,
                original_file_path: res.data.originalname,
              });
            })
            .catch((error) => {
              Swal.fire({
                title: "Warning",
                text: error.message || "Upload failed",
                icon: "warning",
                confirmButtonText: "Ok",
              });
            });
        } else {
          alert("File must be less than 2MB");
        }
      }
    } else if (name === "year") {
      if (setMaxMonthYearTec(value)) {
        updateState({ [name]: value, error_year_of_passing: "" });
      }
    } else if (name === "Cnum") {
      if (!/^[A-Za-z0-9]*$/.test(value)) {
        alert("Certificate number can only contain letters and numbers");
      } else {
        updateState({ [name]: value, error_certificate_no: "" });
      }
    } else if (name === "grade") {
      updateState({ [name]: value, error_grade: "" });
    } else if (name === "level") {
      updateState({ [name]: value, error_level: "" });
    } else if (name === "lang") {
      updateState({ [name]: value, error_edu_medium: "" });
    } else {
      updateState({ [name]: value });
    }
  };

  //handlebar function
  const handleblur = (event) => {
    const { name, value } = event.target;

    setList({
      ...list,
      [name]: value,
    });
  };
  //educational checkbox handlechange
  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    const checked = event.target.checked;

    if (checked) {
      setEducationQualification([...educationQualification, value]);
      setListErrors({
        ...listErrors,
        EducationQualification: "",
      });
    } else {
      // alert("uncheck");
      const userJSON = sessionStorage.getItem("userDetails");
      if (userJSON) {
        const user = JSON.parse(userJSON);
        if (user && user.user_id) {
          const userid = user.user_id;
          AxiosInstance.post("api/course/admission/delete/qualifications", {
            user_id: userid,
            name: value,
            qualification_type: "EDQ",
          })
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                setEducationQualification(
                  educationQualification.filter((item) => item !== value)
                );
                // Swal.fire({
                //   title: 'Success',
                //   text: "Deleted successfully",
                //   icon: 'success',
                //   confirmButtonText: 'Ok'
                // }).then((result) => {
                //   if (result.isConfirmed) {

                //   }
                // });
              }
            })
            .catch((error) => {
              return error;
            });
        }
      } else {
        console.log("User Id cannot avaliable in session storage");
      }
    }
  };

  const handleStepPrevious = (count) => {
    if (step == 7) {
      Info_View(userid);
      setStep(1);
    } else {
      setStep(count);
    }
  };
  const setMaxMonthYear = (value, names) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Month is zero-based

    // Format the current month and year as "yyyy-MM"
    const maxMonthYear = `${currentYear}-${currentMonth
      .toString()
      .padStart(2, "0")}`;

    // Parse the provided value into a JavaScript Date object
    const selectedDate = new Date(value);

    if (selectedDate > currentDate) {
      setListErrors({
        ...listErrors,
        [names]: "Year of passing should be in past",
      });
    } else {
      // Return the value because it's not in the future
      return value;
    }
  };
  const handleEdus = (option, name, dname) => {
    if (name === "Integrated PG") {
      setUgOption((prevState) => ({
        ...prevState,
        ["Integrated_PG"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["IPMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else if (name === "Professional Courses") {
      setUgOption((prevState) => ({
        ...prevState,
        ["Professional_Courses"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["PCMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else if (name === "UG") {
      setUgOption((prevState) => ({
        ...prevState,
        ["UG"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["UGMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else if (name === "PG") {
      setUgOption((prevState) => ({
        ...prevState,
        ["PG"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["PGMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else if (name === "Diploma") {
      setUgOption((prevState) => ({
        ...prevState,
        ["Diploma"]: option,
      }));
      setMOption((prevState) => ({
        ...prevState,
        ["DMajor"]: "",
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    } else {
      setUgOption((prevState) => ({
        ...prevState,
        [name]: option,
      }));
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === name) {
            return { ...q, [dname]: option.value };
          }
          return q;
        });
      });
    }
    setListErrors({
      ...listErrors,
      [dname]: "",
    });
  };
  const handleEduMajor = (option, name, dname) => {
    if (option.label === "Others" && name === "UG" && dname === "UGMajor") {
      setUGIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "UG" &&
      dname === "UGMajor"
    ) {
      setUGIsOther(false);
    } else if (
      option.label === "Others" &&
      name === "PG" &&
      dname === "PGMajor"
    ) {
      setPGIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "PG" &&
      dname === "PGMajor"
    ) {
      setPGIsOther(false);
    } else if (
      option.label === "Others" &&
      name === "Integrated PG" &&
      dname === "IPMajor"
    ) {
      setIPGIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "Integrated PG" &&
      dname === "IPMajor"
    ) {
      setIPGIsOther(false);
    } else if (
      option.label === "Others" &&
      name === "Diploma" &&
      dname === "DMajor"
    ) {
      setDipIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "Diploma" &&
      dname === "DMajor"
    ) {
      setDipIsOther(false);
    } else if (
      option.label === "Others" &&
      name === "Professional Courses" &&
      dname === "PCMajor"
    ) {
      setPCIsOther(true);
    } else if (
      option.label !== "Others" &&
      name === "Professional Courses" &&
      dname === "PCMajor"
    ) {
      setPCIsOther(false);
    }
    setMOption((prevState) => ({
      ...prevState,
      [dname]: option,
    }));
    setSslcCerficates((prevState) => {
      return prevState.map((q) => {
        if (q.name === name) {
          return { ...q, [dname]: option.value };
        }
        return q;
      });
    });
    setListErrors({
      ...listErrors,
      [dname]: "",
    });
  };

  const handleSelectMulti = (option, name, dname) => {
    if (name === "CourseCate") {
      setList((prevState) => ({
        ...prevState,
        ["CourseCate"]: option.value,
        ["CouresName"]: option.course_name,
      }));
      setDropDown((prevState) => ({
        ...prevState,
        [dname]: option,
      }));
      setListErrors({
        ...listErrors,
        [dname]: "",
      });
    } else if (name === "AppCast") {
      if (option) {
        const selectedApp = option.map((zx) => ({
          label: zx.label,
          value: zx.value,
        }));
        const Hio = selectedApp.find((el) => el.label === "Nil");
        if (Hio) {
          setAppCategoryOption([]);
          const Hiso = selectedApp.filter((el) => el.label === "Nil");
          setAppCastLable(Hiso);
        } else {
          setAppCastLable(selectedApp);
        }

        setListErrors({
          ...listErrors,
          [dname]: "",
        });
      } else {
        setAppCastLable([]);
      }
    } else {
      setList((prevState) => ({
        ...prevState,
        [dname]: option.value,
      }));
      setDropDown((prevState) => ({
        ...prevState,
        [dname]: option,
      }));
    }
    setListErrors({
      ...listErrors,
      [dname]: "",
    });
  };

  const handleSelectCH = (option, dname) => {
    // console.log(option,dname);
    setList((prevState) => ({
      ...prevState,
      [dname]: option.value,
    }));
    setListErrors({
      ...listErrors,
      [dname]: "",
    });
  };

  // all date format should handle function
  const handleChangeCuDate = (dates, name) => {
    const dateSam = moment(dates).format("YYYY-MM-DD");
    // console.log(name, "name", dateSam);
    if (name === "JoinGovt") {
      setList((prevState) => ({
        ...prevState,
        [name]: dateSam,
      }));
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    }
  };
  const handleEYDate = (dates, name, dname) => {
    const dateEYD = moment(dates).format("YYYY-MM");
    // console.log(name, "name", dname, dateEYD);
    if (setMaxMonthYear(dateEYD, name)) {
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === dname) {
            return { ...q, [name]: dateEYD };
          }
          return q;
        });
      });
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    } else {
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === dname) {
            return { ...q, [name]: "" };
          }
          return q;
        });
      });
    }
  };

  const handleYearChange_month = (year, dname) => {
    if (dname === "SSLC_Year") {
      if (
        sslcCerficates[0].SSLC_Year !== null &&
        sslcCerficates[0].SSLC_Year !== "" &&
        sslcCerficates[0].SSLC_Year !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[0].SSLC_Year);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "sslc") {
                return { ...q, ["SSLC_Year"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["SSLC_Year"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "sslc") {
                return { ...q, ["SSLC_Year"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "sslc") {
              return { ...q, ["SSLC_Year"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["SSLC_Year"]: "",
        });
      }
    } else if (dname === "HSC_Year") {
      if (
        sslcCerficates[1].HSC_Year !== null &&
        sslcCerficates[1].HSC_Year !== "" &&
        sslcCerficates[1].HSC_Year !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[1].HSC_Year);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "hsc") {
                return { ...q, ["HSC_Year"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["HSC_Year"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "hsc") {
                return { ...q, ["HSC_Year"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "hsc") {
              return { ...q, ["HSC_Year"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["HSC_Year"]: "",
        });
      }
    } else if (dname === "UGYearpassing") {
      if (
        sslcCerficates[2].UGYearpassing !== null &&
        sslcCerficates[2].UGYearpassing !== "" &&
        sslcCerficates[2].UGYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[2].UGYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "UG") {
                return { ...q, ["UGYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["UGYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "UG") {
                return { ...q, ["UGYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "UG") {
              return { ...q, ["UGYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["UGYearpassing"]: "",
        });
      }
    } else if (dname === "PGYearpassing") {
      if (
        sslcCerficates[3].PGYearpassing !== null &&
        sslcCerficates[3].PGYearpassing !== "" &&
        sslcCerficates[3].PGYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[3].PGYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "PG") {
                return { ...q, ["PGYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["PGYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "PG") {
                return { ...q, ["PGYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "PG") {
              return { ...q, ["PGYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["PGYearpassing"]: "",
        });
      }
    } else if (dname === "IPYearpassing") {
      if (
        sslcCerficates[4].IPYearpassing !== null &&
        sslcCerficates[4].IPYearpassing !== "" &&
        sslcCerficates[4].IPYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[4].IPYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Integrated PG") {
                return { ...q, ["IPYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["IPYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Integrated PG") {
                return { ...q, ["IPYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Integrated PG") {
              return { ...q, ["IPYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["IPYearpassing"]: "",
        });
      }
    } else if (dname === "DYearpassing") {
      if (
        sslcCerficates[5].DYearpassing !== null &&
        sslcCerficates[5].DYearpassing !== "" &&
        sslcCerficates[5].DYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[5].DYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Diploma") {
                return { ...q, ["DYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["DYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Diploma") {
                return { ...q, ["DYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Diploma") {
              return { ...q, ["DYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["DYearpassing"]: "",
        });
      }
    } else if (dname === "PCYearpassing") {
      if (
        sslcCerficates[6].PCYearpassing !== null &&
        sslcCerficates[6].PCYearpassing !== "" &&
        sslcCerficates[6].PCYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[6].PCYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Professional Courses") {
                return { ...q, ["PCYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["PCYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Professional Courses") {
                return { ...q, ["PCYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Professional Courses") {
              return { ...q, ["PCYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["PCYearpassing"]: "",
        });
      }
    } else if (dname === "OtYearpassing") {
      if (
        sslcCerficates[7].OtYearpassing !== null &&
        sslcCerficates[7].OtYearpassing !== "" &&
        sslcCerficates[7].OtYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[7].OtYearpassing);
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Others") {
                return { ...q, ["OtYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["OtYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Others") {
                return { ...q, ["OtYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        const newYear = year;
        currentDate.setFullYear(newYear);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Others") {
              return { ...q, ["OtYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["OtYearpassing"]: "",
        });
      }
    }
  };

  const handleMonthChange_month = (month, dname) => {
    if (dname === "SSLC_Year") {
      if (
        sslcCerficates[0].SSLC_Year !== null &&
        sslcCerficates[0].SSLC_Year !== "" &&
        sslcCerficates[0].SSLC_Year !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[0].SSLC_Year);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "sslc") {
                return { ...q, ["SSLC_Year"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["SSLC_Year"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "sslc") {
                return { ...q, ["SSLC_Year"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "sslc") {
              return { ...q, ["SSLC_Year"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["SSLC_Year"]: "",
        });
      }
    } else if (dname === "HSC_Year") {
      if (
        sslcCerficates[1].HSC_Year !== null &&
        sslcCerficates[1].HSC_Year !== "" &&
        sslcCerficates[1].HSC_Year !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[1].HSC_Year);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "hsc") {
                return { ...q, ["HSC_Year"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["HSC_Year"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "hsc") {
                return { ...q, ["HSC_Year"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "hsc") {
              return { ...q, ["HSC_Year"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["HSC_Year"]: "",
        });
      }
    } else if (dname === "UGYearpassing") {
      if (
        sslcCerficates[2].UGYearpassing !== null &&
        sslcCerficates[2].UGYearpassing !== "" &&
        sslcCerficates[2].UGYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[2].UGYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "UG") {
                return { ...q, ["UGYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["UGYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "UG") {
                return { ...q, ["UGYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "UG") {
              return { ...q, ["UGYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["UGYearpassing"]: "",
        });
      }
    } else if (dname === "PGYearpassing") {
      if (
        sslcCerficates[3].PGYearpassing !== null &&
        sslcCerficates[3].PGYearpassing !== "" &&
        sslcCerficates[3].PGYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[3].PGYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "PG") {
                return { ...q, ["PGYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["PGYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "PG") {
                return { ...q, ["PGYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "PG") {
              return { ...q, ["PGYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["PGYearpassing"]: "",
        });
      }
    } else if (dname === "IPYearpassing") {
      if (
        sslcCerficates[4].IPYearpassing !== null &&
        sslcCerficates[4].IPYearpassing !== "" &&
        sslcCerficates[4].IPYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[4].IPYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Integrated PG") {
                return { ...q, ["IPYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["IPYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Integrated PG") {
                return { ...q, ["IPYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Integrated PG") {
              return { ...q, ["IPYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["IPYearpassing"]: "",
        });
      }
    } else if (dname === "DYearpassing") {
      if (
        sslcCerficates[5].DYearpassing !== null &&
        sslcCerficates[5].DYearpassing !== "" &&
        sslcCerficates[5].DYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[5].DYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Diploma") {
                return { ...q, ["DYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["DYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Diploma") {
                return { ...q, ["DYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Diploma") {
              return { ...q, ["DYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["DYearpassing"]: "",
        });
      }
    } else if (dname === "PCYearpassing") {
      if (
        sslcCerficates[6].PCYearpassing !== null &&
        sslcCerficates[6].PCYearpassing !== "" &&
        sslcCerficates[6].PCYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[6].PCYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Professional Courses") {
                return { ...q, ["PCYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["PCYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Professional Courses") {
                return { ...q, ["PCYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Professional Courses") {
              return { ...q, ["PCYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["PCYearpassing"]: "",
        });
      }
    } else if (dname === "OtYearpassing") {
      if (
        sslcCerficates[7].OtYearpassing !== null &&
        sslcCerficates[7].OtYearpassing !== "" &&
        sslcCerficates[7].OtYearpassing !== undefined
      ) {
        const currentDate = new Date(sslcCerficates[7].OtYearpassing);
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        // console.log(dateEYDa,"dateEYDa");
        if (setMaxMonthYear(dateEYDa, dname)) {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Others") {
                return { ...q, ["OtYearpassing"]: dateEYDa };
              }
              return q;
            });
          });
          setListErrors({
            ...listErrors,
            ["OtYearpassing"]: "",
          });
        } else {
          setSslcCerficates((prevState) => {
            return prevState.map((q) => {
              if (q.name === "Others") {
                return { ...q, ["OtYearpassing"]: "" };
              }
              return q;
            });
          });
        }
      } else {
        const currentDate = new Date();
        let monthNumber = moment(month, "MMMM").month();
        currentDate.setMonth(monthNumber);
        const dateEYDa = moment(currentDate).format("YYYY-MM");
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === "Others") {
              return { ...q, ["OtYearpassing"]: dateEYDa };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          ["OtYearpassing"]: "",
        });
      }
    }
  };

  // education cerficate handle change
  const handleEdu = (eduname, event) => {
    const names = event.target.name;
    const value = event.target.value;
    const files = event.target.files;

    if (names === "SSLC_Path" && files && files.length > 0) {
      const SSLC_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("SSLC_Path", SSLC_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            SSLC_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            SSLC_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          SSLC_Path: err,
        });
      }
    } else if (names === "HSC_Path" && files && files.length > 0) {
      const HSC_Path = files[0];

      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("HSC_Path", HSC_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            HSC_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            HSC_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          HSC_Path: err,
        });
      }
    } else if (names === "UG_Path" && files && files.length > 0) {
      const UG_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("UG_Path", UG_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            UG_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            UG_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          UG_Path: err,
        });
      }
    } else if (names === "PG_Path" && files && files.length > 0) {
      const PG_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("PG_Path", PG_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            PG_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            PG_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          PG_Path: err,
        });
      }
    } else if (names === "IP_Path" && files && files.length > 0) {
      const IP_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("IP_Path", IP_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            IP_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            IP_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          IP_Path: err,
        });
      }
    } else if (names === "PC_Path" && files && files.length > 0) {
      const PC_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("PC_Path", PC_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            PC_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            PC_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          PC_Path: err,
        });
      }
    } else if (names === "D_Path" && files && files.length > 0) {
      const D_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("D_Path", D_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            D_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            D_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          D_Path: err,
        });
      }
    } else if (names === "Ot_Path" && files && files.length > 0) {
      const Ot_Path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg" ||
        files[0].type == "application/pdf"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("Ot_Path", Ot_Path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setSslcCerficates((prevState) => {
                return prevState.map((q) => {
                  if (q.name === eduname) {
                    return {
                      ...q,
                      [names]: res.data.path,
                      original_file_path: res.data.originalname,
                    };
                  }
                  return q;
                });
              });
            })
            .catch((error) => {
              return error;
            });
          setListErrors({
            ...listErrors,
            Ot_Path: "",
          });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            Ot_Path: err,
          });
        }
      } else {
        let err = "PDF files only allowed";
        setListErrors({
          ...listErrors,
          Ot_Path: err,
        });
      }
    } else if (names === "PG") {
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === eduname) {
            return { ...q, [names]: value };
          }
          return q;
        });
      });
      setListErrors({
        ...listErrors,
        [names]: "",
      });
    } else if (names === "SSLC_Marks") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "HSC_Marks") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "PGMarksPercentage") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "UGMarksPercentage") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "IPMarksPercentage") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "DMarksPercentage") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "PCMarksPercentage") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (names === "OtMarksPercentage") {
      if (Number(value) < 45 || Number(value) == 0) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45%",
        });
      } else if (Number(value) > 100) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: "" };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "Marks Percentage should be above 45% and less than 100%",
        });
      } else {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else if (
      names === "SSLC_Year" ||
      names === "HSC_Year" ||
      names === "UGYearpassing" ||
      names === "PGYearpassing" ||
      names === "IPYearpassing" ||
      names === "DYearpassing" ||
      names === "PCYearpassing" ||
      names === "OtYearpassing"
    ) {
      if (setMaxMonthYear(value, names)) {
        setSslcCerficates((prevState) => {
          return prevState.map((q) => {
            if (q.name === eduname) {
              return { ...q, [names]: value };
            }
            return q;
          });
        });
        setListErrors({
          ...listErrors,
          [names]: "",
        });
      }
    } else {
      setSslcCerficates((prevState) => {
        return prevState.map((q) => {
          if (q.name === eduname) {
            return { ...q, [names]: value };
          }
          return q;
        });
      });
      setListErrors({
        ...listErrors,
        [names]: "",
      });
    }
  };

  const handlePreDates = (selected) => {
    const selectedPrsss = selected.map((option) => ({
      label: option.label,
      value: option.value,
    }));
    setSelectedPreDate(selectedPrsss);
    setListErrors({
      ...listErrors,
      PreDates_mock: "",
    });
  };
  const handleStepOne = () => {
    setStep(1);
  };
  //handlechange function
  const handleChange = (event) => {
    const { name, value, files, checked } = event.target;
    if (name === "DOB") {
      DobCovertAge(value);
      setList({
        ...list,
        [name]: value,
      });
    } else if (name === "PincodePresent") {
      if (/^[1-9][0-9]{5}$/.test(value) || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["PincodePresent"]: "",
        });
        // Proceed with other fields or actions if needed
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["PincodePresent"]: "Please Enter valid Pincode",
        });
        return;
      }
    } else if (name === "PincodePermanent") {
      if (/^[1-9][0-9]{5}$/.test(value) || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["PincodePermanent"]: "",
        });
        // Proceed with other fields or actions if needed
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["PincodePermanent"]: "Please Enter valid Pincode",
        });
        return;
      }
    } else if (name === "Mobile") {
      if (value.length === 10 || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["Mobile"]: "",
        });
        // Proceed with other fields or actions if needed
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["Mobile"]: "Please Enter valid 10 digit number",
        });
        return;
      }
    } else if (name === "WhatsAppNumber") {
      if (value.length === 10 || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["WhatsAppNumber"]: "",
        });
        // Proceed with other fields or actions if needed
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["WhatsAppNumber"]: "Please Enter valid 10 digit number",
        });
        return;
      }
    } else if (name === "ParentMobileNo") {
      if (value.length === 10 || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["ParentMobileNo"]: "",
        });
        // Proceed with other fields or actions if needed
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["ParentMobileNo"]: "Please Enter valid 10 digit number",
        });
        return;
      }
    } else if (name == "aadharNo") {
      if (value.length === 12 || value.length === 0) {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["aadharNo"]: "",
        });
        // Proceed with other fields or actions if needed
      } else {
        setList((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setListErrors({
          ...listErrors,
          ["aadharNo"]: "Please Enter valid 12 digit number",
        });
        return;
      }
    } else if (name == "ContactNumber") {
      if (checked) {
        setList((prevList) => ({
          ...prevList,
          [name]: checked,
        }));
        setListErrors({
          ...listErrors,
          ["WhatsAppNumber"]: "",
        });
      } else {
        setList((prevList) => ({
          ...prevList,
          ["WhatsAppNumber"]: "",
          [name]: checked,
        }));
        setListErrors({
          ...listErrors,
          ["WhatsAppNumber"]: "",
        });
      }
    } else if (name == "location") {
      setList((prevList) => ({
        ...prevList,
        [name]: value,
      }));
      setListErrors({
        ...listErrors,
        location: "",
      });
      const selectedId = event.target.options[event.target.selectedIndex].id;
      setList((prevList) => ({
        ...prevList,
        location_name: selectedId,
      }));
    } else if (name == "preferredBranchLocation") {
      setList((prevList) => ({
        ...prevList,
        preferredBranchLocation_id: value,
      }));
      setListErrors({
        ...listErrors,
        preferredBranchLocation: "",
      });
      const selectedId = event.target.options[event.target.selectedIndex].id;

      setList((prevList) => ({
        ...prevList,
        preferredBranchLocation: selectedId,
      }));
    } else if (name === "modeOfInterview") {
      setList((prevList) => ({
        ...prevList,
        modeOfInterview: value, // "0" or "1"
      }));

      setListErrors({
        ...listErrors,
        modeOfInterview: "",
      });
    } else if (name == "SamePresentAddress") {
      setList((prevList) => ({
        ...prevList,
        [name]: checked,
      }));
      setListErrors({
        ...listErrors,
        ["SamePresentAddress"]: "",
        ["BuildingNumberPermanent"]: "",
        ["StreetNamePermanent"]: "",
        ["AreaPermanent"]: "",
        ["LandmarkPermanent"]: "",
        ["districtPermanent"]: "",
        ["CityPermanent"]: "",
        ["statePermanent"]: "",
        ["PostPermanent"]: "",
        ["TalukPermanent"]: "",
        ["PincodePermanent"]: "",
      });
    } else if (name === "Profilephoto" && files && files.length > 0) {
      const profile_path = files[0];
      if (
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 40 * 1024) {
          const formData = new FormData();
          formData.append("profile_path", profile_path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setList({
                ...list,
                Profilephoto: res.data.path,
                original_profile_path: res.data.originalname,
              });
              setListErrors({
                ...listErrors,
                Profilephoto: "",
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 40KB.";
          setListErrors({
            ...listErrors,
            Profilephoto: err,
          });
        }
      } else {
        let err = "(Png , jpg ,jpeg )images only allowed";
        setListErrors({
          ...listErrors,
          Profilephoto: err,
        });
      }
    } else if (name === "aadharCardphoto" && files && files.length > 0) {
      const aadhar_path = files[0];
      if (
        files[0].type == "application/pdf" ||
        files[0].type == "image/png" ||
        files[0].type == "image/jpg" ||
        files[0].type == "image/jpeg"
      ) {
        if (files[0].size < 2 * 1024 * 1024) {
          const formData = new FormData();
          formData.append("aadhar_path", aadhar_path);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setList({
                ...list,
                aadharCardphoto: res.data.path,
                original_aadhar_path: res.data.originalname,
              });
              setListErrors({
                ...listErrors,
                aadharCardphoto: "",
              });
            })
            .catch((error) => {
              return error;
            });
        } else {
          let err = "File size must be less than 2MB.";
          setListErrors({
            ...listErrors,
            aadharCardphoto: err,
          });
        }
      } else {
        let err = "PDF, PNG, JPG, and JPEG files only allowed"; //  Correct message
        setListErrors({
          ...listErrors,
          aadharCardphoto: err,
        });
      }
    } else if (name === "CastFile" && files && files.length > 0) {
      const file = files[0];
      // allowed file types
      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
      ];

      // max size = 2MB
      const maxSize = 2 * 1024 * 1024;

      if (!allowedTypes.includes(file.type)) {
        setListErrors({
          ...listErrors,
          CastFile: "PDF, PNG, JPG, and JPEG files only allowed",
        });
        return;
      }

      if (file.size > maxSize) {
        setListErrors({
          ...listErrors,
          CastFile: "File size must be less than 2MB",
        });
        return;
      }

      const formData = new FormData();
      formData.append("community_path", file);

      AxiosInstance.post("api/upload/", formData)
        .then((res) => {
          setList({
            ...list,
            CastFile: res.data.path,
            original_caste_path: res.data.originalname,
          });

          setListErrors({
            ...listErrors,
            CastFile: "",
          });
        })
        .catch((error) => {
          console.error("Upload error", error);
        });
    } else if (name === "category") {
      setBatchDetails([]);
      setList({
        ...list,
        [name]: value,
        courseId: "",
        courseName: "",
        courseSubCate: "",
      });

      setListErrors({
        ...listErrors,
        category: "",
      });
    } else if (name === "SPCcategory") {
      setList({
        ...list,
        [name]: value,
        ["category"]: value,
        ["CourseCate"]: "",
        ["CouresName"]: "",
        ["CourseSubCate"]: "",
      });

      // setSubjectselect([]);
      // setSelectedSub([]);
      setSpecialAdmissionPre((prevState) => {
        return prevState.map((q) => {
          return { ...q, ["name"]: "" };
        });
      });
      setBatchDetails([]);
      setListErrors({
        ...listErrors,
        SPCcategory: "",
      });
    } else if (name === "ExamDetailsRes") {
      const selectedOptions = Array.from(
        event.target.selectedOptions,
        (option) => option.value
      );
      setList((prevList) => ({ ...prevList, ExamDetailsRes: selectedOptions }));
      setListErrors({
        ...listErrors,
        ExamDetailsRes: "",
      });
    } else if (name === "IDPhoto" && files && files.length > 0) {
      const ID_photo_Path = files[0];
      if (files[0].type == "application/pdf") {
        const formData = new FormData();
        formData.append("ID_photo_Path", ID_photo_Path);
        AxiosInstance.post("api/upload/", formData)
          .then((res) => {
            setList({
              ...list,
              IDPhoto: res.data.path,
              original_aiasa_id_path: res.data.originalname,
            });
            setListErrors({
              ...listErrors,
              IDPhoto: "",
            });
          })
          .catch((error) => {
            return error;
          });
      } else if (
        files[0].type == "application/pdf" &&
        files[0].size > 2 * 1024 * 1024
      ) {
        let err = "File size must be less than 2MB.";
        setListErrors({
          ...listErrors,
          CastFile: err,
        });
      } else {
        let err = "pdf files only allowed";
        setListErrors({
          ...listErrors,
          IDPhoto: err,
        });
      }
    } else if (name == "Verify") {
      setList((prevList) => ({
        ...prevList,
        [name]: checked,
      }));
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    } else if (name == "CouponCode") {
      setCouponApplied((prevState) => ({
        ...prevState,
        status: false,
        amount: 0,
        coupon_code: value,
      }));
      setMessage("");
    } else if (name === "ExamWrite") {
      setList({
        ...list,
        [name]: value,
      });
      setExamDetailsExam([]);
      const examdetails_bb = Array.from({ length: value }, (_, index) => ({
        id: index,
        examvalue: "",
        error_name_exam: "", // Add other properties you need in the state
      }));
      setExamDetailsExam(examdetails_bb);
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    } else if (name === "ExamPreviously") {
      if (value === "NO") {
        setList({
          ...list,
          [name]: value,
          ExamWrite: "",
        });
        setExamDetailsExam([]);
        setListErrors({
          ...listErrors,
          [name]: "",
        });
      } else {
        setList({
          ...list,
          [name]: value,
        });
        setExamDetailsExam([]);
        setListErrors({
          ...listErrors,
          [name]: "",
        });
      }
    } else {
      setList({
        ...list,
        [name]: value,
      });
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    }
  };

  //handle Coupon code
  const handleCouponCode = async (e, batchAmount, batchId) => {
    e.preventDefault();

    const code = couponApplied?.coupon_code?.trim();

    // ---- Validation ----
    if (!code) {
      setListErrors({ coupon_code: "Please enter a coupon code" });
      return;
    }

    if (!batchAmount || batchAmount <= 0) {
      setListErrors({ coupon_code: "Invalid batch amount" });
      return;
    }

    setListErrors({});
    setMessage("");

    try {
      const res = await AxiosInstance.post("api/all/getCoupon", {
        user_id: userid,
        coupon_code: code,
      });

      // ---- Normalize response (array | object) ----
      const response = Array.isArray(res.data) ? res.data[0] : res.data;

      if (response?.status === true) {
        const discount = Number(response?.data?.dis_amt || 0);

        if (discount >= batchAmount) {
          setCouponApplied({
            status: false,
            amount: 0,
            coupon_code: code,
          });

          setListErrors({
            coupon_code:
              "The coupon discount exceeds the payable amount and cannot be applied",
          });

          return;
        }

        // ---- SUCCESS ----
        setCouponApplied({
          status: true,
          amount: discount,
          coupon_code: code,
          coupon_id: response.data.id,
          batch_id: batchId,
        });

        setMessage("Coupon code applied successfully");
      } else {
        throw new Error(response?.message || "Invalid coupon code");
      }
    } catch (error) {
      setCouponApplied({
        status: false,
        amount: 0,
        coupon_code: "",
      });

      setMessage(error.message || "Please enter a valid coupon code");
    }
  };

  //dropdown api call
  useEffect(() => {
    // get response from api to fill dropdowns

    AxiosInstance.get("api/codevalues?codetype=EDQ")
      .then((res) => {
        const educationOptions = res.data.map((item) => (
          <option key={item.name} value={item.name}>
            {item.name}
          </option>
        ));
        setEducationOptions(educationOptions);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=CLASS_EDQ")
      .then((res) => {
        const classOptions = res.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setClassOption(classOptions);
      })
      .catch((error) => {
        return error;
      });
    AxiosInstance.get("api/codevalues?codetype=THQ")
      .then((res) => {
        const technicalOption = res.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        // Sort the options alphabetically, ignoring "Nil"
        const sortedOptions = technicalOption
          .filter((item) => item.value !== "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        const NilOption = technicalOption
          .filter((item) => item.value === "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        // Set the sorted list to the state
        sortedOptions.push(...NilOption);
        setTechnicalOption(sortedOptions);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=CTGY")
      .then((res) => {
        const categoryOption = res.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));

        const sortedOptions = categoryOption
          .filter((item) => item.value !== "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        const NilOption = categoryOption
          .filter((item) => item.value === "Nil")
          .sort((a, b) => a.value.localeCompare(b.value));
        // Set the sorted list to the state
        sortedOptions.push(...NilOption);
        setCategoryOption(sortedOptions);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=CURS")
      .then((res) => {
        const cOption = res.data.map((item, index) => ({
          value: item.name,
          label: item.name,
        }));
        setCOption(cOption);
        setCatOption(res.data);
      })
      .catch((error) => {
        return error;
      });

    AxiosInstance.get("api/codevalues?codetype=MDP")
      .then((res) => {
        const teachMedium = res.data.map((item) => (
          <option key={item.name} value={item.name}>
            {item.name}
          </option>
        ));
        setTeachMedium(teachMedium);
      })
      .catch((error) => {
        return error;
      });
    // AxiosInstance.get("api/all/district/31")
    //   .then((res) => {
    //     const district = res.data.map((item) => (
    //       <option key={item.name} value={item.name}>
    //         {item.name}
    //       </option>
    //     ));
    //     setDistrict(district);
    //   })
    //   .catch((error) => {
    //     return error;
    //   });
  }, []);

  useEffect(() => {
    if (list.SPCcategory !== "") {
      let ValueAsp = "";
      if (list.SPCcategory === "UPSC") {
        ValueAsp = "UPSC_ASP";
      } else if (list.SPCcategory === "TNPSC") {
        ValueAsp = "TNPSC_ASP";
      } else if (list.SPCcategory === "TRB") {
        ValueAsp = "TRB_ASP";
      } else if (list.SPCcategory === "TET") {
        ValueAsp = "TET_ASP";
      } else if (list.SPCcategory === "TNUSRB") {
        ValueAsp = "TNUSRB_ASP";
      } else if (list.SPCcategory === "SSC") {
        ValueAsp = "SSC_ASP";
      } else if (list.SPCcategory === "Banking") {
        ValueAsp = "Banking_ASP";
      } else if (list.SPCcategory === "Others") {
        ValueAsp = "OTHERS_ASP";
      } else if (list.SPCcategory === "RRB") {
        ValueAsp = "RRB_ASP";
      }

      AxiosInstance.get(`api/codevalues?codetype=${ValueAsp}`)
        .then((res) => {
          const specialPrefrence = res.data.map((item, index) => ({
            value: item.name,
            label: item.name,
          }));
          // Sort the options alphabetically, ignoring "Nil"
          const sortedOptions = specialPrefrence
            .filter((item) => item.value !== "Nil")
            .sort((a, b) => a.value.localeCompare(b.value));
          const NilOption = specialPrefrence
            .filter((item) => item.value === "Nil")
            .sort((a, b) => a.value.localeCompare(b.value));
          // Set the sorted list to the state
          sortedOptions.push(...NilOption);
          setSpecialPrefrence(sortedOptions);
        })
        .catch((error) => {
          return error;
        });
    }
  }, [list.SPCcategory]);

  const toggleBatchSelect = (batchIndex, batchId) => {
    setBatchDetails((prev) => {
      const next = prev.map((b, i) => {
        if (i !== batchIndex) return b;
        const willSelect = !b.is_selected_all;
        const exam_details = (b.exam_details || []).map((ed) => ({
          ...ed,
          is_selected_exam: willSelect,
        }));
        return {
          ...b,
          is_selected: willSelect,
          is_selected_all: willSelect,
          exam_details,
        };
      });
      const allSelected =
        next.length > 0 && next.every((b) => b.is_selected_all === true);
      setSelectAll(allSelected);
      return next;
    });
    getSpeciOfferDis(batchId);
    getOldStudDisocount(batchId);
  };

  // toggle single exam selection and update parent batch state
  const toggleExamSelection = (batchIndex, examPk, batchId) => {
    setBatchDetails((prev) => {
      const next = prev.map((b, i) => {
        if (i !== batchIndex) return b;

        // Block individual selection if paper_type === 1
        if (b.paper_type === 1) return b;

        const exam_details = (b.exam_details || []).map((ed) =>
          ed.pk === examPk
            ? { ...ed, is_selected_exam: !ed.is_selected_exam }
            : ed
        );

        const is_selected_all =
          exam_details.length > 0 &&
          exam_details.every((ed) => ed.is_selected_exam);

        const is_selected_any = exam_details.some((ed) => ed.is_selected_exam);

        return {
          ...b,
          exam_details,
          is_selected_all,
          is_selected: is_selected_any,
        };
      });

      const allSelected =
        next.length > 0 && next.every((b) => b.is_selected_all === true);

      setSelectAll(allSelected);
      return next;
    });
    getSpeciOfferDis(batchId);
    getOldStudDisocount(batchId);
  };

  //step handle prev button click
  const handlePrevious = () => {
    setStep(step - 1);
  };

  useEffect(() => {
    const adId = admissionID?.adId;
    if (!adId || adId === 0 || adId === "undefined") return;
    callInfoView(adId);
  }, [admissionID?.adId]);

  const callInfoView = async (admissionId) => {
    if (!admissionId || admissionId === 0 || admissionId === "undefined") {
      return false;
    }
    try {
      const res = await AxiosInstance.post(
        `api/modelexam/info_view/${admissionId}/5`
      );

      if (res?.data?.status !== true) return false;

      const data = res.data.data;
      const courses = data?.Courses || {};
      const batchDetails = courses?.batch_details || {};

      //  MAP API RESPONSE → STATE
      setList((prev) => ({
        ...prev,

        // Step-4 / Step-5 fields
        place_birth: courses.place_birth ?? "",
        district: batchDetails.district ? String(batchDetails.district) : "",
        district_name: batchDetails.district_name ?? "",
        location: res.data.data?.Courses?.location || "",
        mediumStudied: courses.medium_studied ?? "",
        govtExamName: courses.government_exam_name ?? "",
        govtExamRegisternumber: courses.govt_reg_no ?? "",
        coreSubject: courses.core_subject
          ? { value: courses.core_subject, label: courses.core_subject }
          : null,

        modeOfInterview: courses.interview_type === 1 ? "0" : "1",
      }));

      return true;
    } catch (err) {
      console.error("info_view API error", err);
      return false;
    }
  };

  const handleSubmit = (
    batchId,
    oldstudentAmount,
    damount,
    AmountPay,
    cname,
    cId,
    GstMts
  ) => {
    // const userJSON = sessionStorage.getItem("userDetails");
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const Amoup = Number(AmountPay).toFixed(2);
        const GstMt = Number(GstMts).toFixed(2);
        const errorss = validateFieldsPayment(list);
        if (Object.keys(errorss).length === 0) {
          setStepperButton(true);
          const userid = user.user_id;

          const CouresAmount = Number(Amoup);
          const CouresName = cname;
          const gstrate = 18;
          const discountAmount = damount;
          const batch_id = batchId;
          const Course_id = cId;
          const receipt = "Order_" + userid;
          // console.log(CouresAmount,"CouresAmountCouresAmountCouresAmount1")
          if (CouresAmount > 0) {
            // console.log(CouresAmount,"CouresAmountCouresAmountCouresAmount2" , (CouresAmount * 100).toFixed(2))
            const VHFix = (CouresAmount * 100).toFixed(2);
            AxiosInstance.post("api/payemnt/create_order", {
              amount: Number(VHFix),
              currency: "INR",
              receipt: receipt,
            })
              .then((res) => {
                // console.log(isPaymentLoading ,"isPaymentLoading11")
                // setIsPaymentLoading(true);
                if (res.data.status) {
                  const { data } = res;
                  let payment_status = "";

                  if (data.status === "failed") {
                    payment_status = 0;
                  } else if (data.status === "created") {
                    payment_status = 1;
                  } else if (data.status === "authenticated") {
                    payment_status = 2;
                  } else if (data.status === "authorized") {
                    payment_status = 3;
                  } else if (data.status === "captured") {
                    payment_status = 4;
                  } else if (data.status === "refunded") {
                    payment_status = 5;
                  }
                  setIsPaymentLoading(true);
                  const dat = {
                    step: 6,
                    type: 5,
                    category: list.category ? list.category : "",
                    location_id: list.preferredBranchLocation_id,
                    subject: [],
                    SpecialOffer: Number(offSpl) > 0 ? offSpl : 0.0,
                    spc_offer_type: offSplDisplayType,
                    Isverify: list.Verify || false,
                    // AdmissionID: admissionID.adId ? admissionID.adId : 0,
                    AdmissionID:
                      admissionID?.adId && Number(admissionID.adId) > 0
                        ? Number(admissionID.adId)
                        : null,
                    // coures_id
                    CouresName: CouresName,
                    discountAmount: discountAmount,
                    gst: gstrate,
                    batch_id: batch_id,
                    coures_id: Course_id,
                    user_id: userid,
                    old_stud_disc_perc: dis,
                    old_stud_disc: oldstudentAmount,
                    iscoupon: couponApplied.status === true ? true : false,
                    couponAmount:
                      couponApplied.amount !== "" ? couponApplied.amount : 0,
                    couponcode: couponApplied.coupon_code,
                    Netamount: data.amount / 100,
                    status: payment_status,
                    transaction_id: "",
                    razorpay_order_id: data.id,
                    razorpay_signature: "",
                    created_at: moment
                      .unix(data.created_at)
                      .format("YYYY-MM-DD HH:mm:ss"),
                    partial_payment: 0,
                    old_stud_disc_applied: 0,
                    tot_amt: data.amount / 100,
                    gst_amt: Number(GstMt),
                    payment_type: list.PPaymentMode
                      ? list.PPaymentMode === "0"
                        ? 0
                        : 1
                      : null,
                  };

                  AxiosInstance.post("api/course/admission/register", dat)
                    .then((res) => {
                      if (res.data.status === true) {
                        setIsPaymentLoading(false);
                        const options = {
                          key: PaymentSKey,
                          amount: res.data.data.Netamount,
                          currency: "INR",
                          name: CouresName,
                          prefill: {
                            name:
                              list.FirstName != null && list.FirstName !== ""
                                ? list.FirstName
                                : "Anna iasa",
                            email:
                              list.emailaddress !== null &&
                              list.emailaddress !== ""
                                ? list.emailaddress
                                : "sample@annaiasacademy.com",
                            contact:
                              list.Mobile != null && list.Mobile !== ""
                                ? list.Mobile
                                : "1234567890",
                          },
                          description: `For ModelExam Admission  - ${batch_id}`,
                          image: "B",
                          order_id: res.data.data.razorpay_order_id,
                          handler: function (response) {
                            if (response) {
                              setIsPaymentLoading(true);

                              const dats = {
                                id: res.data.data.id,
                                step: 7,
                                SpecialOffer: Number(offSpl) > 0 ? offSpl : 0.0,
                                spc_offer_type: offSplDisplayType,
                                subject: [],
                                type: 5,
                                category: list.category ? list.category : "",
                                location_id: list.preferredBranchLocation_id,
                                Isverify: list.Verify || false,
                                AdmissionID: admissionID.adId
                                  ? admissionID.adId
                                  : 0,
                                CouresName: CouresName,
                                discountAmount: discountAmount,
                                gst: gstrate,
                                batch_id: batch_id,
                                coures_id: Course_id,
                                user_id: userid,
                                old_stud_disc_perc: dis,
                                old_stud_disc: oldstudentAmount,
                                iscoupon:
                                  couponApplied.status === true ? true : false,
                                couponAmount:
                                  couponApplied.amount !== ""
                                    ? couponApplied.amount
                                    : 0,
                                couponcode: couponApplied.coupon_code,
                                Netamount: res.data.data.Netamount,
                                status: res.data.data.status,
                                transaction_id: response.razorpay_payment_id,
                                razorpay_order_id: response.razorpay_order_id,
                                razorpay_signature: response.razorpay_signature,
                                created_at: res.data.data.created_at,
                                partial_payment: 0,
                                old_stud_disc_applied: 0,
                                tot_amt: res.data.data.Netamount,
                                gst_amt: Number(GstMt),
                                payment_type: list.PPaymentMode
                                  ? list.PPaymentMode === "0"
                                    ? 0
                                    : 1
                                  : null,
                                created_by: userid,
                                updated_by: userid,
                                installment_type: [1, 2, 3],
                              };

                              AxiosInstance.post(
                                "api/course/admission/register",
                                dats
                              )
                                .then((res) => {
                                  // console.log(res);
                                  if (res.data.status === true) {
                                    const message = res.data.data.batch_message;
                                    setBatchMessage([message]);
                                    setStep(step + 1);
                                    setStepperButton(false);
                                    setIsPaymentLoading(false);
                                  } else {
                                    setIsPaymentLoading(false);
                                    setStepperButton(false);
                                  }
                                })
                                .catch((error) => {
                                  setIsPaymentLoading(false);
                                  setStepperButton(false);
                                  return error;
                                });
                            } else {
                              setIsPaymentLoading(false);
                              setStepperButton(false);
                            }
                          },
                          modal: {
                            ondismiss: function () {
                              // Triggered when the Razorpay modal is closed by the user
                              navigate("/TransactionHistory/1"); // book tab for payment pending
                            },
                          },
                        };
                        setStepperButton(false);
                        const rzp1 = new window.Razorpay(options);
                        rzp1.open();
                      } else {
                        setIsPaymentLoading(false);
                        Swal.fire({
                          title: "Warning",
                          text: res.data.message,
                          icon: "Warning",
                          confirmButtonText: "Ok",
                        }).then((result) => {
                          if (
                            res.data.data &&
                            res.data.data.req_data &&
                            res.data.data &&
                            res.data.data.req_data.id
                          ) {
                            setIsPaymentLoading(true);

                            const dats = {
                              id:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.req_data.id
                                  : "",
                              step: 7,
                              SpecialOffer: Number(offSpl) > 0 ? offSpl : 0.0,
                              spc_offer_type: offSplDisplayType,
                              location_id: list.preferredBranchLocation_id,
                              category: list.category ? list.category : "",
                              subject: [], //send  if subject having only
                              type: 5,
                              Isverify: list.Verify || false,
                              AdmissionID: admissionID.adId
                                ? admissionID.adId
                                : 0,
                              CouresName: CouresName,
                              discountAmount: discountAmount,
                              gst: gstrate,
                              batch_id: batch_id,
                              coures_id: Course_id,
                              user_id: userid,
                              old_stud_disc_perc: dis,
                              old_stud_disc: oldstudentAmount,
                              iscoupon:
                                couponApplied.status === true ? true : false,
                              couponAmount:
                                couponApplied.amount !== ""
                                  ? couponApplied.amount
                                  : 0,
                              couponcode: couponApplied.coupon_code,
                              Netamount:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.rpay_data.trans_amount
                                  : "",
                              status:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.rpay_data.transaction_status
                                  : "",
                              transaction_id:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.rpay_data.transaction_id
                                  : "",
                              razorpay_order_id:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.rpay_data.transaction_order_id
                                  : "",
                              razorpay_signature:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.req_data.razorpay_signature
                                  : "",
                              created_at:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.req_data.created_at
                                  : "",
                              partial_payment: 0,
                              old_stud_disc_applied:
                                list.PPayment === "1" ? 0 : 1,
                              tot_amt:
                                res.data.data && res.data.data.req_data
                                  ? res.data.data.rpay_data.trans_amount
                                  : "",
                              gst_amt: Number(GstMt),
                              payment_type: list.PPaymentMode
                                ? list.PPaymentMode === "0"
                                  ? 0
                                  : 1
                                : null,
                              created_by: userid,
                              updated_by: userid,
                              installment_type: [1, 2, 3],
                            };
                            AxiosInstance.post(
                              "api/course/admission/register",
                              dats
                            )
                              .then((res) => {
                                if (res.data.status === true) {
                                  setStepperButton(false);
                                  const message = res.data.data.batch_message;
                                  setBatchMessage([message]);
                                  setStep(step + 1);
                                  setStepperButton(false);
                                  setIsPaymentLoading(false);
                                } else {
                                  setIsPaymentLoading(false);
                                  setStepperButton(false);
                                }
                              })
                              .catch((error) => {
                                setStepperButton(false);
                                setIsPaymentLoading(false);
                                return error;
                              });
                          } else {
                            // Swal.fire({
                            //   title: "Warning",
                            //   text: res.data.message,
                            //   icon: "Warning",
                            //   confirmButtonText: "Ok",
                            // });
                            setStep(1);
                            // callInfoView();
                            setStepperButton(false);
                            setIsPaymentLoading(false);
                          }
                        });
                      }
                    })
                    .catch((error) => {
                      // console.log(error);
                      Swal.fire({
                        title: "Warning",
                        text: error,
                        icon: "Warning",
                        confirmButtonText: "Ok",
                      });
                      setStepperButton(false);
                      setIsPaymentLoading(false);
                      return error;
                    });
                } else {
                  Swal.fire({
                    title: "Warning",
                    text: res.data.message,
                    icon: "Warning",
                    confirmButtonText: "Ok",
                  });
                  setStepperButton(false);
                  setIsPaymentLoading(false);
                }
              })
              .catch((error) => {
                Swal.fire({
                  title: "Warning",
                  text: error,
                  icon: "Warning",
                  confirmButtonText: "Ok",
                });
                setStepperButton(false);
                setIsPaymentLoading(false);
                return error;
              });
            // .finally(() => {
            //   console.log(isPaymentLoading ,"isPaymentLoading22")
            //   setIsPaymentLoading(false)
            // } )
          } else {
            Swal.fire({
              title: "Warning",
              text: "Your fee should be a minimum of 1 rupee. Kindly reach out to the administrator for assistance with this matter.",
              icon: "Warning",
              confirmButtonText: "Ok",
            });
            setStepperButton(false);
          }
        } else {
          setStepperButton(false);
          setListErrors(errorss);
        }
      }
    } else {
      console.log("User Id cannot available in session storage");
    }
  };

  const handleSubmitCash = (
    batchId,
    oldstudentAmount,
    damount,
    AmountPay,
    cname,
    cId,
    GstMts
  ) => {
    // const userJSON = sessionStorage.getItem("userDetails");
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const Amouto = Number(AmountPay).toFixed(2);
        const GstMt = Number(GstMts).toFixed(2);
        const errorss = validateFieldsPayment(list);
        if (Object.keys(errorss).length === 0) {
          const userid = user.user_id;
          const CouresAmount = Number(Amouto);
          const CouresName = cname;
          const gstrate = 18;
          // const soffer = specialoffer;
          const discountAmount = damount;
          const coures_id = cId;
          const batch_id = batchId;
          // const receipt = "Order_" + Math.floor(Math.random() * 900 + 100);
          const receipt = "Order_" + userid;

          if (CouresAmount > 0) {
            setIsPaymentLoading(true);
            const dat = {
              step: 6,
              type: 4,
              category: list.category ? list.category : "",
              location_id: list.preferredBranchLocation_id,
              subject: [],
              SpecialOffer: Number(offSpl) > 0 ? offSpl : 0.0,
              spc_offer_type: offSplDisplayType,
              Isverify: list.Verify || false,
              AdmissionID: admissionID.adId ? admissionID.adId : 0,
              CouresName: CouresName,
              discountAmount: discountAmount,
              gst: gstrate,
              batch_id: batch_id,
              coures_id: coures_id,
              user_id: userid,
              old_stud_disc_perc: dis,
              old_stud_disc: oldstudentAmount,
              iscoupon: couponApplied.status === true ? true : false,
              couponAmount:
                couponApplied.amount !== "" ? couponApplied.amount : 0,
              couponcode: couponApplied.coupon_code,
              Netamount: CouresAmount,
              status: 1,
              transaction_id: "",
              razorpay_order_id: "",
              razorpay_signature: "",
              created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
              partial_payment: 0,
              old_stud_disc_applied: 0,
              tot_amt: parseInt(CouresAmount),
              gst_amt: Number(GstMt),
              payment_type: list.PPaymentMode
                ? list.PPaymentMode === "0"
                  ? 0
                  : 1
                : null,
            };

            AxiosInstance.post("api/course/admission/register", dat)
              .then((res) => {
                if (res.data.status === true) {
                  const message = res.data.data.Batch_msg;
                  setBatchMessage([message]);
                  setStep(step + 1);
                  setIsPaymentLoading(false);
                } else {
                  Swal.fire({
                    title: "Warning",
                    text: res.data.message,
                    icon: "Warning",
                    confirmButtonText: "Ok",
                  });
                  setStep(1);
                  callInfoView();
                  setIsPaymentLoading(false);
                }
              })
              .catch((error) => {
                Swal.fire({
                  title: "Warning",
                  text: error,
                  icon: "Warning",
                  confirmButtonText: "Ok",
                });
                setIsPaymentLoading(false);
                return error;
              });
          } else {
            Swal.fire({
              title: "Warning",
              text: "Your fee should be a minimum of 1 rupee. Kindly reach out to the administrator for assistance with this matter.",
              icon: "Warning",
              confirmButtonText: "Ok",
            });
          }
        } else {
          setListErrors(errorss);
        }
      }
    } else {
      console.log("User Id cannot avaliable in session storage");
    }
  };

  //step handle next button click
  const handleNext = () => {
    const userJSON = sessionStorage.getItem("userDetails");
    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        const userid = user.user_id;

        const AdmissionRef_validation = {
          firstName: txtAdFname,
          AppCast: txtAppSpeCat,
          lastName: txtAdLname,
          age: txtAdAge,
          mdob: txtAdMDob,
          mStatus: txtAdMStatus,
          gender: txtAdGender,
          father: txtAdFath,
          mother: txtAdMoth,
          pSize: txtAdPSize,
          ano: txtAdAno,
          apath: txtAdApath,
          cno: txtAdCno,
          cpath: txtAdCpath,
          pno: txtAdPno,
          wno: txtAdWno,
          fpo: txtAdFpo,
          email: txtAdEmail,
          SPCcategory: txtAdSpc,
          phno: txtAdPhno,
          psname: txtAdPsname,
          parea: txtAdParea,
          pland: txtAdPland,
          ppost: txtAdPpost,
          ptaluk: txtAdPtaluk,
          ppincode: txtAdPpincode,
          pcity: txtAdPcity,
          pstate: txtAdPstate,
          pdistrict: txtAdPdistrict,
          perhno: txtAdPerhno,
          persname: txtAdPersname,
          perarea: txtAdPerarea,
          perland: txtAdPerland,
          pererpost: txtAdPererpost,
          pertaluk: txtAdPertaluk,
          perpincode: txtAdPerpincode,
          percity: txtAdPercity,
          perstate: txtAdPerstate,
          perdistrict: txtAdPerdistrict,
          education: txtAdEduc,
          eduSCer: txtAdSslc,
          eduSpass: txtAdSpass,
          eduSmarks: txtAdSmarks,
          eduSboard: txtAdSboard,
          eduSschool: txtAdSschool,
          eduSins: txtAdSins,
          eduSfile: txtAdSfile,
          eduHCer: txtAdHslc,
          eduHpass: txtAdHpass,
          eduHmarks: txtAdHmarks,
          eduHboard: txtAdHboard,
          eduHschool: txtAdHschool,
          eduHins: txtAdHins,
          eduHfile: txtAdHfile,
          eduUCer: txtAdUCer,
          eduUpass: txtAdUpass,
          eduUmarks: txtAdUmarks,
          eduUdeg: txtAdUdeg,
          eduUMaj: txtAdUMaj,
          eduUMajOther: txtAdUMajOther,
          eduPMajOther: txtAdPMajOther,
          eduIMajOther: txtAdIMajOther,
          eduDMajOther: txtAdDMajOther,
          eduCMajOther: txtAdCMajOther,
          eduUclass: txtAdUclass,
          eduUins: txtAdUins,
          eduUfile: txtAdUfile,
          eduPCer: txtAdPCer,
          eduPpass: txtAdPpass,
          eduPmarks: txtAdPmarks,
          eduPdeg: txtAdPdeg,
          eduPMaj: txtAdPMaj,
          eduPclass: txtAdPclass,
          eduPins: txtAdPins,
          eduPfile: txtAdPfile,
          eduICer: txtAdICer,
          eduIpass: txtAdIpass,
          eduImarks: txtAdImarks,
          eduIdeg: txtAdIdeg,
          eduIMaj: txtAdIMaj,
          eduIclass: txtAdIclass,
          eduIins: txtAdIins,
          eduIfile: txtAdIfile,
          eduDCer: txtAdDCer,
          eduDpass: txtAdDpass,
          eduDmarks: txtAdDmarks,
          eduDdeg: txtAdDdeg,
          eduDMaj: txtAdDMaj,
          eduDclass: txtAdDclass,
          eduDins: txtAdDins,
          eduDfile: txtAdDfile,
          eduCCer: txtAdCCer,
          eduCpass: txtAdCpass,
          eduCmarks: txtAdCmarks,
          eduCdeg: txtAdCdeg,
          eduCMaj: txtAdCMaj,
          eduCclass: txtAdCclass,
          eduCins: txtAdCins,
          eduCfile: txtAdCfile,
          eduOCer: txtAdOCer,
          eduOpass: txtAdOpass,
          eduOmarks: txtAdOmarks,
          eduOdeg: txtAdOdeg,
          eduOMaj: txtAdOMaj,
          eduOclass: txtAdOclass,
          eduOins: txtAdOins,
          eduOfile: txtAdOfile,
          category: txtAdCate,
          examPassed: txtAdExamPassed,
          examRegno: txtAdExamRegno,
          location: txtAdLoca,
          batchDetails: txtbatchDet,
          examdetail: txtAdEdetail,
          examclear: txtAdEclear,
          designation: txtAdDesg,
          department: txtAdDep,
          departJoin: txtAdDjoin,
          aiasayear: txtAdayear,
          aiasacate: txtAdacate,
          aiasacourse: txtAdacourse,
          aiasaIdnum: txtAdaIdnum,
          aiasafile: txtAdafile,
          govtInterDate: txtAdGovtInteDate,
          prefrDateMock: txtAdPDates,
          course: txtAdCourse,
          // STEP 4
          courseName: refCourseName,
          coreSubject: refCoreSubject,
          mediumStudied: refMediumStudied,
          govtExamName: refGovtExamName,
          govtExamRegisternumber: refGovtExamRegisternumber,
          preferredBranchLocation: refPreferredBranchLocation,
          place_birth: placeBirthRef,
          district_name: districtRef,
        };

        const errors = validateFields_mock(
          list,
          sslcCerficates,
          educationQualification,
          step,
          AdmissionRef_validation,
          batchDetails,
          selectedPrev,
          selectedPreDate,
          specialAdmissionPre,
          setSpecialAdmissionPre,
          techQualification,
          setTechQualification,
          appCastLable
        );
        console.log("errors", errors);
        if (Object.keys(errors).length === 0) {
          if (step === 1) {
            let SP = appCastLable.map((item) => item.value);
            const SteponeData = {
              user_id: userid,
              step: 1,
              id: admissionID.adId ? admissionID.adId : 0,
              type: 5,
              first_name: list.FirstName,
              last_name: list.LastName,
              father_name: list.Fathername,
              mother_name: list.MotherName,
              dob: list.DOB,
              age: list.age,
              gender: list.gender,
              marital_status: list.MaritalStatus,
              profile_path: list.Profilephoto,
              aadhar_no: list.aadharNo,
              original_aadhar_path: list.original_aadhar_path,
              original_profile_path: list.original_profile_path,
              aadhar_path: list.aadharCardphoto,
              community_name: list.Cast, // name
              community_path: list.CastFile, // path
              original_caste_path: list.original_caste_path, // file name
              scp: SP,
              tech_qualification: [{ id: 5281, name: "", level: "", lang: "" }],
              created_by: userid,
            };

            AxiosInstance.post("api/course/admission/register", SteponeData)
              .then((res) => {
                if (res.data.status === true) {
                  setStep(step + 1);
                  sessionStorage.removeItem("stateRefreshs_mock");

                  setScp_stt(true);
                } else {
                  Swal.fire({
                    title: "warning",
                    text: res.data.message,
                    icon: "warning",
                    confirmButtonText: "Ok",
                  });
                  setScp_stt(false);
                }
              })
              .catch((error) => {
                return error;
              });
          } else if (step === 2) {
            const address = [
              {
                address1: list.BuildingNumberPresent,
                address2: list.StreetNamePresent,
                address3: list.AreaPresent,
                landmark: list.LandmarkPresent,
                post_name: list.PostPresent,
                taluk: list.TalukPresent,
                postal_code: list.PincodePresent ? list.PincodePresent : 0,
                city: list.CityPresent,
                district_name: list.districtPresent,
                state_name: list.statePresent,
                same_address: list.SamePresentAddress == true ? "0" : "1",
                address_type: "1",
              },
              {
                address1:
                  list.SamePresentAddress == true
                    ? list.BuildingNumberPresent
                    : list.BuildingNumberPermanent,
                address2:
                  list.SamePresentAddress == true
                    ? list.StreetNamePresent
                    : list.StreetNamePermanent,
                address3:
                  list.SamePresentAddress == true
                    ? list.AreaPresent
                    : list.AreaPermanent,
                landmark:
                  list.SamePresentAddress == true
                    ? list.LandmarkPresent
                    : list.LandmarkPermanent,
                post_name:
                  list.SamePresentAddress == true
                    ? list.PostPresent
                    : list.PostPermanent,
                taluk:
                  list.SamePresentAddress == true
                    ? list.TalukPresent
                    : list.TalukPermanent,
                postal_code:
                  list.SamePresentAddress == true
                    ? list.PincodePresent
                      ? list.PincodePresent
                      : 0
                    : list.PincodePermanent
                    ? list.PincodePermanent
                    : 0,
                city:
                  list.SamePresentAddress == true
                    ? list.CityPresent
                    : list.CityPermanent,
                district_name:
                  list.SamePresentAddress == true
                    ? list.districtPresent
                    : list.districtPermanent,
                state_name:
                  list.SamePresentAddress == true
                    ? list.statePresent
                    : list.statePermanent,
                same_address: list.SamePresentAddress == true ? "0" : "1",
                address_type: "2",
              },
            ];

            const StepTwoData = {
              user_id: userid,
              step: 2,
              phone_no: list.Mobile,
              country_code: list.MobileCode,
              whatsapp_no:
                list.ContactNumber === true
                  ? list.Mobile
                  : list.WhatsAppNumber
                  ? list.WhatsAppNumber
                  : null,
              contact_type: list.ContactNumber === true ? "1" : "0",
              parent_mob_no: list.ParentMobileNo ? list.ParentMobileNo : null,
              email: list.emailaddress,
              address: address,
            };

            // console.log(StepTwoData);
            AxiosInstance.post("api/course/admission/register", StepTwoData)
              .then((res) => {
                if (res.data.status === true) {
                  setStep(step + 1);
                  sessionStorage.removeItem("stateRefreshs_mock");
                } else {
                  Swal.fire({
                    title: "warning",
                    text: res.data.message,
                    icon: "warning",
                    confirmButtonText: "Ok",
                  });
                }
              })
              .catch((error) => {
                return error;
              });
          } else if (step === 3) {
            const errors_thq = validateThq(
              techQualification,
              setTechQualification
            );
            if (
              errors_thq.length > 0 &&
              errors_thq.every(
                (el) =>
                  el.error_name === "" &&
                  el.error_certificate_no === "" &&
                  el.error_year_of_passing === "" &&
                  el.error_level === "" &&
                  el.error_grade === ""
              )
            ) {
              const filteredDetails = sslcCerficates.filter((detail) => {
                let cert = "";
                if (detail.name === "sslc") {
                  cert = detail.name.toUpperCase();
                } else if (detail.name === "hsc") {
                  cert = detail.name.toUpperCase();
                } else {
                  cert = detail.name;
                }
                if (detail.name === "UG") {
                  detail.UGMajor =
                    uGisOther === true ? detail.UGMajor_Other : detail.UGMajor;
                  detail.type_of_degree = uGisOther === true ? 1 : 0;
                } else if (detail.name === "PG") {
                  detail.PGMajor =
                    pGisOther === true ? detail.PGMajor_Other : detail.PGMajor;
                  detail.type_of_degree = pGisOther === true ? 1 : 0;
                } else if (detail.name === "Integrated PG") {
                  detail.IPMajor =
                    iPGisOther === true ? detail.IPMajor_Other : detail.IPMajor;
                  detail.type_of_degree = iPGisOther === true ? 1 : 0;
                } else if (detail.name === "Diploma") {
                  detail.DMajor =
                    dipisOther === true ? detail.DMajor_Other : detail.DMajor;
                  detail.type_of_degree = dipisOther === true ? 1 : 0;
                } else if (detail.name === "Professional Courses") {
                  detail.PCMajor =
                    pCisOther === true ? detail.PCMajor_Other : detail.PCMajor;
                  detail.type_of_degree = pCisOther === true ? 1 : 0;
                } else if (detail.name === "Others") {
                  detail.type_of_degree = 1;
                }
                return educationQualification.includes(cert);
              });

              const TQ = techQualification.map((item) => ({
                id: item.id,
                name: item.name,
                level:
                  item.name !== "Knowledge in computer"
                    ? item.level
                    : item.level,
                lang: item.lang,
                Cnum: item.Cnum,
                kdg_in_com:
                  item.name === "Knowledge in computer" ? item.level : "",
                grade: item.grade,
                year: item.year,
                file: item.file,
                original_file_path:
                  item.original_file_path !== null &&
                  item.original_file_path !== "null"
                    ? item.original_file_path
                    : null,
                type_of_degree: 0,
              }));
              const StepThreeData = {
                user_id: userid,
                step: 3,
                edu_details: filteredDetails,
                tech_qualification: TQ,
              };
              // console.log(StepThreeData);
              AxiosInstance.post("api/course/admission/register", StepThreeData)
                .then((res) => {
                  if (res.data.status === true) {
                    setStep(step + 1);
                    sessionStorage.removeItem("stateRefreshs_mock");
                  } else {
                    Swal.fire({
                      title: "warning",
                      text: res.data.message,
                      icon: "warning",
                      confirmButtonText: "Ok",
                    });
                  }
                })
                .catch((error) => {
                  return error;
                });
            }
          } else if (step === 4) {
            //  Get selected batch safely
            const selectedBatch = batchDetails.find(
              (itm) => itm.is_selected === true
            );

            //  Stop if no batch selected
            if (!selectedBatch) {
              Swal.fire({
                title: "Warning",
                text: "Please select at least one batch",
                icon: "warning",
                confirmButtonText: "Ok",
              });
              return;
            }

            //  Prepare exam details once
            const ExamDetailsArray = examDetailsExam.map(
              (item) => item.examvalue
            );

            //  Validate exam details
            const errors_ExamDetails = validateExamDetails(
              examDetailsExam,
              setExamDetailsExam
            );

            //  Validation condition (unchanged logic, fixed structure)
            if (
              (list.ExamPreviously === "Yes" &&
                errors_ExamDetails.length > 0 &&
                errors_ExamDetails.every(
                  (el) => el.examvalue !== "" && el.error_name_exam === ""
                )) ||
              list.ExamPreviously === "NO"
            ) {
              //  Final payload (NO undefined .map, NO duplicates)
              const StepFourData = {
                user_id: userid,
                step: 4,
                type: 5,
                id: admissionID.adId ? admissionID.adId : 0,
                Category: list.category,
                Courses: selectedBatch.category_course_id
                  ? selectedBatch.category_course_id
                  : "",
                //  Send full selected batch
                BatchDetails: selectedBatch,
                govt_interview_dt: list.GovtInterDate || null,
                location: list.preferredBranchLocation_id
                  ? Number(list.preferredBranchLocation_id)
                  : null,
                exam_center_id: null,
                hall_ticket: 0,
                Exam: list.CompetitiveExamination === "Yes" ? 1 : 0,
                ExamName:
                  list.CompetitiveExamination === "Yes"
                    ? list.CompetitiveExamName
                    : null,
                ExamInstitute:
                  list.CompetitiveExamination === "Yes" ? list.Institute : null,
                passed_exam_name: Number(list.ExamName),
                exam_reg_no: list.ExamRegno || "",
                PrevExam: list.ExamPreviously === "Yes" ? 1 : 0,
                ExamDetail:
                  list.ExamPreviously === "Yes"
                    ? ExamDetailsArray.length > 0
                      ? ExamDetailsArray
                      : null
                    : null,
                PastExam: list.ExamPreviously === "Yes" ? list.ExamWrite : null,
                GoveEmp: list.workingRes === "Yes" ? 1 : 0,
                Designation:
                  list.workingRes === "Yes" ? list.Designation : null,
                Department: list.workingRes === "Yes" ? list.Department : null,
                JoinGovt: list.workingRes === "Yes" ? list.JoinGovt : null,
                AIASAStudent: list.AIASAStudent === "Yes" ? 1 : 0,
                Year: list.AIASAStudent === "Yes" ? list.Year : null,
                Aiasa_category:
                  list.AIASAStudent === "Yes" ? list.CategoryAias : null,
                Aiasa_course:
                  list.AIASAStudent === "Yes" ? list.CourseAias : null,
                IDNumber: list.AIASAStudent === "Yes" ? list.IDNumber : null,
                original_aiasa_id_path:
                  list.AIASAStudent === "Yes"
                    ? list.original_aiasa_id_path
                    : null,
                IdCardPath: list.AIASAStudent === "Yes" ? list.IDPhoto : null,
                updated_by: userid,
                //  Place of Birth & District
                place_birth: list.place_birth || "",
                district: list.district ? String(list.district) : "",
                //  Extra fields
                interview_type: list.modeOfInterview === "0" ? 1 : 0,
                mediumStudied: list.mediumStudied || "",
                govtExamName: list.govtExamName || "",
                govtExamRegisternumber: list.govtExamRegisternumber || "",
                core_pk: list.core_pk || null,
                core_subject: list.coreSubject ? list.coreSubject.value : null,
              };

              //  API call
              AxiosInstance.post("api/course/admission/register", StepFourData)
                .then(async (res) => {
                  if (res.data.status === true) {
                    if (res.data.data) {
                      setAdmissionID({ adId: res.data.data });
                    }
                    const infoViewSuccess = await callInfoView(userid);
                    if (infoViewSuccess) {
                      setStep(5);
                      sessionStorage.removeItem("stateRefreshs_mock");
                    } else {
                      Swal.fire({
                        title: "Warning",
                        text: "Unable to load exam details. Please try again.",
                        icon: "warning",
                        confirmButtonText: "Ok",
                      });
                    }
                  } else {
                    Swal.fire({
                      title: "Warning",
                      text: res.data.message,
                      icon: "warning",
                      confirmButtonText: "Ok",
                    });
                    setStep(1);
                    Info_View(userid);
                  }
                })
                .catch((error) => {
                  console.error("Step 4 submit error", error);
                });
            }
          } else if (step === 5) {
            if (list.Verify === true) {
              setStep(step + 1);
              sessionStorage.removeItem("stateRefreshs_mock");
            } else {
              let err = "Please look and verify the Terms and Conditions.";
              txtadVerifyHere.current.focus();
              setListErrors({
                ...listErrors,
                Verify: err,
              });
            }
          }
          // setStep(step + 1);
          // appendToStorage("PersonalDetails", JSON.stringify(list));
        } else {
          setListErrors(errors);
        }
      }
    } else {
      console.log("User Id cannot available in session storage");
    }
  };
  const validateThq = (techQualification, setTechQualification) => {
    if (techQualification && techQualification.length > 0) {
      const updateTHQ = techQualification.map((OB) => {
        let updatedOB = { ...OB };
        // if (!OB.name) {
        //   updatedOB.error_name = "Name is required";
        // }
        // if (OB.name === "Nil") {
        //   updatedOB.error_name = "";
        //   updatedOB.error_level = "";
        //   updatedOB.error_edu_medium = "";
        //   updatedOB.error_certificate_no = "";
        //   updatedOB.error_year_of_passing = "";
        //   updatedOB.error_grade = "";
        // }
        // if (!OB.level && OB.name !== "Nil") {
        //   updatedOB.error_level = "Level is required";
        // }

        // if (!OB.lang && OB.name !== "Nil") {
        //   updatedOB.error_edu_medium = "Lang is required";
        // }

        // if (!OB.Cnum && OB.name !== "Nil") {
        //   updatedOB.error_certificate_no = "Certificate No is required";
        // }

        // if (!OB.year && OB.name !== "Nil") {
        //   updatedOB.error_year_of_passing = "Year of passing is required";
        // }

        // if (!OB.grade && OB.name !== "Nil") {
        //   updatedOB.error_grade = "Grade is required";
        // }

        return updatedOB;
      });
      setTechQualification(updateTHQ);
      return updateTHQ;
    }
  };

  const validateExamDetails = (examDetailsExam, setExamDetailsExam) => {
    if (
      step === 4 &&
      examDetailsExam.length > 0 &&
      list.ExamPreviously === "Yes"
    ) {
      const updateExam = examDetailsExam.map((OB) => {
        let updatedOB = { ...OB };
        if (!OB.examvalue) {
          updatedOB.error_name_exam = "Exam Name is required";
          txtAdEdetail.current.focus();
        } else {
          updatedOB.error_name_exam = "";
        }
        return updatedOB;
      });
      setExamDetailsExam(updateExam);
      return updateExam;
    }
  };

  //  front end
  return (
    <div className="AdmissionForm_section AdmissionForm BathHeader global_container">
      <h4 className="Title">Mock Interview Admission</h4>

      <form>
        <div className="row progressTitle">
          <div className={`col-md-2  col-2 col-sm-2 col_progress`}>
            <div
              className={`${
                step === 1 ||
                step === 2 ||
                step === 3 ||
                step === 4 ||
                step === 5 ||
                step === 6 ||
                step === 7
                  ? "Card"
                  : "  Cards"
              }`}
            >
              <p
                className="circle"
                onClick={
                  step === 2 ||
                  step === 3 ||
                  step === 4 ||
                  step === 5 ||
                  step === 6 ||
                  step === 7
                    ? () => handleStepPrevious(1) // Wrap the call in an arrow function
                    : handleNext
                }
              >
                {step === 2 ||
                step === 3 ||
                step === 4 ||
                step === 5 ||
                step === 6 ||
                step === 7
                  ? "✓"
                  : "1"}
              </p>
              <p className="cTitle fw-semibold">Personal Profile</p>
              <p className="cSubtitle">Define Your Identity</p>
              <span
                className={`${
                  step === 2 ||
                  step === 3 ||
                  step === 4 ||
                  step === 5 ||
                  step === 6 ||
                  step === 7
                    ? "Stepborders"
                    : "Stepborder"
                } display_none_Stepborder`}
              ></span>
            </div>
          </div>
          <div className={`col-md-2 col-2 col-sm-2 col_progress`}>
            <div
              className={`${
                step === 2 ||
                step === 3 ||
                step === 4 ||
                step === 5 ||
                step === 6 ||
                step === 7
                  ? "Card"
                  : "  Cards"
              }`}
            >
              <p
                className="circle"
                onClick={
                  step === 3 ||
                  step === 4 ||
                  step === 5 ||
                  step === 6 ||
                  step === 7
                    ? () => handleStepPrevious(2) // Wrap the call in an arrow function
                    : handleNext
                }
              >
                {step === 3 ||
                step === 4 ||
                step === 5 ||
                step === 6 ||
                step === 7
                  ? "✓"
                  : "2"}
              </p>
              <p className="cTitle ">Communication</p>
              <p className="cSubtitle">Stay Connected Always</p>
              <span
                className={`${
                  step === 3 ||
                  step === 4 ||
                  step === 5 ||
                  step === 6 ||
                  step === 7
                    ? "Stepborders"
                    : "Stepborder"
                } display_none_Stepborder`}
              ></span>
            </div>
          </div>
          <div className={`col-md-2 col-2 col-sm-2 `}>
            <div
              className={`${
                step === 3 ||
                step === 4 ||
                step === 5 ||
                step === 6 ||
                step === 7
                  ? "Card"
                  : "  Cards"
              }`}
            >
              <p
                className="circle"
                onClick={
                  step === 4 || step === 5 || step === 6 || step === 7
                    ? () => handleStepPrevious(3) // Wrap the call in an arrow function
                    : handleNext
                }
              >
                {step === 4 || step === 5 || step === 6 || step === 7
                  ? "✓"
                  : "3"}
              </p>
              <p className="cTitle ">Academic Background</p>
              <p className="cSubtitle ">Your Learning Journey</p>
              <span
                className={`${
                  step === 4 || step === 5 || step === 6 || step === 7
                    ? "Stepborders"
                    : "Stepborder"
                } display_none_Stepborder`}
              ></span>
            </div>
          </div>
          <div className={`col-md-2 col-2 col-sm-2 `}>
            <div
              className={`${
                step === 4 || step === 5 || step === 6 || step === 7
                  ? "Card"
                  : "  Cards"
              }`}
            >
              <p
                className="circle"
                onClick={
                  step === 5 || step === 6 || step === 7
                    ? () => handleStepPrevious(4) // Wrap the call in an arrow function
                    : handleNext
                }
              >
                {step === 5 || step === 6 || step === 7 ? "✓" : "4"}
              </p>
              <p className="cTitle ">Mock Interview</p>
              <p className="cSubtitle ">Choose Your Course</p>
              <span
                className={`${
                  step === 5 || step === 6 || step === 7
                    ? "Stepborders"
                    : "Stepborder"
                } display_none_Stepborder`}
              ></span>
            </div>
          </div>

          <div className={`col-md-2 col-2 col-sm-2 col_end_progress `}>
            <div
              className={`${
                step === 5 || step === 6 || step === 7 ? "Card" : "  Cards"
              }`}
            >
              <p
                className="circle"
                onClick={
                  step === 6 || step === 7
                    ? () => handleStepPrevious(5) // Wrap the call in an arrow function
                    : handleNext
                }
              >
                {step === 6 || step === 7 ? "✓" : "5"}
              </p>
              <p className="cTitle ">Review and Confirm</p>
              <p className="cSubtitle ">Review Your Details</p>
              <span
                className={`${
                  step === 6 || step === 7 ? "Stepborders" : "Stepborder"
                } display_none_Stepborder`}
              ></span>
            </div>
          </div>
          <div className={`col-md-2 col-2 col-sm-2 col_end_progress `}>
            <div className={`${step === 6 || step === 7 ? "Card" : "  Cards"}`}>
              <p
                className="circle"
                onClick={
                  step === 7
                    ? () => handleStepPrevious(6) // Wrap the call in an arrow function
                    : handleNext
                }
              >
                {step === 7 ? "✓" : "6"}
              </p>
              <p className="cTitle ">Payment Info</p>
              <p className="cSubtitle ">Your Course, Your Cost</p>
            </div>
          </div>
        </div>
        {/* {step === 1} */}
        {step === 1 && (
          <div className="row">
            <div className="col-md-12">
              {/* -------------------- STEP ONE -------------------- */}
              <section className="StepOne">
                <div className="heading mt-3 d-flex justify-content-end">
                  <button
                    type="button"
                    className="SaveButton"
                    onClick={handleNext}
                  >
                    <a href="javascript:void(0)">
                      Save and Continue to Communication
                    </a>
                  </button>
                </div>

                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">{LBL_BASIC_DETAILS}</p>

                    {/* ---------- FIRST / LAST NAME ---------- */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="FirstName">First Name</label>
                          <input
                            ref={txtAdFname}
                            id="FirstName"
                            type="text"
                            name="FirstName"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={list.FirstName}
                            placeholder="First Name"
                            autoComplete="FirstName"
                            minLength={5}
                            maxLength={15}
                            required
                          />
                          {listErrors.FirstName && (
                            <p className="errors">{listErrors.FirstName}</p>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="LastName">Last Name</label>
                          <input
                            ref={txtAdLname}
                            id="LastName"
                            type="text"
                            name="LastName"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={list.LastName}
                            placeholder="Last Name"
                            autoComplete="LastName"
                            minLength={5}
                            maxLength={15}
                            required
                          />
                          {listErrors.LastName && (
                            <p className="errors">{listErrors.LastName}</p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* ---------- FATHER / MOTHER NAME ---------- */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="Fathername">
                            Father's / Guardian's Name
                          </label>
                          <input
                            ref={txtAdFath}
                            id="Fathername"
                            type="text"
                            name="Fathername"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={list.Fathername}
                            placeholder="Father Name"
                            minLength={5}
                            maxLength={50}
                            autoComplete="Fathername"
                            required
                          />
                          {listErrors.Fathername && (
                            <p className="errors">{listErrors.Fathername}</p>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="Gender">Gender</label>

                          <div className="d-flex col-md-12" id="radiobuttons">
                            {["Male", "Female", "Transgender"].map((g) => (
                              <div
                                className="form-check form-check-inline"
                                key={g}
                              >
                                <input
                                  className="checkbox_radio"
                                  type="radio"
                                  name="gender"
                                  id={g}
                                  ref={g === "Male" ? txtAdGender : null}
                                  disabled={list.admission_status === 1}
                                  onChange={handleChange}
                                  checked={list.gender === g}
                                  value={g}
                                />
                                <label className="checkbox-label" htmlFor={g}>
                                  {g}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>

                        {listErrors.gender && (
                          <small className="errors fw-semibold">
                            {listErrors.gender}
                          </small>
                        )}
                      </div>

                      {/* <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="MotherName">Mother's Name</label>
                          <input
                            ref={txtAdMoth}
                            id="MotherName"
                            type="text"
                            name="MotherName"
                            onChange={handleChange}
                            value={list.MotherName}
                            className="Inputs"
                            placeholder="Mother Name"
                            minLength={5}
                            maxLength={15}
                            autoComplete="MotherName"
                            required
                          />
                          {listErrors.MotherName && (
                            <small className="errors fw-semibold">
                              {listErrors.MotherName}
                            </small>
                          )}
                        </div>
                      </div> */}
                    </div>

                    {/* ---------- DOB / AGE ---------- */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="forms mock-interview">
                          <label htmlFor="DOB">Date of Birth</label>

                          <DatePickerSample
                            disabledProperty={list.admission_status === 1}
                            txtAdMDob={txtAdMDob}
                            name="DOB"
                            handleChange={handleChangeDate}
                            fieldInput={list.DOB}
                          />

                          {listErrors.DOB && (
                            <p className="errors">{listErrors.DOB}</p>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="age">Age</label>
                          <input
                            ref={txtAdAge}
                            id="age"
                            type="text"
                            name="age"
                            className="Inputs"
                            placeholder="Age"
                            readOnly
                            disabled={list.admission_status === 1}
                            value={list.age}
                            onChange={handleChange}
                            autoComplete="age"
                            required
                          />
                          {listErrors.age && (
                            <p className="errors">{listErrors.age}</p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* ---------- GENDER ---------- */}
                    <div className="row mb-4">
                      {/* ---------- MARITAL STATUS ---------- */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="MaritalStatus">Marital Status</label>

                          <div
                            className="d-flex ms-4 col-md-12"
                            id="radiobuttons"
                          >
                            {["Single/Unmarried", "Married", "Widowed"].map(
                              (status) => (
                                <div
                                  className="form-checks form-check-inline"
                                  key={status}
                                >
                                  <input
                                    className="checkbox_radio"
                                    type="radio"
                                    name="MaritalStatus"
                                    id={status}
                                    ref={
                                      status === "Single/Unmarried"
                                        ? txtAdMStatus
                                        : null
                                    }
                                    disabled={list.admission_status === 1}
                                    onChange={handleChange}
                                    checked={list.MaritalStatus === status}
                                    value={status}
                                  />
                                  <label
                                    className="checkbox-label"
                                    htmlFor={status}
                                  >
                                    {status}
                                  </label>
                                </div>
                              )
                            )}
                          </div>
                        </div>

                        {listErrors.MaritalStatus && (
                          <small className="errors fw-semibold">
                            {listErrors.MaritalStatus}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              {/* -------------------- PASSPORT PHOTO -------------------- */}
              <section className="sectionTwo">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Passport Size Photograph</p>

                    <div className="row">
                      <div className="col-md-6 d-flex justify-content-center">
                        <div className="forms">
                          <img
                            className="ProfilePhoto bg-opacity-75"
                            src={`${ImageUrlPrefix}/${list.Profilephoto}`}
                            alt="profile"
                          />

                          {!list.Profilephoto && (
                            <span id="text">Profile Picture</span>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="Profilephoto">
                            Upload Passport Size Photograph
                          </label>

                          <input
                            ref={txtAdPSize}
                            id="Profilephoto"
                            type="file"
                            disabled={list.admission_status === 1}
                            name="Profilephoto"
                            onChange={handleChange}
                            className="InputsFile"
                            autoComplete="Profilephoto"
                            required
                          />

                          {listErrors.Profilephoto && (
                            <small className="errors fw-semibold">
                              {listErrors.Profilephoto}
                            </small>
                          )}
                        </div>

                        {/* Notes */}
                        <div className="forms mt-4 ms-md-3 mb-4">
                          <h6 className="profileText">Note:</h6>
                          <p className="warningOne my-2">
                            Image format: JPEG or PNG.
                          </p>
                          <h6 className="warningTwo">
                            <span className="fw-semibold">Image size</span>:
                            400x400 to 1024x1024. Max 40 KB.
                          </h6>
                          <h6 className="warningTwo">
                            <span className="fw-semibold">Image quality</span>:
                            Professional and clear.
                          </h6>
                          <h6 className="warningTwo">
                            <span className="fw-semibold">
                              Image orientation
                            </span>
                            : Square format recommended.
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* -------------------- ID PROOFS -------------------- */}
              <section className="sectionTwo">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">{LBL_ID_PROOFS}</p>

                    {/* ---------- AADHAR NUMBER ---------- */}
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="aadharNo">AADHAR Number</label>
                          <input
                            ref={txtAdAno}
                            id="aadharNo"
                            type="number"
                            disabled={list.admission_status === 1}
                            name="aadharNo"
                            onChange={handleChange}
                            value={list.aadharNo < 0 ? 0 : list.aadharNo}
                            className="Inputs"
                            placeholder="Aadhar Number"
                            autoComplete="aadharNo"
                            minLength={12}
                            required
                          />
                          {listErrors.aadharNo && (
                            <p className="errors">{listErrors.aadharNo}</p>
                          )}
                        </div>
                      </div>

                      {/* ---------- AADHAR UPLOAD ---------- */}
                      <div className="col-lg-6 col-md-12">
                        <div className="forms">
                          <label htmlFor="aadharCardphoto">
                            Upload AADHAR Card (PDF/Image)
                            {list.aadharCardphoto && (
                              <a
                                href={`${ImageUrlPrefix}/${list.aadharCardphoto}`}
                                target="_blank"
                                download
                              >
                                <span className="material-icons align-middle download_icon">
                                  file_download
                                </span>
                              </a>
                            )}
                          </label>

                          <div className="row">
                            <div
                              className={
                                list.aadharCardphoto ? "col-md-3" : "col-md-12"
                              }
                            >
                              <input
                                ref={txtAdApath}
                                id="aadharCardphoto"
                                type="file"
                                name="aadharCardphoto"
                                disabled={list.admission_status === 1}
                                className={
                                  list.aadharCardphoto
                                    ? "InputsFile nn_upload_width"
                                    : "InputsFile vv_upload_width"
                                }
                                onChange={handleChange}
                                autoComplete="aadharCardphoto"
                                required
                              />
                            </div>

                            {list.aadharCardphoto && (
                              <div className="col-md-9 d-flex align-content-center p-0">
                                <span className="nn_upload_file">
                                  {list.original_aadhar_path}
                                </span>
                                <span className="material-icons align-middle text-danger verified_upload">
                                  verified
                                </span>
                              </div>
                            )}
                          </div>

                          {listErrors.aadharCardphoto && (
                            <p className="errors">
                              {listErrors.aadharCardphoto}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* -------------------- COMMUNAL CATEGORY -------------------- */}
              <section className="sectionTwo">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Communal Reservation Category</p>

                    <div className="row mb-4">
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="Cast">Category</label>

                          <Select
                            ref={txtAdCno}
                            id="Cast"
                            name="Cast"
                            value={dropdown.Cast}
                            isDisabled={list.admission_status === 1}
                            onChange={(option) =>
                              handleSelectMulti(option, "Cast", "Cast")
                            }
                            options={categoryOption}
                            isSearchable
                            placeholder="Select an option"
                            maxMenuHeight={200}
                            filterOption={(option, search) =>
                              option.label
                                .toLowerCase()
                                .includes(search.toLowerCase())
                            }
                            styles={customStyles}
                          />

                          {listErrors.Cast && (
                            <small className="errors fw-semibold">
                              {listErrors.Cast}
                            </small>
                          )}
                        </div>
                      </div>

                      {/* ---------- CAST FILE UPLOAD ---------- */}
                      <div className="col-lg-6 col-md-12">
                        <div className="forms">
                          <label htmlFor="CastFile">
                            Upload Community Certificate (PDF/Image)
                            <span className="optionFields">(Optional)</span>
                            {list.CastFile && (
                              <a
                                href={`${ImageUrlPrefix}/${list.CastFile}`}
                                target="_blank"
                                download
                              >
                                <span className="material-icons align-middle download_icon">
                                  file_download
                                </span>
                              </a>
                            )}
                          </label>

                          <div className="row">
                            <div
                              className={
                                list.CastFile ? "col-md-3" : "col-md-12"
                              }
                            >
                              <input
                                ref={txtAdCpath}
                                id="CastFile"
                                type="file"
                                name="CastFile"
                                disabled={list.admission_status === 1}
                                onChange={handleChange}
                                className={
                                  list.CastFile
                                    ? "InputsFile nn_upload_width"
                                    : "InputsFile vv_upload_width"
                                }
                              />
                            </div>

                            {list.CastFile && (
                              <div className="col-md-9 d-flex align-content-center p-0">
                                <span className="nn_upload_file">
                                  {list.original_caste_path}
                                </span>
                                <span className="material-icons align-middle text-danger verified_upload">
                                  verified
                                </span>
                              </div>
                            )}
                          </div>

                          {listErrors.CastFile && (
                            <small className="errors fw-semibold">
                              {listErrors.CastFile}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* -------------------- SPECIAL ADMISSION -------------------- */}
              <section className=" sectionTwo">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">
                      Applicable Special Category Preferences
                    </p>

                    <div className="row mb-4">
                      <div className="col-md-6">
                        <div className="forms ">
                          <label htmlFor="AppCast">Category</label>
                          <Select
                            ref={txtAppSpeCat}
                            id="AppCast"
                            name="AppCast"
                            closeMenuOnSelect={false}
                            hideSelectedOptions={true}
                            isMulti
                            placeholder="Select an option"
                            value={appCastLable.map((value) => ({
                              value: value.value,
                              label: value.label,
                            }))}
                            onChange={(option) =>
                              handleSelectMulti(option, "AppCast", "AppCast")
                            }
                            isDisabled={list.admission_status === 1}
                            options={appcategoryOption}
                            isSearchable={true}
                            maxMenuHeight={200}
                            components={{
                              Option: CommonOption,
                            }}
                            styles={multiCusutomStyle}
                          />
                          {listErrors.AppCast && (
                            <small className="errors fw-semibold">
                              {listErrors.AppCast}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="heading mb-5 d-flex justify-content-end">
                  <button
                    type="button"
                    className="SaveButton"
                    onClick={handleNext}
                  >
                    <a href="javascript:void(0)">
                      Save and Continue to Communication
                    </a>
                  </button>
                </div>
              </section>
              {/* <section className="sectionTwo">
                {specialAdmissionPre.map((item, index) => (
                  <SpecialPre
                    key={index}
                    record={item}
                    length={specialAdmissionPre.length}
                    specialAdmissionHandleChanges={
                      specialAdmissionHandleChanges
                    }
                    specialHandleChange={specialAdmissionHandleChange}
                    sPrefrence={specialPrefrence}
                    Deletespre={DeleteAdmissionspre}
                    AddPrefrence={AddPrefrence}
                    txtAdSpc={txtAdSpc}
                    handleChange={handleChange}
                    list={list.SPCcategory}
                    listErrors={listErrors.SPCcategory}
                  />
                ))}

                <div className="heading mb-5 d-flex justify-content-end">
                  <button
                    type="button"
                    className="SaveButton"
                    onClick={handleNext}
                  >
                    <a href="javascript:void(0)">
                      Save and Continue to Communication
                    </a>
                  </button>
                </div>
              </section> */}
            </div>
          </div>
        )}

        {/* &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& */}
        {/* {step === 2} */}
        {step === 2 && (
          <div className="row">
            <div className="col-md-12">
              {/* -------------------- CONTACT DETAILS -------------------- */}
              <section className="sectionThree">
                <div className="heading dflexbetww">
                  <div>
                    <button
                      type="button"
                      className="SaveButton_Prev"
                      onClick={handlePrevious}
                    >
                      <a href="javascript:void(0)">Go to Personal Details</a>
                    </button>
                  </div>

                  <div className="d-flex smButton mobiledown">
                    <Link to="/" className="CancelButton">
                      Back to Home
                    </Link>

                    <button
                      type="button"
                      className="SaveButtons"
                      onClick={handleNext}
                    >
                      <a href="javascript:void(0)">
                        Save and Continue to Academic Background
                      </a>
                    </button>
                  </div>
                </div>

                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">{LBL_CONTACT_DETAILS}</p>

                    {/* Phone + WhatsApp */}
                    <div className="row">
                      {/* Phone Number */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="Mobile">Phone Number</label>
                          <input
                            ref={txtAdPno}
                            id="Mobile"
                            type="tel"
                            name="Mobile"
                            className="Inputs_Phone"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={list.Mobile}
                            placeholder="Phone Number"
                            autoComplete="Mobile"
                            required
                            minLength={10}
                            maxLength={10}
                            inputMode="tel"
                          />
                          {listErrors.Mobile && (
                            <p className="errors">{listErrors.Mobile}</p>
                          )}
                        </div>
                      </div>

                      {/* WhatsApp Number */}
                      <div className="col-md-6">
                        <div className="forms">
                          <div className="d-flex justify-content-between">
                            <label htmlFor="WhatsAppNumber">
                              WhatsApp Number
                            </label>

                            <label>
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                                id="ContactNumber"
                                name="ContactNumber"
                                disabled={list.admission_status === 1}
                                onChange={handleChange}
                                checked={list.ContactNumber === true}
                              />
                              <span className="form-check-label">
                                Same as Contact Number
                              </span>
                            </label>
                          </div>

                          <input
                            ref={txtAdWno}
                            id="WhatsAppNumber"
                            type="tel"
                            name="WhatsAppNumber"
                            className="Inputs_Phone"
                            disabled={list.admission_status === 1}
                            onBlur={handleblur}
                            onChange={handleChange}
                            value={
                              list.ContactNumber !== true
                                ? list.WhatsAppNumber
                                : list.Mobile
                            }
                            placeholder="WhatsApp Number"
                            autoComplete="WhatsAppNumber"
                            required
                            minLength={10}
                            maxLength={10}
                            inputMode="tel"
                          />

                          {listErrors.WhatsAppNumber && (
                            <p className="errors">
                              {listErrors.WhatsAppNumber}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Guardian Phone + Email */}
                    <div className="row">
                      {/* Guardian Phone */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="ParentMobileNo">
                            Father/Guardian Phone Number
                          </label>
                          <input
                            ref={txtAdFpo}
                            id="ParentMobileNo"
                            type="text"
                            name="ParentMobileNo"
                            className="Inputs_Phone"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={list.ParentMobileNo}
                            placeholder="Mobile Number"
                            autoComplete="ParentMobileNo"
                            required
                            minLength={10}
                            maxLength={10}
                            inputMode="tel"
                          />
                          {listErrors.ParentMobileNo && (
                            <p className="errors">
                              {listErrors.ParentMobileNo}
                            </p>
                          )}
                        </div>
                      </div>

                      {/* Email */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="emailaddress">Email ID</label>
                          <input
                            ref={txtAdEmail}
                            id="emailaddress"
                            type="email"
                            name="emailaddress"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            readOnly
                            onChange={handleChange}
                            value={list.emailaddress}
                            placeholder="Email ID"
                            autoComplete="emailaddress"
                            required
                          />
                          {listErrors.emailaddress && (
                            <p className="errors">{listErrors.emailaddress}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* -------------------- PRESENT ADDRESS -------------------- */}
              <section className="sectionFour">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Present Address</p>

                    {/* House + Street */}
                    <div className="row">
                      {/* House/Flat Number */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="BuildingNumberPresent">
                            House/Flat Number & Name
                          </label>
                          <input
                            ref={txtAdPhno}
                            id="BuildingNumberPresent"
                            type="text"
                            name="BuildingNumberPresent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={list.BuildingNumberPresent}
                            placeholder="House/Building Number"
                            autoComplete="BuildingNumberPresent"
                            required
                          />
                          {listErrors.BuildingNumberPresent && (
                            <p className="errors">
                              {listErrors.BuildingNumberPresent}
                            </p>
                          )}
                        </div>
                      </div>

                      {/* Street Name */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="StreetNamePresent">Street Name</label>
                          <input
                            ref={txtAdPsname}
                            id="StreetNamePresent"
                            type="text"
                            name="StreetNamePresent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={list.StreetNamePresent}
                            placeholder="Street Name"
                            autoComplete="StreetNamePresent"
                            required
                          />
                          {listErrors.StreetNamePresent && (
                            <p className="errors">
                              {listErrors.StreetNamePresent}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Area + Landmark */}
                    <div className="row">
                      {/* Area */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="AreaPresent">Locality/Area</label>
                          <input
                            ref={txtAdParea}
                            id="AreaPresent"
                            type="text"
                            name="AreaPresent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={list.AreaPresent}
                            placeholder="Locality/Area"
                            autoComplete="AreaPresent"
                            required
                          />
                          {listErrors.AreaPresent && (
                            <p className="errors">{listErrors.AreaPresent}</p>
                          )}
                        </div>
                      </div>

                      {/* Landmark */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="LandmarkPresent">Landmark</label>
                          <input
                            ref={txtAdPland}
                            id="LandmarkPresent"
                            type="text"
                            name="LandmarkPresent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={list.LandmarkPresent}
                            placeholder="Landmark"
                            autoComplete="LandmarkPresent"
                            required
                          />
                          {listErrors.LandmarkPresent && (
                            <p className="errors">
                              {listErrors.LandmarkPresent}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Post + Taluk */}
                    <div className="row">
                      {/* Post */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="PostPresent">Post</label>
                          <input
                            ref={txtAdPpost}
                            id="PostPresent"
                            type="text"
                            name="PostPresent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={list.PostPresent}
                            placeholder="Post"
                            autoComplete="PostPresent"
                            required
                          />
                          {listErrors.PostPresent && (
                            <p className="errors">{listErrors.PostPresent}</p>
                          )}
                        </div>
                      </div>

                      {/* Taluk */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="TalukPresent">Taluk</label>
                          <input
                            ref={txtAdPtaluk}
                            id="TalukPresent"
                            type="text"
                            name="TalukPresent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={list.TalukPresent}
                            placeholder="Taluk"
                            autoComplete="TalukPresent"
                            required
                          />
                          {listErrors.TalukPresent && (
                            <p className="errors">{listErrors.TalukPresent}</p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Pincode + City */}
                    <div className="row">
                      {/* Pincode */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="PincodePresent">
                            Pin/Postal Code
                          </label>
                          <input
                            ref={txtAdPpincode}
                            id="PincodePresent"
                            type="text"
                            name="PincodePresent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={list.PincodePresent}
                            placeholder="Pin/Postal Code"
                            autoComplete="PincodePresent"
                            required
                          />
                          {listErrors.PincodePresent && (
                            <p className="errors">
                              {listErrors.PincodePresent}
                            </p>
                          )}
                        </div>
                      </div>

                      {/* City */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="CityPresent">City/Town/Village</label>

                          <Select
                            ref={txtAdPcity}
                            id="CityPresent"
                            name="CityPresent"
                            disabled={list.admission_status === 1}
                            value={
                              list.CityPresent
                                ? {
                                    value: list.CityPresent,
                                    label: list.CityPresent,
                                  }
                                : null
                            }
                            onChange={(option) =>
                              handleSelectCH(option, "CityPresent")
                            }
                            options={city
                              .filter((item) => item && item.label)
                              .sort((a, b) => a.label.localeCompare(b.label))}
                            isSearchable
                            placeholder="Select an option"
                            maxMenuHeight={200}
                            filterOption={(option, search) =>
                              option.label
                                .toLowerCase()
                                .includes(search.toLowerCase())
                            }
                            styles={customStyles}
                          />

                          {listErrors.CityPresent && (
                            <p className="errors">{listErrors.CityPresent}</p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* District + State */}
                    <div className="row mb-4">
                      {/* District */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="districtPresent">District</label>
                          <input
                            ref={txtAdPdistrict}
                            id="districtPresent"
                            type="text"
                            name="districtPresent"
                            className="Inputs"
                            value={list.districtPresent}
                            placeholder="District"
                            disabled
                            required
                          />
                          {listErrors.districtPresent && (
                            <p className="errors">
                              {listErrors.districtPresent}
                            </p>
                          )}
                        </div>
                      </div>

                      {/* State */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="statePresent">
                            State/Union Territory
                          </label>
                          <input
                            ref={txtAdPstate}
                            id="statePresent"
                            type="text"
                            name="statePresent"
                            className="Inputs"
                            value={list.statePresent}
                            placeholder="State/Union Territory"
                            disabled
                            required
                          />
                          {listErrors.statePresent && (
                            <p className="errors">{listErrors.statePresent}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* -------------------- PERMANENT ADDRESS -------------------- */}
              <section className="sectionFour">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="final">Permanent Address</p>

                    {/* Same as Present Address */}
                    <div className="row mt-4 ms-2">
                      <div className="col-md-12">
                        <div className="d-flex justify-content-between">
                          <label>
                            <input
                              className="form-check-input me-2"
                              type="checkbox"
                              id="SamePresentAddress"
                              name="SamePresentAddress"
                              disabled={list.admission_status === 1}
                              onChange={handleChange}
                              checked={list.SamePresentAddress === true}
                            />
                            <span className="form-check-label">
                              Same as Present Address
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* House + Street */}
                    <div className="row">
                      {/* House */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="BuildingNumberPermanent">
                            House/Flat Number & Name
                          </label>
                          <input
                            ref={txtAdPerhno}
                            id="BuildingNumberPermanent"
                            type="text"
                            name="BuildingNumberPermanent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={
                              list.SamePresentAddress !== true
                                ? list.BuildingNumberPermanent
                                : list.BuildingNumberPresent
                            }
                            placeholder="House/Building Number"
                            autoComplete="BuildingNumberPermanent"
                            required
                          />
                          {listErrors.BuildingNumberPermanent && (
                            <p className="errors">
                              {listErrors.BuildingNumberPermanent}
                            </p>
                          )}
                        </div>
                      </div>

                      {/* Street */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="StreetNamePermanent">
                            Street Name
                          </label>
                          <input
                            ref={txtAdPersname}
                            id="StreetNamePermanent"
                            type="text"
                            name="StreetNamePermanent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={
                              list.SamePresentAddress !== true
                                ? list.StreetNamePermanent
                                : list.StreetNamePresent
                            }
                            placeholder="Street Name"
                            autoComplete="StreetNamePermanent"
                            required
                          />
                          {listErrors.StreetNamePermanent && (
                            <p className="errors">
                              {listErrors.StreetNamePermanent}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Area + Landmark */}
                    <div className="row">
                      {/* Area */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="AreaPermanent">Locality/Area</label>
                          <input
                            ref={txtAdPerarea}
                            id="AreaPermanent"
                            type="text"
                            name="AreaPermanent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={
                              list.SamePresentAddress !== true
                                ? list.AreaPermanent
                                : list.AreaPresent
                            }
                            placeholder="Locality/Area"
                            autoComplete="AreaPermanent"
                            required
                          />
                          {listErrors.AreaPermanent && (
                            <p className="errors">{listErrors.AreaPermanent}</p>
                          )}
                        </div>
                      </div>

                      {/* Landmark */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="LandmarkPermanent">Landmark</label>
                          <input
                            ref={txtAdPerland}
                            id="LandmarkPermanent"
                            type="text"
                            name="LandmarkPermanent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={
                              list.SamePresentAddress !== true
                                ? list.LandmarkPermanent
                                : list.LandmarkPresent
                            }
                            placeholder="Landmark"
                            autoComplete="LandmarkPermanent"
                            required
                          />
                          {listErrors.LandmarkPermanent && (
                            <p className="errors">
                              {listErrors.LandmarkPermanent}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Post + Taluk */}
                    <div className="row">
                      {/* Post */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="PostPermanent">Post</label>
                          <input
                            ref={txtAdPererpost}
                            id="PostPermanent"
                            type="text"
                            name="PostPermanent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={
                              list.SamePresentAddress !== true
                                ? list.PostPermanent
                                : list.PostPresent
                            }
                            placeholder="Post"
                            autoComplete="PostPermanent"
                            required
                          />
                          {listErrors.PostPermanent && (
                            <p className="errors">{listErrors.PostPermanent}</p>
                          )}
                        </div>
                      </div>

                      {/* Taluk */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="TalukPermanent">Taluk</label>
                          <input
                            ref={txtAdPertaluk}
                            id="TalukPermanent"
                            type="text"
                            name="TalukPermanent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={
                              list.SamePresentAddress !== true
                                ? list.TalukPermanent
                                : list.TalukPresent
                            }
                            placeholder="Taluk"
                            autoComplete="TalukPermanent"
                            required
                          />
                          {listErrors.TalukPermanent && (
                            <p className="errors">
                              {listErrors.TalukPermanent}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Pincode + City */}
                    <div className="row">
                      {/* Pincode */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="PincodePermanent">
                            Pin/Postal Code
                          </label>
                          <input
                            ref={txtAdPerpincode}
                            id="PincodePermanent"
                            type="text"
                            name="PincodePermanent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={
                              list.SamePresentAddress !== true
                                ? list.PincodePermanent
                                : list.PincodePresent
                            }
                            placeholder="Pin/Postal Code"
                            autoComplete="PincodePermanent"
                            required
                          />
                          {listErrors.PincodePermanent && (
                            <p className="errors">
                              {listErrors.PincodePermanent}
                            </p>
                          )}
                        </div>
                      </div>

                      {/* City */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="CityPermanent">
                            City/Town/Village
                          </label>

                          {list.SamePresentAddress !== true ? (
                            <Select
                              ref={txtAdPercity}
                              id="CityPermanent"
                              name="CityPermanent"
                              disabled={list.admission_status === 1}
                              value={
                                list.CityPermanent
                                  ? {
                                      value: list.CityPermanent,
                                      label: list.CityPermanent,
                                    }
                                  : null
                              }
                              onChange={(option) =>
                                handleSelectCH(option, "CityPermanent")
                              }
                              options={city
                                .filter((item) => item && item.label)
                                .sort((a, b) => a.label.localeCompare(b.label))}
                              isSearchable
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, search) =>
                                option.label
                                  .toLowerCase()
                                  .includes(search.toLowerCase())
                              }
                              styles={customStyles}
                            />
                          ) : (
                            <input
                              ref={txtAdPercity}
                              id="CityPermanent"
                              type="text"
                              name="CityPermanent"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={handleChange}
                              value={
                                list.SamePresentAddress === true
                                  ? list.CityPresent
                                  : list.CityPermanent
                              }
                              placeholder="City"
                              autoComplete="CityPermanent"
                              required
                            />
                          )}

                          {listErrors.CityPermanent && (
                            <p className="errors">{listErrors.CityPermanent}</p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* District + State */}
                    <div className="row mb-4">
                      {/* District */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="districtPermanent">District</label>
                          <input
                            ref={txtAdPerdistrict}
                            id="districtPermanent"
                            type="text"
                            name="districtPermanent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={
                              list.SamePresentAddress !== true
                                ? list.districtPermanent
                                : list.districtPresent
                            }
                            placeholder="District"
                            autoComplete="districtPermanent"
                            required
                          />
                          {listErrors.districtPermanent && (
                            <p className="errors">
                              {listErrors.districtPermanent}
                            </p>
                          )}
                        </div>
                      </div>

                      {/* State */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="statePermanent">
                            State/Union Territory
                          </label>
                          <input
                            ref={txtAdPerstate}
                            id="statePermanent"
                            type="text"
                            name="statePermanent"
                            className="Inputs"
                            disabled={list.admission_status === 1}
                            onChange={handleChange}
                            value={
                              list.SamePresentAddress !== true
                                ? list.statePermanent
                                : list.statePresent
                            }
                            placeholder="State/Union Territory"
                            autoComplete="statePermanent"
                            required
                          />
                          {listErrors.statePermanent && (
                            <p className="errors">
                              {listErrors.statePermanent}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Footer Buttons */}
                <div className="heading mb-4 dflexbetww">
                  <div>
                    <button
                      type="button"
                      className="SaveButton_Prev"
                      onClick={handlePrevious}
                    >
                      <a href="javascript:void(0)">Go to Personal Details</a>
                    </button>
                  </div>

                  <div className="d-flex smButton mobiledown">
                    <Link to="/" className="CancelButton">
                      Back to Home
                    </Link>

                    <button
                      type="button"
                      className="SaveButtons"
                      onClick={handleNext}
                    >
                      <a href="javascript:void(0)">
                        Save and Continue to Academic Background
                      </a>
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>
        )}

        {/* &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& */}
        {/* {step === 3} */}
        {step === 3 && (
          <div className="row">
            <div className="col-md-12">
              <section className="sectionFive">
                <div className="heading dflexbetww">
                  <div>
                    <button
                      type="button"
                      className="SaveButton_Prev"
                      onClick={handlePrevious}
                    >
                      <a href="javascript:void(0)">Go to Communication</a>
                    </button>
                  </div>

                  <div className="d-flex smButton mobiledown">
                    <Link to="/" className="CancelButton">
                      Back to Home
                    </Link>

                    <button
                      type="button"
                      className="SaveButtons"
                      onClick={handleNext}
                    >
                      <a href="javascript:void(0)">
                        Save and Continue to Mock Interview Details
                      </a>
                    </button>
                  </div>
                </div>

                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Educational Qualification</p>

                    <div className="row mb-3">
                      <div className="col-md-12">
                        <div className="forms row">
                          <label htmlFor="EducationQualification">
                            Select All The Academic Certificates You Have
                          </label>

                          <div
                            className="d-flex mt-4 ms-3 col-md-12"
                            id="radiobuttons"
                          >
                            <div className="form-check form-check-inline">
                              <input
                                ref={txtAdEduc}
                                className="form-check-input"
                                type="checkbox"
                                id="EducationQualification1"
                                value="SSLC"
                                disabled={list.admission_status === 1}
                                checked={educationQualification.includes(
                                  "SSLC"
                                )}
                                onChange={handleCheckboxChange}
                              />
                              <span className="form-check-label">SSLC</span>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="EducationQualification2"
                                value="HSC"
                                disabled={list.admission_status === 1}
                                checked={educationQualification.includes("HSC")}
                                onChange={handleCheckboxChange}
                              />
                              <span className="form-check-label">HSC</span>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="EducationQualification3"
                                value="UG"
                                disabled={list.admission_status === 1}
                                checked={educationQualification.includes("UG")}
                                onChange={handleCheckboxChange}
                              />
                              <span className="form-check-label">UG</span>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="EducationQualification4"
                                value="PG"
                                disabled={list.admission_status === 1}
                                checked={educationQualification.includes("PG")}
                                onChange={handleCheckboxChange}
                              />
                              <span className="form-check-label">PG</span>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="EducationQualification5"
                                value="Integrated PG"
                                disabled={list.admission_status === 1}
                                checked={educationQualification.includes(
                                  "Integrated PG"
                                )}
                                onChange={handleCheckboxChange}
                              />
                              <span className="form-check-label">
                                Integrated PG
                              </span>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="EducationQualification6"
                                value="Diploma"
                                disabled={list.admission_status === 1}
                                checked={educationQualification.includes(
                                  "Diploma"
                                )}
                                onChange={handleCheckboxChange}
                              />
                              <span className="form-check-label">Diploma</span>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="EducationQualification7"
                                value="Professional Courses"
                                disabled={list.admission_status === 1}
                                checked={educationQualification.includes(
                                  "Professional Courses"
                                )}
                                onChange={handleCheckboxChange}
                              />
                              <span className="form-check-label">
                                Professional Courses
                              </span>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="EducationQualification8"
                                value="Others"
                                disabled={list.admission_status === 1}
                                checked={educationQualification.includes(
                                  "Others"
                                )}
                                onChange={handleCheckboxChange}
                              />
                              <span className="form-check-label">Others</span>
                            </div>
                          </div>

                          {listErrors.EducationQualification && (
                            <p className="errors">
                              {listErrors.EducationQualification}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* //educational section */}

              {educationQualification.includes("SSLC") && (
                <section className="sectionFive">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">SSLC</p>

                      {/* --- Certificate Number --- */}
                      <div className="row">
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="SSLC_CNo">Certificate Number</label>
                            <input
                              ref={txtAdSslc}
                              id="SSLC_CNo"
                              type="text"
                              name="SSLC_CNo"
                              disabled={list.admission_status === 1}
                              className="Inputs"
                              onChange={(e) => handleEdu("sslc", e)}
                              placeholder="Certificate Number"
                              value={sslcCerficates[0].SSLC_CNo}
                              autoComplete="Certificate Number"
                              minLength={10}
                              maxLength={10}
                              required
                            />
                            {listErrors.SSLC_CNo && (
                              <p className="errors">{listErrors.SSLC_CNo}</p>
                            )}
                          </div>
                        </div>

                        {/* --- Year of Passing --- */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms mock-interview">
                            <label htmlFor="SSLC_Year">Year of Passing</label>

                            <MonthDatePicker
                              handleYearChange={handleYearChange_month}
                              handleMonthChange={handleMonthChange_month}
                              disabledProperty={list.admission_status === 1}
                              dname="sslc"
                              txtAdSpass={txtAdSpass}
                              name="SSLC_Year"
                              handleChange={handleEYDate}
                              fieldInput={sslcCerficates[0].SSLC_Year}
                            />

                            {listErrors.SSLC_Year && (
                              <p className="errors">{listErrors.SSLC_Year}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* --- Marks & Board --- */}
                      <div className="row">
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="SSLC_Marks">Marks Percentage</label>
                            <input
                              ref={txtAdSmarks}
                              id="SSLC_Marks"
                              type="number"
                              name="SSLC_Marks"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("sslc", e)}
                              placeholder="Marks Percentage"
                              value={sslcCerficates[0].SSLC_Marks}
                              autoComplete="SSLC_Marks"
                              required
                            />
                            {listErrors.SSLC_Marks && (
                              <p className="errors">{listErrors.SSLC_Marks}</p>
                            )}
                          </div>
                        </div>

                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="SSLC_Eboard">Education Board</label>
                            <select
                              ref={txtAdSboard}
                              id="SSLC_Eboard"
                              name="SSLC_Eboard"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("sslc", e)}
                              defaultValue={sslcCerficates[0].SSLC_Eboard}
                              required
                            >
                              <option value="" disabled>
                                Please select
                              </option>
                              <option>State board</option>
                              <option>Matriculation</option>
                              <option>CBSE</option>
                              <option>ICSE</option>
                              <option>others</option>
                            </select>

                            {listErrors.SSLC_Eboard && (
                              <p className="errors">{listErrors.SSLC_Eboard}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* --- Medium & School --- */}
                      <div className="row mb-4">
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="SSLC_MI">
                              Medium of Instruction
                            </label>
                            <select
                              ref={txtAdSins}
                              id="SSLC_MI"
                              name="SSLC_MI"
                              disabled={list.admission_status === 1}
                              className="Inputs"
                              onChange={(e) => handleEdu("sslc", e)}
                              defaultValue={sslcCerficates[0].SSLC_MI}
                              required
                            >
                              <option value="" disabled>
                                Please select
                              </option>
                              <option>Tamil Medium</option>
                              <option>English Medium</option>
                            </select>

                            {listErrors.SSLC_MI && (
                              <p className="errors">{listErrors.SSLC_MI}</p>
                            )}
                          </div>
                        </div>

                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="SSLC_Scl">School Name</label>
                            <input
                              ref={txtAdSschool}
                              id="SSLC_Scl"
                              type="text"
                              name="SSLC_Scl"
                              disabled={list.admission_status === 1}
                              className="Inputs"
                              onChange={(e) => handleEdu("sslc", e)}
                              placeholder="School Name"
                              value={sslcCerficates[0].SSLC_Scl}
                              autoComplete="SchoolName"
                              required
                            />
                            {listErrors.SSLC_Scl && (
                              <p className="errors">{listErrors.SSLC_Scl}</p>
                            )}
                          </div>
                        </div>

                        {/* --- Upload --- */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="SSLC_Path">
                              Upload SSLC Certificate (pdf/Image)
                              <span className="optionFields">(Optional)</span>
                              {Boolean(sslcCerficates[0].SSLC_Path) && (
                                <a
                                  href={`${ImageUrlPrefix}/${sslcCerficates[0].SSLC_Path}`}
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons download_icon align-middle text-danger">
                                    file_download
                                  </span>
                                </a>
                              )}
                            </label>

                            <div className="row">
                              <div
                                className={
                                  Boolean(sslcCerficates[0].SSLC_Path)
                                    ? "col-md-3"
                                    : "col-md-12"
                                }
                              >
                                <input
                                  ref={txtAdSfile}
                                  id="SSLC_Path"
                                  type="file"
                                  name="SSLC_Path"
                                  disabled={list.admission_status === 1}
                                  className={
                                    Boolean(sslcCerficates[0].SSLC_Path)
                                      ? "InputsFile nn_upload_width"
                                      : "InputsFile vv_upload_width"
                                  }
                                  onChange={(e) => handleEdu("sslc", e)}
                                  autoComplete="SSLC_Path"
                                  required
                                />
                              </div>

                              {Boolean(sslcCerficates[0].SSLC_Path) && (
                                <div className="col-md-9 d-flex align-content-center p-0">
                                  <span className="nn_upload_file">
                                    {sslcCerficates[0].original_file_path}
                                  </span>
                                  <span className="material-icons align-middle text-danger verified_upload">
                                    verified
                                  </span>
                                </div>
                              )}
                            </div>

                            {listErrors.SSLC_Path && (
                              <p className="errors">{listErrors.SSLC_Path}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {educationQualification.includes("HSC") && (
                <section className="sectionFive">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">HSC</p>

                      {/* --- Certificate Number --- */}
                      <div className="row">
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="HSC_CNo">Certificate Number</label>
                            <input
                              ref={txtAdHslc}
                              id="HSC_CNo"
                              type="text"
                              name="HSC_CNo"
                              minLength={10}
                              maxLength={10}
                              disabled={list.admission_status === 1}
                              className="Inputs"
                              onChange={(e) => handleEdu("hsc", e)}
                              placeholder="Certificate Number"
                              value={sslcCerficates[1].HSC_CNo}
                              autoComplete="Certificate Number"
                              required
                            />
                            {listErrors.HSC_CNo && (
                              <p className="errors">{listErrors.HSC_CNo}</p>
                            )}
                          </div>
                        </div>

                        {/* --- Year of Passing --- */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms mock-interview">
                            <label htmlFor="HSC_Year">Year of Passing</label>

                            <MonthDatePicker
                              handleYearChange={handleYearChange_month}
                              handleMonthChange={handleMonthChange_month}
                              minDate={
                                Boolean(sslcCerficates[0].SSLC_Year)
                                  ? sslcCerficates[0].SSLC_Year
                                  : ""
                              }
                              disabledProperty={list.admission_status === 1}
                              dname="hsc"
                              txtAdSpass={txtAdHpass}
                              name="HSC_Year"
                              handleChange={handleEYDate}
                              fieldInput={sslcCerficates[1].HSC_Year}
                            />

                            {listErrors.HSC_Year && (
                              <p className="errors">{listErrors.HSC_Year}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* --- Marks & Board --- */}
                      <div className="row">
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="HSC_Marks">Marks Percentage</label>
                            <input
                              ref={txtAdHmarks}
                              id="HSC_Marks"
                              type="number"
                              name="HSC_Marks"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("hsc", e)}
                              placeholder="Marks Percentage"
                              value={sslcCerficates[1].HSC_Marks}
                              autoComplete="Marks Percentage"
                              required
                            />
                            {listErrors.HSC_Marks && (
                              <p className="errors">{listErrors.HSC_Marks}</p>
                            )}
                          </div>
                        </div>

                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="HSC_Ebaord">Education Board</label>
                            <select
                              ref={txtAdHboard}
                              id="HSC_Ebaord"
                              name="HSC_Ebaord"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("hsc", e)}
                              defaultValue={sslcCerficates[1].HSC_Ebaord}
                              required
                            >
                              <option value="" disabled>
                                Please select
                              </option>
                              <option>State board</option>
                              <option>Matriculation</option>
                              <option>CBSE</option>
                              <option>ICSE</option>
                              <option>others</option>
                            </select>

                            {listErrors.HSC_Ebaord && (
                              <p className="errors">{listErrors.HSC_Ebaord}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* --- Medium & School --- */}
                      <div className="row mb-4">
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="HSC_MI">
                              Medium of Instruction
                            </label>
                            <select
                              ref={txtAdHins}
                              id="HSC_MI"
                              name="HSC_MI"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("hsc", e)}
                              defaultValue={sslcCerficates[1].HSC_MI}
                              required
                            >
                              <option value="" disabled>
                                Please select
                              </option>
                              <option>Tamil Medium</option>
                              <option>English Medium</option>
                            </select>

                            {listErrors.HSC_MI && (
                              <p className="errors">{listErrors.HSC_MI}</p>
                            )}
                          </div>
                        </div>

                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="HSC_Scl">School Name</label>
                            <input
                              ref={txtAdHschool}
                              id="HSC_Scl"
                              type="text"
                              name="HSC_Scl"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("hsc", e)}
                              placeholder="School Name"
                              value={sslcCerficates[1].HSC_Scl}
                              autoComplete="SchoolName"
                              required
                            />
                            {listErrors.HSC_Scl && (
                              <p className="errors">{listErrors.HSC_Scl}</p>
                            )}
                          </div>
                        </div>

                        {/* --- Upload --- */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="HSC_Path">
                              Upload HSC Certificate (pdf/Image)
                              <span className="optionFields">(Optional)</span>
                              {Boolean(sslcCerficates[1].HSC_Path) && (
                                <a
                                  href={`${ImageUrlPrefix}/${sslcCerficates[1].HSC_Path}`}
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons download_icon align-middle text-danger">
                                    file_download
                                  </span>
                                </a>
                              )}
                            </label>

                            <div className="row">
                              <div
                                className={
                                  Boolean(sslcCerficates[1].HSC_Path)
                                    ? "col-md-3"
                                    : "col-md-12"
                                }
                              >
                                <input
                                  ref={txtAdHfile}
                                  id="HSC_Path"
                                  type="file"
                                  name="HSC_Path"
                                  className={
                                    Boolean(sslcCerficates[1].HSC_Path)
                                      ? "InputsFile nn_upload_width"
                                      : "InputsFile vv_upload_width"
                                  }
                                  disabled={list.admission_status === 1}
                                  onChange={(e) => handleEdu("hsc", e)}
                                  autoComplete="HSC_Path"
                                  required
                                />
                              </div>

                              {Boolean(sslcCerficates[1].HSC_Path) && (
                                <div className="col-md-9 d-flex align-content-center p-0">
                                  <span className="nn_upload_file">
                                    {sslcCerficates[1].original_file_path}
                                  </span>
                                  <span className="material-icons align-middle text-danger verified_upload">
                                    verified
                                  </span>
                                </div>
                              )}
                            </div>

                            {listErrors.HSC_Path && (
                              <p className="errors">{listErrors.HSC_Path}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {educationQualification.includes("UG") && (
                <section className="sectionFive">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">UG</p>

                      {/* --- Degree & Major --- */}
                      <div className="row">
                        {/* Degree */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="UGDegree">Degree</label>
                            <Select
                              ref={txtAdUdeg}
                              id="UGDegree"
                              name="UGDegree"
                              isDisabled={list.admission_status === 1}
                              value={ugOption.UG}
                              onChange={(option) =>
                                handleEdus(option, "UG", "UGDegree")
                              }
                              options={ugDegree.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable={true}
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />
                            {listErrors.UGDegree && (
                              <p className="errors">{listErrors.UGDegree}</p>
                            )}
                          </div>
                        </div>

                        {/* Major */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="UGMajor">Major</label>
                            <Select
                              ref={txtAdUMaj}
                              id="UGMajor"
                              name="UGMajor"
                              isDisabled={list.admission_status === 1}
                              value={mOption.UGMajor}
                              onChange={(option) =>
                                handleEduMajor(option, "UG", "UGMajor")
                              }
                              options={major.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable={true}
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />
                            {listErrors.UGMajor && (
                              <p className="errors">{listErrors.UGMajor}</p>
                            )}
                          </div>
                        </div>

                        {/* Major Other */}
                        {uGisOther && (
                          <div className="col-md-6 col-sm-12">
                            <div className="forms">
                              <label htmlFor="UGMajor_Other">
                                Major (Other)
                              </label>
                              <input
                                ref={txtAdUMajOther}
                                id="UGMajor_Other"
                                type="text"
                                name="UGMajor_Other"
                                className="Inputs"
                                disabled={list.admission_status === 1}
                                onChange={(e) => handleEdu("UG", e)}
                                placeholder="Enter major"
                                value={sslcCerficates[2].UGMajor_Other}
                                required
                              />
                              {listErrors.UGMajor_Other && (
                                <p className="errors">
                                  {listErrors.UGMajor_Other}
                                </p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* --- Year of Passing & Certificate Number --- */}
                      <div className="row">
                        {/* Year Passing */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms mock-interview">
                            <label htmlFor="UGYearpassing">
                              Year of Passing
                            </label>

                            <MonthDatePicker
                              handleYearChange={handleYearChange_month}
                              handleMonthChange={handleMonthChange_month}
                              minDate={
                                Boolean(sslcCerficates[1].HSC_Year)
                                  ? sslcCerficates[1].HSC_Year
                                  : Boolean(sslcCerficates[0].SSLC_Year)
                                  ? sslcCerficates[0].SSLC_Year
                                  : ""
                              }
                              disabledProperty={list.admission_status === 1}
                              dname="UG"
                              txtAdSpass={txtAdUpass}
                              name="UGYearpassing"
                              handleChange={handleEYDate}
                              fieldInput={sslcCerficates[2].UGYearpassing}
                            />

                            {listErrors.UGYearpassing && (
                              <p className="errors">
                                {listErrors.UGYearpassing}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Certificate Number */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="UGCertificateNumber">
                              Certificate Number
                            </label>
                            <input
                              ref={txtAdUCer}
                              id="UGCertificateNumber"
                              type="text"
                              name="UGCertificateNumber"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("UG", e)}
                              placeholder="Certificate Number"
                              value={sslcCerficates[2].UGCertificateNumber}
                              minLength={10}
                              maxLength={10}
                              required
                            />
                            {listErrors.UGCertificateNumber && (
                              <p className="errors">
                                {listErrors.UGCertificateNumber}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* --- Marks & Class --- */}
                      <div className="row">
                        {/* Marks */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="UGMarksPercentage">
                              Marks Percentage
                            </label>
                            <input
                              ref={txtAdUmarks}
                              id="UGMarksPercentage"
                              type="number"
                              name="UGMarksPercentage"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("UG", e)}
                              placeholder="Marks Percentage"
                              value={sslcCerficates[2].UGMarksPercentage}
                              required
                            />
                            {listErrors.UGMarksPercentage && (
                              <p className="errors">
                                {listErrors.UGMarksPercentage}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Class */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="UGClassName">Class</label>
                            <Select
                              ref={txtAdUclass}
                              id="UGClassName"
                              name="UGClassName"
                              isDisabled={list.admission_status === 1}
                              value={mOption.UGClassName}
                              onChange={(option) =>
                                handleEduMajor(option, "UG", "UGClassName")
                              }
                              options={classOption.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable={true}
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />
                            {listErrors.UGClassName && (
                              <p className="errors">{listErrors.UGClassName}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* --- College Name & Upload --- */}
                      <div className="row mb-4">
                        {/* College Name */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="UGNameInstitute">
                              Name of the college / university
                            </label>
                            <input
                              ref={txtAdUins}
                              id="UGNameInstitute"
                              type="text"
                              name="UGNameInstitute"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("UG", e)}
                              placeholder="Name of the college / university"
                              value={sslcCerficates[2].UGNameInstitute}
                              required
                            />
                            {listErrors.UGNameInstitute && (
                              <p className="errors">
                                {listErrors.UGNameInstitute}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Upload */}
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="UG_Path">
                              Upload Certificate (pdf/Image)
                              <span className="optionFields">(Optional)</span>
                              {Boolean(sslcCerficates[2].UG_Path) && (
                                <a
                                  href={`${ImageUrlPrefix}/${sslcCerficates[2].UG_Path}`}
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span>
                                </a>
                              )}
                            </label>

                            <div className="row">
                              <div
                                className={
                                  Boolean(sslcCerficates[2].UG_Path)
                                    ? "col-md-3"
                                    : "col-md-12"
                                }
                              >
                                <input
                                  ref={txtAdUfile}
                                  id="UG_Path"
                                  type="file"
                                  name="UG_Path"
                                  className={
                                    Boolean(sslcCerficates[2].UG_Path)
                                      ? "InputsFile nn_upload_width"
                                      : "InputsFile vv_upload_width"
                                  }
                                  disabled={list.admission_status === 1}
                                  onChange={(e) => handleEdu("UG", e)}
                                  required
                                />
                              </div>

                              {Boolean(sslcCerficates[2].UG_Path) && (
                                <div className="col-md-9 d-flex align-content-center p-0">
                                  <span className="nn_upload_file">
                                    {sslcCerficates[2].original_file_path}
                                  </span>
                                  <span className="material-icons align-middle text-danger verified_upload">
                                    verified
                                  </span>
                                </div>
                              )}
                            </div>

                            {listErrors.UG_Path && (
                              <p className="errors">{listErrors.UG_Path}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {educationQualification.includes("PG") && (
                <section className="sectionFive">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">PG</p>

                      {/* ---------------- DEGREE & MAJOR ---------------- */}
                      <div className="row">
                        {/* Degree */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PGDegree">Degree</label>
                            <Select
                              id="PGDegree"
                              ref={txtAdPdeg}
                              name="PGDegree"
                              isDisabled={list.admission_status === 1}
                              value={ugOption.PG}
                              onChange={(option) =>
                                handleEdus(option, "PG", "PGDegree")
                              }
                              options={pgDegree.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable={true}
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {listErrors.PGDegree && (
                              <p className="errors">{listErrors.PGDegree}</p>
                            )}
                          </div>
                        </div>

                        {/* Major */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PGMajor">Major</label>
                            <Select
                              id="PGMajor"
                              ref={txtAdPMaj}
                              name="PGMajor"
                              isDisabled={list.admission_status === 1}
                              value={mOption.PGMajor}
                              onChange={(option) =>
                                handleEduMajor(option, "PG", "PGMajor")
                              }
                              options={pgMajor.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable={true}
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {listErrors.PGMajor && (
                              <p className="errors">{listErrors.PGMajor}</p>
                            )}
                          </div>
                        </div>

                        {/* Major Other */}
                        {pGisOther && (
                          <div className="col-md-6 col-sm-12">
                            <div className="forms">
                              <label htmlFor="PGMajor_Other">
                                Major (Other)
                              </label>
                              <input
                                id="PGMajor_Other"
                                ref={txtAdPMajOther}
                                type="text"
                                name="PGMajor_Other"
                                className="Inputs"
                                disabled={list.admission_status === 1}
                                onChange={(e) => handleEdu("PG", e)}
                                defaultValue={sslcCerficates[3].PGMajor_Other}
                                required
                                placeholder="Please enter major"
                              />

                              {listErrors.PGMajor_Other && (
                                <p className="errors">
                                  {listErrors.PGMajor_Other}
                                </p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* ---------------- YEAR OF PASSING & CERTIFICATE NUMBER ---------------- */}
                      <div className="row">
                        {/* Year Passing */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms mock-interview">
                            <label htmlFor="PGYearpassing">
                              Year of Passing
                            </label>

                            <MonthDatePicker
                              handleYearChange={handleYearChange_month}
                              handleMonthChange={handleMonthChange_month}
                              minDate={
                                Boolean(sslcCerficates[1].HSC_Year)
                                  ? sslcCerficates[1].HSC_Year
                                  : Boolean(sslcCerficates[0].SSLC_Year)
                                  ? sslcCerficates[0].SSLC_Year
                                  : ""
                              }
                              disabledProperty={list.admission_status === 1}
                              dname="PG"
                              txtAdSpass={txtAdPpass}
                              name="PGYearpassing"
                              handleChange={handleEYDate}
                              fieldInput={sslcCerficates[3].PGYearpassing}
                            />

                            {listErrors.PGYearpassing && (
                              <p className="errors">
                                {listErrors.PGYearpassing}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Certificate Number */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PGCertificateNumber">
                              Certificate Number
                            </label>
                            <input
                              ref={txtAdPCer}
                              id="PGCertificateNumber"
                              type="text"
                              name="PGCertificateNumber"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("PG", e)}
                              placeholder="Certificate Number"
                              value={sslcCerficates[3].PGCertificateNumber}
                              minLength={10}
                              maxLength={10}
                              required
                            />

                            {listErrors.PGCertificateNumber && (
                              <p className="errors">
                                {listErrors.PGCertificateNumber}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ---------------- MARKS & CLASS ---------------- */}
                      <div className="row">
                        {/* Marks */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PGMarksPercentage">
                              Marks Percentage
                            </label>
                            <input
                              ref={txtAdPmarks}
                              id="PGMarksPercentage"
                              type="number"
                              name="PGMarksPercentage"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("PG", e)}
                              placeholder="Marks Percentage"
                              value={sslcCerficates[3].PGMarksPercentage}
                              required
                            />

                            {listErrors.PGMarksPercentage && (
                              <p className="errors">
                                {listErrors.PGMarksPercentage}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Class */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PGClassName">Class</label>
                            <Select
                              ref={txtAdPclass}
                              id="PGClassName"
                              name="PGClassName"
                              isDisabled={list.admission_status === 1}
                              value={mOption.PGClassName}
                              onChange={(option) =>
                                handleEduMajor(option, "PG", "PGClassName")
                              }
                              options={classOption.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable={true}
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {listErrors.PGClassName && (
                              <p className="errors">{listErrors.PGClassName}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ---------------- COLLEGE NAME & UPLOAD ---------------- */}
                      <div className="row mb-4">
                        {/* College Name */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PGNameInstitute">
                              Name of the college / university
                            </label>
                            <input
                              ref={txtAdPins}
                              id="PGNameInstitute"
                              type="text"
                              name="PGNameInstitute"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("PG", e)}
                              placeholder="Name of the college / university"
                              value={sslcCerficates[3].PGNameInstitute}
                              required
                            />

                            {listErrors.PGNameInstitute && (
                              <p className="errors">
                                {listErrors.PGNameInstitute}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Upload Certificate */}
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PG_Path">
                              Upload Certificate (pdf/Image)
                              <span className="optionFields">(Optional)</span>
                              {Boolean(sslcCerficates[3].PG_Path) && (
                                <a
                                  href={`${ImageUrlPrefix}/${sslcCerficates[3].PG_Path}`}
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span>
                                </a>
                              )}
                            </label>

                            <div className="row">
                              <div
                                className={
                                  Boolean(sslcCerficates[3].PG_Path)
                                    ? "col-md-3"
                                    : "col-md-12"
                                }
                              >
                                <input
                                  ref={txtAdPfile}
                                  id="PG_Path"
                                  type="file"
                                  name="PG_Path"
                                  disabled={list.admission_status === 1}
                                  className={
                                    Boolean(sslcCerficates[3].PG_Path)
                                      ? "InputsFile nn_upload_width"
                                      : "InputsFile vv_upload_width"
                                  }
                                  onChange={(e) => handleEdu("PG", e)}
                                  required
                                />
                              </div>

                              {Boolean(sslcCerficates[3].PG_Path) && (
                                <div className="col-md-9 d-flex align-content-center p-0">
                                  <span className="nn_upload_file">
                                    {sslcCerficates[3].original_file_path}
                                  </span>
                                  <span className="material-icons align-middle text-danger verified_upload">
                                    verified
                                  </span>
                                </div>
                              )}
                            </div>

                            {listErrors.PG_Path && (
                              <p className="errors">{listErrors.PG_Path}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {educationQualification.includes("Integrated PG") && (
                <section className="sectionFive">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Integrated PG</p>

                      {/* ---------------- DEGREE & MAJOR ---------------- */}
                      <div className="row">
                        {/* Degree */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="IPDegree">Degree</label>
                            <Select
                              ref={txtAdIdeg}
                              id="IPDegree"
                              name="IPDegree"
                              isDisabled={list.admission_status === 1}
                              value={ugOption.Integrated_PG}
                              onChange={(option) =>
                                handleEdus(option, "Integrated PG", "IPDegree")
                              }
                              options={ipgDegree.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable={true}
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {listErrors.IPDegree && (
                              <p className="errors">{listErrors.IPDegree}</p>
                            )}
                          </div>
                        </div>

                        {/* Major */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="IPMajor">Major</label>
                            <Select
                              ref={txtAdIMaj}
                              id="IPMajor"
                              name="IPMajor"
                              isDisabled={list.admission_status === 1}
                              value={mOption.IPMajor}
                              onChange={(option) =>
                                handleEduMajor(
                                  option,
                                  "Integrated PG",
                                  "IPMajor"
                                )
                              }
                              options={ipMajor.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable={true}
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {listErrors.IPMajor && (
                              <p className="errors">{listErrors.IPMajor}</p>
                            )}
                          </div>
                        </div>

                        {/* Major (Other) */}
                        {iPGisOther && (
                          <div className="col-md-6 col-sm-12">
                            <div className="forms">
                              <label htmlFor="IPMajor_Other">
                                Major (Other)
                              </label>
                              <input
                                ref={txtAdIMajOther}
                                id="IPMajor_Other"
                                type="text"
                                name="IPMajor_Other"
                                className="Inputs"
                                disabled={list.admission_status === 1}
                                onChange={(e) => handleEdu("Integrated PG", e)}
                                value={sslcCerficates[4].IPMajor_Other}
                                placeholder="Please enter major"
                                required
                              />

                              {listErrors.IPMajor_Other && (
                                <p className="errors">
                                  {listErrors.IPMajor_Other}
                                </p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* ---------------- YEAR OF PASSING & CERTIFICATE NUMBER ---------------- */}
                      <div className="row">
                        {/* Year Passing */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms mock-interview">
                            <label htmlFor="IPYearpassing">
                              Year of Passing
                            </label>

                            <MonthDatePicker
                              handleYearChange={handleYearChange_month}
                              handleMonthChange={handleMonthChange_month}
                              minDate={
                                Boolean(sslcCerficates[1].HSC_Year)
                                  ? sslcCerficates[1].HSC_Year
                                  : Boolean(sslcCerficates[0].SSLC_Year)
                                  ? sslcCerficates[0].SSLC_Year
                                  : ""
                              }
                              disabledProperty={list.admission_status === 1}
                              dname="Integrated PG"
                              txtAdSpass={txtAdIpass}
                              name="IPYearpassing"
                              handleChange={handleEYDate}
                              fieldInput={sslcCerficates[4].IPYearpassing}
                            />

                            {listErrors.IPYearpassing && (
                              <p className="errors">
                                {listErrors.IPYearpassing}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Certificate Number */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="IPCertificateNumber">
                              Certificate Number
                            </label>
                            <input
                              ref={txtAdICer}
                              id="IPCertificateNumber"
                              type="text"
                              name="IPCertificateNumber"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("Integrated PG", e)}
                              placeholder="Certificate Number"
                              value={sslcCerficates[4].IPCertificateNumber}
                              minLength={10}
                              maxLength={10}
                              required
                            />

                            {listErrors.IPCertificateNumber && (
                              <p className="errors">
                                {listErrors.IPCertificateNumber}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ---------------- MARKS & CLASS ---------------- */}
                      <div className="row">
                        {/* Marks */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="IPMarksPercentage">
                              Marks Percentage
                            </label>
                            <input
                              ref={txtAdImarks}
                              id="IPMarksPercentage"
                              type="number"
                              name="IPMarksPercentage"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("Integrated PG", e)}
                              placeholder="Marks Percentage"
                              value={sslcCerficates[4].IPMarksPercentage}
                              required
                            />

                            {listErrors.IPMarksPercentage && (
                              <p className="errors">
                                {listErrors.IPMarksPercentage}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Class */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="IPClassName">Class</label>
                            <Select
                              ref={txtAdIclass}
                              id="IPClassName"
                              name="IPClassName"
                              isDisabled={list.admission_status === 1}
                              value={mOption.IPClassName}
                              onChange={(option) =>
                                handleEduMajor(
                                  option,
                                  "Integrated PG",
                                  "IPClassName"
                                )
                              }
                              options={classOption.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable={true}
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {listErrors.IPClassName && (
                              <p className="errors">{listErrors.IPClassName}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ---------------- COLLEGE NAME & FILE UPLOAD ---------------- */}
                      <div className="row mb-4">
                        {/* Institute Name */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="IPNameInstitute">
                              Name of the college / university
                            </label>
                            <input
                              ref={txtAdIins}
                              id="IPNameInstitute"
                              type="text"
                              name="IPNameInstitute"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              onChange={(e) => handleEdu("Integrated PG", e)}
                              placeholder="Name of the college / university"
                              value={sslcCerficates[4].IPNameInstitute}
                              required
                            />

                            {listErrors.IPNameInstitute && (
                              <p className="errors">
                                {listErrors.IPNameInstitute}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Upload */}
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="IP_Path">
                              Upload Certificate (pdf/Image)
                              <span className="optionFields">(Optional)</span>
                              {Boolean(sslcCerficates[4].IP_Path) && (
                                <a
                                  href={`${ImageUrlPrefix}/${sslcCerficates[4].IP_Path}`}
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span>
                                </a>
                              )}
                            </label>

                            <div className="row">
                              <div
                                className={
                                  Boolean(sslcCerficates[4].IP_Path)
                                    ? "col-md-3"
                                    : "col-md-12"
                                }
                              >
                                <input
                                  ref={txtAdIfile}
                                  id="IP_Path"
                                  type="file"
                                  name="IP_Path"
                                  className={
                                    Boolean(sslcCerficates[4].IP_Path)
                                      ? "InputsFile nn_upload_width"
                                      : "InputsFile vv_upload_width"
                                  }
                                  disabled={list.admission_status === 1}
                                  onChange={(e) =>
                                    handleEdu("Integrated PG", e)
                                  }
                                  required
                                />
                              </div>

                              {Boolean(sslcCerficates[4].IP_Path) && (
                                <div className="col-md-9 d-flex align-content-center p-0">
                                  <span className="nn_upload_file">
                                    {sslcCerficates[4].original_file_path}
                                  </span>
                                  <span className="material-icons align-middle text-danger verified_upload">
                                    verified
                                  </span>
                                </div>
                              )}
                            </div>

                            {listErrors.IP_Path && (
                              <p className="errors">{listErrors.IP_Path}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {educationQualification.includes("Diploma") && (
                <section className="sectionFive">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Diploma</p>

                      {/* ---------------- DEGREE & MAJOR ---------------- */}
                      <div className="row">
                        {/* Degree */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="DDegree">Diploma</label>
                            <Select
                              ref={txtAdDdeg}
                              id="DDegree"
                              name="DDegree"
                              isDisabled={list.admission_status === 1}
                              value={ugOption.Diploma}
                              onChange={(option) =>
                                handleEdus(option, "Diploma", "DDegree")
                              }
                              options={diplomaDegree.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {listErrors.DDegree && (
                              <p className="errors">{listErrors.DDegree}</p>
                            )}
                          </div>
                        </div>

                        {/* Major */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="DMajor">Major</label>
                            <Select
                              ref={txtAdDMaj}
                              id="DMajor"
                              name="DMajor"
                              isDisabled={list.admission_status === 1}
                              value={mOption.DMajor}
                              onChange={(option) =>
                                handleEduMajor(option, "Diploma", "DMajor")
                              }
                              options={dmajor.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {listErrors.DMajor && (
                              <p className="errors">{listErrors.DMajor}</p>
                            )}
                          </div>
                        </div>

                        {/* Major (Other) */}
                        {dipisOther && (
                          <div className="col-md-6 col-sm-12">
                            <div className="forms">
                              <label htmlFor="DMajor_other">Major</label>
                              <input
                                ref={txtAdDMajOther}
                                id="DMajor_other"
                                name="DMajor_other"
                                type="text"
                                className="Inputs"
                                disabled={list.admission_status === 1}
                                placeholder="Please Enter Major"
                                onChange={(e) => handleEdu("Diploma", e)}
                                value={sslcCerficates[5].DMajor_other}
                                required
                              />

                              {listErrors.DMajor_other && (
                                <p className="errors">
                                  {listErrors.DMajor_other}
                                </p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* ---------------- YEAR & CERTIFICATE NUMBER ---------------- */}
                      <div className="row">
                        {/* Year Passing */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms mock-interview">
                            <label htmlFor="DYearpassing">
                              Year of Passing
                            </label>

                            <MonthDatePicker
                              handleYearChange={handleYearChange_month}
                              handleMonthChange={handleMonthChange_month}
                              minDate={
                                Boolean(sslcCerficates[1].HSC_Year)
                                  ? sslcCerficates[1].HSC_Year
                                  : Boolean(sslcCerficates[0].SSLC_Year)
                                  ? sslcCerficates[0].SSLC_Year
                                  : ""
                              }
                              disabledProperty={list.admission_status === 1}
                              dname="Diploma"
                              txtAdSpass={txtAdDpass}
                              name="DYearpassing"
                              handleChange={handleEYDate}
                              fieldInput={sslcCerficates[5].DYearpassing}
                            />

                            {listErrors.DYearpassing && (
                              <p className="errors">
                                {listErrors.DYearpassing}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Certificate Number */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="DCertificateNumber">
                              Certificate Number
                            </label>
                            <input
                              ref={txtAdDCer}
                              id="DCertificateNumber"
                              type="text"
                              name="DCertificateNumber"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              placeholder="Certificate Number"
                              value={sslcCerficates[5].DCertificateNumber}
                              minLength={10}
                              maxLength={10}
                              required
                              onChange={(e) => handleEdu("Diploma", e)}
                            />

                            {listErrors.DCertificateNumber && (
                              <p className="errors">
                                {listErrors.DCertificateNumber}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ---------------- MARKS & CLASS ---------------- */}
                      <div className="row">
                        {/* Marks */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="DMarksPercentage">
                              Marks Percentage
                            </label>
                            <input
                              ref={txtAdDmarks}
                              id="DMarksPercentage"
                              type="number"
                              name="DMarksPercentage"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              placeholder="Marks Percentage"
                              value={sslcCerficates[5].DMarksPercentage}
                              required
                              onChange={(e) => handleEdu("Diploma", e)}
                            />

                            {listErrors.DMarksPercentage && (
                              <p className="errors">
                                {listErrors.DMarksPercentage}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Class */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="DClassName">Class</label>
                            <Select
                              ref={txtAdDclass}
                              id="DClassName"
                              name="DClassName"
                              isDisabled={list.admission_status === 1}
                              value={mOption.DClassName}
                              onChange={(option) =>
                                handleEduMajor(option, "Diploma", "DClassName")
                              }
                              options={classOption.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {listErrors.DClassName && (
                              <p className="errors">{listErrors.DClassName}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ---------------- INSTITUTE NAME & FILE UPLOAD ---------------- */}
                      <div className="row mb-4">
                        {/* Institute Name */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="DNameInstitute">
                              Name of the college / university
                            </label>
                            <input
                              ref={txtAdDins}
                              id="DNameInstitute"
                              type="text"
                              name="DNameInstitute"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              placeholder="Name of the college / university"
                              value={sslcCerficates[5].DNameInstitute}
                              required
                              onChange={(e) => handleEdu("Diploma", e)}
                            />

                            {listErrors.DNameInstitute && (
                              <p className="errors">
                                {listErrors.DNameInstitute}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Upload */}
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="D_Path">
                              Upload Certificate (In pdf/Image format)
                              <span className="optionFields">(Optional)</span>
                              {Boolean(sslcCerficates[5].D_Path) && (
                                <a
                                  href={`${ImageUrlPrefix}/${sslcCerficates[5].D_Path}`}
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span>
                                </a>
                              )}
                            </label>

                            <div className="row">
                              <div
                                className={
                                  Boolean(sslcCerficates[5].D_Path)
                                    ? "col-md-3"
                                    : "col-md-12"
                                }
                              >
                                <input
                                  ref={txtAdDfile}
                                  id="D_Path"
                                  type="file"
                                  name="D_Path"
                                  className={
                                    Boolean(sslcCerficates[5].D_Path)
                                      ? "InputsFile nn_upload_width"
                                      : "InputsFile vv_upload_width"
                                  }
                                  disabled={list.admission_status === 1}
                                  onChange={(e) => handleEdu("Diploma", e)}
                                  required
                                />
                              </div>

                              {Boolean(sslcCerficates[5].D_Path) && (
                                <div className="col-md-9 d-flex align-content-center p-0">
                                  <span className="nn_upload_file">
                                    {sslcCerficates[5].original_file_path}
                                  </span>
                                  <span className="material-icons align-middle text-danger verified_upload">
                                    verified
                                  </span>
                                </div>
                              )}
                            </div>

                            {listErrors.D_Path && (
                              <p className="errors">{listErrors.D_Path}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {educationQualification.includes("Professional Courses") && (
                <section className="sectionFive">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Professional Courses</p>

                      {/* ---------------- DEGREE & MAJOR ---------------- */}
                      <div className="row">
                        {/* Degree */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PCDegree">Degree</label>
                            <Select
                              ref={txtAdCdeg}
                              id="PCDegree"
                              name="PCDegree"
                              isDisabled={list.admission_status === 1}
                              value={ugOption.Professional_Courses}
                              onChange={(option) =>
                                handleEdus(
                                  option,
                                  "Professional Courses",
                                  "PCDegree"
                                )
                              }
                              options={pcDegree.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {listErrors.PCDegree && (
                              <p className="errors">{listErrors.PCDegree}</p>
                            )}
                          </div>
                        </div>

                        {/* Major */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PCMajor">Major</label>
                            <Select
                              ref={txtAdCMaj}
                              id="PCMajor"
                              name="PCMajor"
                              isDisabled={list.admission_status === 1}
                              value={mOption.PCMajor}
                              onChange={(option) =>
                                handleEduMajor(
                                  option,
                                  "Professional Courses",
                                  "PCMajor"
                                )
                              }
                              options={pcMajor.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {listErrors.PCMajor && (
                              <p className="errors">{listErrors.PCMajor}</p>
                            )}
                          </div>
                        </div>

                        {/* Major Other */}
                        {pCisOther && (
                          <div className="col-md-6 col-sm-12">
                            <div className="forms">
                              <label htmlFor="PCMajor_Other">Major</label>
                              <input
                                ref={txtAdCMajOther}
                                id="PCMajor_Other"
                                name="PCMajor_Other"
                                type="text"
                                className="Inputs"
                                disabled={list.admission_status === 1}
                                placeholder="Please Enter Major"
                                defaultValue={sslcCerficates[6].PCMajor_Other}
                                onChange={(e) =>
                                  handleEdu("Professional Courses", e)
                                }
                                required
                              />

                              {listErrors.PCMajor_Other && (
                                <p className="errors">
                                  {listErrors.PCMajor_Other}
                                </p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* ---------------- YEAR & CERTIFICATE NUMBER ---------------- */}
                      <div className="row">
                        {/* Year Passing */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms mock-interview">
                            <label htmlFor="PCYearpassing">
                              Year of Passing
                            </label>

                            <MonthDatePicker
                              handleYearChange={handleYearChange_month}
                              handleMonthChange={handleMonthChange_month}
                              minDate={
                                Boolean(sslcCerficates[1].HSC_Year)
                                  ? sslcCerficates[1].HSC_Year
                                  : Boolean(sslcCerficates[0].SSLC_Year)
                                  ? sslcCerficates[0].SSLC_Year
                                  : ""
                              }
                              disabledProperty={list.admission_status === 1}
                              dname="Professional Courses"
                              txtAdSpass={txtAdCpass}
                              name="PCYearpassing"
                              handleChange={handleEYDate}
                              fieldInput={sslcCerficates[6].PCYearpassing}
                            />

                            {listErrors.PCYearpassing && (
                              <p className="errors">
                                {listErrors.PCYearpassing}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Certificate Number */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PCCertificateNumber">
                              Certificate Number
                            </label>
                            <input
                              ref={txtAdCCer}
                              id="PCCertificateNumber"
                              name="PCCertificateNumber"
                              type="text"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              placeholder="Certificate Number"
                              value={sslcCerficates[6].PCCertificateNumber}
                              minLength={10}
                              maxLength={10}
                              onChange={(e) =>
                                handleEdu("Professional Courses", e)
                              }
                              required
                            />

                            {listErrors.PCCertificateNumber && (
                              <p className="errors">
                                {listErrors.PCCertificateNumber}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ---------------- MARKS & CLASS ---------------- */}
                      <div className="row">
                        {/* Marks */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PCMarksPercentage">
                              Marks Percentage
                            </label>
                            <input
                              ref={txtAdCmarks}
                              id="PCMarksPercentage"
                              name="PCMarksPercentage"
                              type="number"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              placeholder="Marks Percentage"
                              value={sslcCerficates[6].PCMarksPercentage}
                              onChange={(e) =>
                                handleEdu("Professional Courses", e)
                              }
                              required
                            />

                            {listErrors.PCMarksPercentage && (
                              <p className="errors">
                                {listErrors.PCMarksPercentage}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Class */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PCClassName">Class</label>
                            <Select
                              ref={txtAdCclass}
                              id="PCClassName"
                              name="PCClassName"
                              isDisabled={list.admission_status === 1}
                              value={mOption.PCClassName}
                              onChange={(option) =>
                                handleEduMajor(
                                  option,
                                  "Professional Courses",
                                  "PCClassName"
                                )
                              }
                              options={classOption.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {listErrors.PCClassName && (
                              <p className="errors">{listErrors.PCClassName}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ---------------- INSTITUTE NAME & FILE UPLOAD ---------------- */}
                      <div className="row mb-4">
                        {/* Institute Name */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PCNameInstitute">
                              Name of the college / university
                            </label>
                            <input
                              ref={txtAdCins}
                              id="PCNameInstitute"
                              name="PCNameInstitute"
                              type="text"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              placeholder="Name of the college / university"
                              value={sslcCerficates[6].PCNameInstitute}
                              onChange={(e) =>
                                handleEdu("Professional Courses", e)
                              }
                              required
                            />

                            {listErrors.PCNameInstitute && (
                              <p className="errors">
                                {listErrors.PCNameInstitute}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Upload */}
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="PC_Path">
                              Upload Certificate (In pdf/Image format)
                              <span className="optionFields">(Optional)</span>
                              {Boolean(sslcCerficates[6].PC_Path) && (
                                <a
                                  href={`${ImageUrlPrefix}/${sslcCerficates[6].PC_Path}`}
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span>
                                </a>
                              )}
                            </label>

                            <div className="row">
                              <div
                                className={
                                  Boolean(sslcCerficates[6].PC_Path)
                                    ? "col-md-3"
                                    : "col-md-12"
                                }
                              >
                                <input
                                  ref={txtAdCfile}
                                  id="PC_Path"
                                  name="PC_Path"
                                  type="file"
                                  className={
                                    Boolean(sslcCerficates[6].PC_Path)
                                      ? "InputsFile nn_upload_width"
                                      : "InputsFile vv_upload_width"
                                  }
                                  disabled={list.admission_status === 1}
                                  onChange={(e) =>
                                    handleEdu("Professional Courses", e)
                                  }
                                  required
                                />
                              </div>

                              {Boolean(sslcCerficates[6].PC_Path) && (
                                <div className="col-md-9 d-flex align-content-center p-0">
                                  <span className="nn_upload_file">
                                    {sslcCerficates[6].original_file_path}
                                  </span>
                                  <span className="material-icons align-middle text-danger verified_upload">
                                    verified
                                  </span>
                                </div>
                              )}
                            </div>

                            {listErrors.PC_Path && (
                              <p className="errors">{listErrors.PC_Path}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {educationQualification.includes("Others") && (
                <section className="sectionFive">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Others</p>

                      {/* ---------- DEGREE & MAJOR ---------- */}
                      <div className="row">
                        {/* Degree */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="OtDegree">Degree</label>

                            <input
                              ref={txtAdOdeg}
                              id="OtDegree"
                              name="OtDegree"
                              placeholder="Please Enter Degree name"
                              disabled={list.admission_status === 1}
                              className="Inputs"
                              onChange={(e) => handleEdu("Others", e)}
                              value={sslcCerficates[7].OtDegree}
                              required
                            />

                            {listErrors.OtDegree && (
                              <p className="errors">{listErrors.OtDegree}</p>
                            )}
                          </div>
                        </div>

                        {/* Major */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="OtMajor">Major</label>

                            <input
                              ref={txtAdOMaj}
                              id="OtMajor"
                              name="OtMajor"
                              type="text"
                              className="Inputs"
                              placeholder="Please Enter Major"
                              disabled={list.admission_status === 1}
                              defaultValue={sslcCerficates[7].OtMajor}
                              onChange={(e) => handleEdu("Others", e)}
                              required
                            />

                            {listErrors.OtMajor && (
                              <p className="errors">{listErrors.OtMajor}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ---------- YEAR & CERTIFICATE NUMBER ---------- */}
                      <div className="row">
                        {/* Year Passing */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms mock-interview">
                            <label htmlFor="OtYearpassing">
                              Year of Passing
                            </label>

                            <MonthDatePicker
                              handleYearChange={handleYearChange_month}
                              handleMonthChange={handleMonthChange_month}
                              minDate={
                                Boolean(sslcCerficates[1].HSC_Year)
                                  ? sslcCerficates[1].HSC_Year
                                  : Boolean(sslcCerficates[0].SSLC_Year)
                                  ? sslcCerficates[0].SSLC_Year
                                  : ""
                              }
                              disabledProperty={list.admission_status === 1}
                              dname="Others"
                              txtAdSpass={txtAdOpass}
                              name="OtYearpassing"
                              handleChange={handleEYDate}
                              fieldInput={sslcCerficates[7].OtYearpassing}
                            />

                            {listErrors.OtYearpassing && (
                              <p className="errors">
                                {listErrors.OtYearpassing}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Certificate Number */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="OtCertificateNumber">
                              Certificate Number
                            </label>

                            <input
                              ref={txtAdOCer}
                              id="OtCertificateNumber"
                              name="OtCertificateNumber"
                              type="text"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              placeholder="Certificate Number"
                              value={sslcCerficates[7].OtCertificateNumber}
                              autoComplete="Certificate Number"
                              minLength={10}
                              maxLength={10}
                              onChange={(e) => handleEdu("Others", e)}
                              required
                            />

                            {listErrors.OtCertificateNumber && (
                              <p className="errors">
                                {listErrors.OtCertificateNumber}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ---------- MARKS & CLASS ---------- */}
                      <div className="row">
                        {/* Marks */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="OtMarksPercentage">
                              Marks Percentage
                            </label>

                            <input
                              ref={txtAdOmarks}
                              id="OtMarksPercentage"
                              name="OtMarksPercentage"
                              type="number"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              placeholder="Marks Percentage"
                              value={sslcCerficates[7].OtMarksPercentage}
                              onChange={(e) => handleEdu("Others", e)}
                              required
                            />

                            {listErrors.OtMarksPercentage && (
                              <p className="errors">
                                {listErrors.OtMarksPercentage}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Class */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="OtClassName">Class</label>

                            <Select
                              ref={txtAdOclass}
                              id="OtClassName"
                              name="OtClassName"
                              isDisabled={list.admission_status === 1}
                              value={mOption.OtClassName}
                              onChange={(option) =>
                                handleEduMajor(option, "Others", "OtClassName")
                              }
                              options={classOption.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              isSearchable
                              placeholder="Select an option"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option.label
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                              }
                              styles={customStyles}
                            />

                            {listErrors.OtClassName && (
                              <p className="errors">{listErrors.OtClassName}</p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ---------- INSTITUTE & FILE UPLOAD ---------- */}
                      <div className="row mb-4">
                        {/* Institute Name */}
                        <div className="col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="OtNameInstitute">
                              Name of the college / university
                            </label>

                            <input
                              ref={txtAdOins}
                              id="OtNameInstitute"
                              name="OtNameInstitute"
                              type="text"
                              className="Inputs"
                              disabled={list.admission_status === 1}
                              placeholder="Name of the college / university"
                              value={sslcCerficates[7].OtNameInstitute}
                              onChange={(e) => handleEdu("Others", e)}
                              required
                            />

                            {listErrors.OtNameInstitute && (
                              <p className="errors">
                                {listErrors.OtNameInstitute}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* File Upload */}
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="forms">
                            <label htmlFor="Ot_Path">
                              Upload Certificate (In pdf/Image format)
                              <span className="optionFields">(Optional)</span>
                              {Boolean(sslcCerficates[7].Ot_Path) && (
                                <a
                                  href={`${ImageUrlPrefix}/${sslcCerficates[7].Ot_Path}`}
                                  target="_blank"
                                  download
                                >
                                  <span className="material-icons align-middle download_icon">
                                    file_download
                                  </span>
                                </a>
                              )}
                            </label>

                            <div className="row">
                              <div
                                className={
                                  Boolean(sslcCerficates[7].Ot_Path)
                                    ? "col-md-3"
                                    : "col-md-12"
                                }
                              >
                                <input
                                  ref={txtAdOfile}
                                  id="Ot_Path"
                                  name="Ot_Path"
                                  type="file"
                                  className={
                                    Boolean(sslcCerficates[7].Ot_Path)
                                      ? "InputsFile nn_upload_width"
                                      : "InputsFile vv_upload_width"
                                  }
                                  disabled={list.admission_status === 1}
                                  onChange={(e) => handleEdu("Others", e)}
                                  required
                                />
                              </div>

                              {Boolean(sslcCerficates[7].Ot_Path) && (
                                <div className="col-md-9 d-flex align-content-center p-0">
                                  <span className="nn_upload_file">
                                    {sslcCerficates[7].original_file_path}
                                  </span>
                                  <span className="material-icons align-middle text-danger verified_upload">
                                    verified
                                  </span>
                                </div>
                              )}
                            </div>

                            {listErrors.Ot_Path && (
                              <p className="errors">{listErrors.Ot_Path}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {/* //educational section  end */}
              <section className="sectionFive">
                {techQualification.map((item, index) => (
                  <TechQualification
                    key={item.id}
                    admission_status={list.admission_status === 1 ? 1 : 0}
                    length={techQualification.length}
                    AddQualification={AddQualification}
                    DeleteQual={DeleteQual}
                    technicalOption={technicalOption}
                    TechhandleChange={TechhandleChange}
                    TechhandleChange_date={TechhandleChange_date}
                    TechhandleChanges={TechhandleChanges}
                    record={item}
                    index={index}
                  />
                ))}

                <div className="heading mb-4 dflexbetww">
                  <div>
                    <button
                      type="button"
                      className="SaveButton_Prev"
                      onClick={handlePrevious}
                    >
                      <a href="javascript:void(0)">Go to Communication</a>
                    </button>
                  </div>

                  <div className="d-flex smButton mobiledown">
                    <Link to="/" className="CancelButton">
                      Back to Home
                    </Link>

                    <button
                      type="button"
                      className="SaveButtons"
                      onClick={handleNext}
                    >
                      <a href="javascript:void(0)">
                        Save and Continue to Mock Interview Details
                      </a>
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>
        )}

        {/* &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& */}
        {/* {step === 4} */}
        {step === 4 && (
          <div className="row">
            <div className="col-md-12">
              <section className="sectionSix">
                <div className="heading  dflexbetww">
                  <div className="">
                    <button
                      type="button"
                      className="SaveButton_Prev"
                      onClick={handlePrevious}
                    >
                      <a href="javascript:void(0)">Go to Academic Background</a>
                    </button>
                  </div>
                  <div className="d-flex smButton mobiledown">
                    <Link to="/" className="CancelButton">
                      Back to Home
                    </Link>
                    <button
                      type="button"
                      className="SaveButton mockinterview"
                      onClick={handleNext}
                    >
                      <a href="javascript:void(0)">
                        Save and Review Your Information
                      </a>
                    </button>
                  </div>
                </div>

                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Mock Interview Enrollment</p>

                    <div className="row mb-4">
                      {/* CATEGORY BLOCK */}
                      <div className="col-lg-6 col-md-12">
                        <div className="forms ">
                          <label htmlFor="Category">Category </label>
                          <div
                            className="d-flex flex-lg-row flex-md-row flex-column"
                            id="radiobuttons"
                          >
                            <div className="form-check form-check-inline">
                              <input
                                ref={txtAdCate}
                                className="checkbox_radio"
                                type="radio"
                                name="category"
                                id="UPSC"
                                value="UPSC"
                                onChange={handleChange}
                                checked={list.category === "UPSC"}
                              />
                              <label className="checkbox-label" htmlFor="UPSC">
                                UPSC
                              </label>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="category"
                                id="TNPSC"
                                value="TNPSC"
                                checked={list.category === "TNPSC"}
                                onChange={handleChange}
                              />
                              <label className="checkbox-label" htmlFor="TNPSC">
                                TNPSC
                              </label>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="category"
                                id="TRB"
                                value="TRB"
                                checked={list.category === "TRB"}
                                onChange={handleChange}
                              />
                              <label className="checkbox-label" htmlFor="TRB">
                                TRB
                              </label>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="category"
                                id="TET"
                                value="TET"
                                checked={list.category === "TET"}
                                onChange={handleChange}
                              />
                              <label className="checkbox-label" htmlFor="TET">
                                TET
                              </label>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="category"
                                id="TNUSRB"
                                value="TNUSRB"
                                checked={list.category === "TNUSRB"}
                                onChange={handleChange}
                              />
                              <label
                                className="checkbox-label"
                                htmlFor="TNUSRB"
                              >
                                TNUSRB
                              </label>
                            </div>
                          </div>
                          <div
                            className="d-flex flex-lg-row flex-md-row flex-column"
                            id="radiobuttons"
                          >
                            <div className="form-check form-check-inline">
                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="category"
                                id="RRB"
                                value="RRB"
                                checked={list.category === "RRB"}
                                onChange={handleChange}
                              />
                              <label className="checkbox-label" htmlFor="RRB">
                                RRB
                              </label>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="category"
                                id="SSC"
                                value="SSC"
                                checked={list.category === "SSC"}
                                onChange={handleChange}
                              />
                              <label className="checkbox-label" htmlFor="SSC">
                                SSC
                              </label>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="category"
                                id="Banking"
                                value="Banking"
                                checked={list.category === "Banking"}
                                onChange={handleChange}
                              />
                              <label
                                className="checkbox-label"
                                htmlFor="Banking"
                              >
                                Banking
                              </label>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="category"
                                id="Others"
                                value="Others"
                                checked={list.category === "Others"}
                                onChange={handleChange}
                              />
                              <label
                                className="checkbox-label"
                                htmlFor="Others"
                              >
                                Others
                              </label>
                            </div>
                          </div>
                        </div>
                        {listErrors.category && (
                          <small className="errors fw-semibold">
                            {listErrors.category}
                          </small>
                        )}
                      </div>

                      {/* COURSE BLOCK */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="CourseCate">Course</label>

                          <DropdownHeader
                            txtAdCourse={refCourseName}
                            id="CourseCate"
                            name="CourseCate"
                            items={list.courseName}
                            record={mockInterviewCourseSorted}
                            handleChangeCheckbox={handleChangeCheckbox}
                          />

                          {listErrors.courseId && (
                            <p className="errors">{listErrors.courseId}</p>
                          )}
                        </div>
                      </div>

                      {/* MOCK TYPE BLOCK */}
                      <div className="col-lg-6 col-md-12">
                        <div className="forms">
                          <label htmlFor="mockInterviewType">
                            Mock Interview Type
                          </label>

                          <div className="d-flex flex-lg-row flex-md-row flex-column">
                            <div className="form-check form-check-inline">
                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="mockInterviewType"
                                id="Interview"
                                value="0"
                                onChange={handleChange}
                                checked={list.mockInterviewType === "0"}
                              />
                              <label
                                className="checkbox-label"
                                htmlFor="Interview"
                              >
                                Interview
                              </label>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="mockInterviewType"
                                id="Class & Interview"
                                value="1"
                                onChange={handleChange}
                                checked={list.mockInterviewType === "1"}
                              />
                              <label
                                className="checkbox-label"
                                htmlFor="Class & Interview"
                              >
                                Class & Interview
                              </label>
                            </div>
                          </div>
                        </div>

                        {/* {listErrors.category && (
                          <small className="errors fw-semibold">
                            {listErrors.category}
                          </small>
                        )} */}
                      </div>

                      <div className="col-lg-6 col-md-12">
                        <div className="forms">
                          <label htmlFor="modeOfInterview">
                            Mode of Interview
                          </label>

                          <div className="d-flex flex-lg-row flex-md-row flex-column">
                            <div className="form-check form-check-inline">
                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="modeOfInterview"
                                id="Online"
                                value="0"
                                onChange={handleChange}
                                checked={list.modeOfInterview === "0"}
                              />
                              <label
                                className="checkbox-label"
                                htmlFor="Online"
                              >
                                Online
                              </label>
                            </div>

                            <div className="form-check form-check-inline">
                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="modeOfInterview"
                                id="Offline"
                                value="1"
                                onChange={handleChange}
                                checked={list.modeOfInterview === "1"}
                              />
                              <label
                                className="checkbox-label"
                                htmlFor="Offline"
                              >
                                Offline
                              </label>
                            </div>
                          </div>
                        </div>

                        {/* {listErrors.category && (
                          <small className="errors fw-semibold">
                            {listErrors.category}
                          </small>
                        )} */}
                      </div>

                      {/* PREFERRED LOCATION */}
                      {/* {list.classMode === "ClassRoom" && ( */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="preferredBranchLocation">
                            Preferred Branch Location
                          </label>
                          <select
                            ref={refPreferredBranchLocation}
                            id="preferredBranchLocation"
                            name="preferredBranchLocation"
                            className="Inputs"
                            onChange={handleChange}
                            value={list.preferredBranchLocation_id}
                            required
                          >
                            <option value="">Please select</option>
                            {locations}
                          </select>

                          {listErrors.preferredBranchLocation && (
                            <p className="errors">
                              {listErrors.preferredBranchLocation}
                            </p>
                          )}
                        </div>
                      </div>
                      {/*  )} */}

                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="location">Core Subject</label>
                          <div id="CourseCate">
                            <Creatable
                              ref={refCoreSubject}
                              name="coreSubject"
                              isMulti={false}
                              value={list.coreSubject}
                              onChange={handlechangeCoreSubject}
                              onCreateOption={handleCreateCoreSubject}
                              options={tagsList}
                              isSearchable={true}
                              placeholder="Select or enter new tags"
                              maxMenuHeight={200}
                              filterOption={(option, searchText) =>
                                option?.label
                                  ?.toLowerCase()
                                  ?.includes(searchText.toLowerCase())
                              }
                              closeMenuOnSelect={true}
                              hideSelectedOptions={true}
                              styles={customStyles}
                              formatCreateLabel={(inputValue) =>
                                `Add New: ${inputValue}`
                              }
                            />
                          </div>

                          {listErrors.coreSubject && (
                            <p className="errors">{listErrors.coreSubject}</p>
                          )}
                        </div>
                      </div>

                      {/* MEDIUM STUDIED */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="mediumStudied">Medium Studied</label>
                          <div id="CourseCate">
                            <Select
                              ref={refMediumStudied}
                              id="mediumStudied"
                              name="mediumStudied"
                              value={
                                list.mediumStudied
                                  ? {
                                      value: list.mediumStudied,
                                      label: list.mediumStudied,
                                    }
                                  : null
                              }
                              onChange={(option) => {
                                setList((prev) => ({
                                  ...prev,
                                  mediumStudied: option.value,
                                }));

                                setListErrors((prev) => ({
                                  ...prev,
                                  mediumStudied: "",
                                }));
                              }}
                              options={[
                                { value: "Tamil", label: "Tamil" },
                                { value: "English", label: "English" },
                              ]}
                              isSearchable={false}
                              placeholder="Select Medium"
                              styles={customStyles}
                            />
                          </div>

                          {listErrors.mediumStudied && (
                            <p className="errors">{listErrors.mediumStudied}</p>
                          )}
                        </div>
                      </div>

                      {/* GOVT EXAM NAME */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="govtExamName">
                            Name of the Govt. Exam You Passed
                          </label>
                          <input
                            ref={refGovtExamName}
                            id="govtExamName"
                            type="text"
                            name="govtExamName"
                            className="Inputs"
                            onChange={handleChange}
                            value={list.govtExamName}
                            placeholder="Enter the Name of the Govt. Exam You Passed"
                            autoComplete="govtExamName"
                            required
                          />

                          {listErrors.govtExamName && (
                            <p className="errors">{listErrors.govtExamName}</p>
                          )}
                        </div>
                      </div>

                      {/* GOVT EXAM REG NUMBER */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="govtExamRegisternumber">
                            Govt. Exam Registration Number
                          </label>
                          <input
                            ref={refGovtExamRegisternumber}
                            id="govtExamRegisternumber"
                            type="number"
                            name="govtExamRegisternumber"
                            className="Inputs"
                            onChange={handleChange}
                            value={list.govtExamRegisternumber}
                            placeholder="Enter the Govt. Exam Registration Number"
                            autoComplete="govtExamRegisternumber"
                            required
                          />

                          {listErrors.govtExamRegisternumber && (
                            <p className="errors">
                              {listErrors.govtExamRegisternumber}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Place of Birth */}
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Place of Birth</p>
                    <div className="row mb-4">
                      {/*Place of Birth*/}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="place_birth">Place of Birth</label>
                          <input
                            ref={placeBirthRef}
                            id="place_birth"
                            type="text"
                            name="place_birth"
                            className="Inputs"
                            onChange={handleChange}
                            value={list.place_birth}
                            placeholder="Place of Birth"
                            autoComplete="place_birth"
                            required
                          />

                          {listErrors.place_birth && (
                            <p className="errors">{listErrors.place_birth}</p>
                          )}
                        </div>
                      </div>
                      {/* Districts */}
                      <div className="col-md-6">
                        <div className="forms">
                          <label htmlFor="mediumStudied">Districts</label>
                          <div id="CourseCate">
                            <Select
                              name="district"
                              ref={districtRef}
                              value={
                                list.district
                                  ? districtOptions.find(
                                      (d) => d.value === list.district
                                    )
                                  : null
                              }
                              onChange={(option) => {
                                setList((prev) => ({
                                  ...prev,
                                  district: option.value,
                                }));

                                //  CLEAR ERROR HERE
                                setListErrors((prev) => ({
                                  ...prev,
                                  district: "",
                                }));
                              }}
                              options={districtOptions}
                              placeholder="Select District"
                            />
                          </div>

                          {listErrors.district && (
                            <p className="errors">{listErrors.district}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {batchDetails.length > 0 ? (
                <section className="sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Interview Details</p>

                      {batchDetails.map((batch, batchIndex) => (
                        <div className="row" key={batchIndex}>
                          <div className="col-md-12 mt-3 mb-3">
                            <div className="card text-dark">
                              <div className="card-body BatchImage">
                                {/* BATCH HEADER */}
                                <div className="row align-items-center">
                                  {/* IMAGE */}
                                  <div className="col-lg-2 col-md-6 col-sm-12 d-flex justify-content-center">
                                    <img
                                      src={`${ImageUrlPrefix}/${batch.img_url}`}
                                      alt="Batch"
                                      id={batch.id}
                                      style={{
                                        width: "100%",
                                        maxWidth: "140px",
                                        borderRadius: "10px",
                                      }}
                                    />
                                  </div>
                                  {/* TITLE */}
                                  <div className="col-lg-3 col-md-6 col-sm-12 d-flex flex-column justify-content-center">
                                    <p className="title m-0 text-center text-lg-start">
                                      {batch.course_name} | {batch.name}
                                    </p>
                                  </div>

                                  {/* FEE DETAILS */}
                                  <div className="col-lg-4 col-md-6 col-sm-12 d-flex flex-column  justify-content-center ">
                                    <li className="IconsImage">
                                      <span className="material-icons">
                                        currency_rupee
                                      </span>
                                      <div className="d-flex flex-column">
                                        <p className="st_confirm_label ms-1">
                                          Fee Details
                                        </p>
                                        <p className="st_confirm_value ms-1">
                                          {/* .filter(
                                                                                    (fee) =>
                                                                                      fee.fees_count ===
                                                                                      el.exam_details.length
                                                                                  ) */}
                                          {batch.exam_fees.map((fee, ind) => (
                                            <React.Fragment key={ind}>
                                              <span className="batch_fees_text">
                                                {fee.fees_count}
                                                {`${
                                                  fee.fees_count > 1
                                                    ? " Exams - "
                                                    : " Exam - "
                                                }`}
                                                {fee.fees
                                                  ? Number(fee.fees).toFixed(2)
                                                  : "_"}
                                              </span>
                                              {(ind + 1) % 2 === 0 && <br />}
                                            </React.Fragment>
                                          ))}
                                        </p>
                                      </div>
                                    </li>
                                  </div>

                                  {/* SELECT ALL */}
                                  <div className="col-lg-3 col-md-3 d-flex justify-content-lg-end justify-content-center align-items-center mt-3 mt-lg-0">
                                    <input
                                      type="checkbox"
                                      checked={batch.is_selected_all}
                                      onChange={() =>
                                        toggleBatchSelect(batchIndex, batch.id)
                                      }
                                    />
                                    <label className="ms-2 confirm_label">
                                      Select All Mock Interviews
                                    </label>
                                  </div>
                                </div>

                                {/* MOCK INTERVIEW ROWS */}
                                {(batch.exam_details || [])
                                  .slice()
                                  .sort(
                                    (a, b) => a.exam_title_id - b.exam_title_id
                                  )
                                  .map((exam) => (
                                    <div
                                      className="row mockinter-row"
                                      key={exam.pk}
                                    >
                                      <div className="col-md-1 col-sm-12 col-lg-1 d-flex align-items-center justify-content-center">
                                        <input
                                          ref={txtbatchDet}
                                          className="checkbox_batch"
                                          type="checkbox"
                                          checked={exam.is_selected_exam}
                                          disabled={batch.paper_type === 1}
                                          onChange={() =>
                                            toggleExamSelection(
                                              batchIndex,
                                              exam.pk,
                                              batch.id
                                            )
                                          }
                                        />
                                      </div>

                                      <div className="col-md-11 col-sm-12">
                                        <div className="card mt-3 BatchImage">
                                          <div className="row p-3">
                                            {/* INTERVIEW TITLE */}
                                            <div className="col-md-3 col-lg-4 col-xl-2">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  format_shapes
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="st_confirm_label ms-1">
                                                    Interview Title
                                                  </p>
                                                  <p className="st_confirm_value ms-1">
                                                    {exam.exam_title}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>

                                            {/* INTERVIEW DATE */}
                                            <div className="col-md-3 col-sm-12">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  event
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="title">
                                                    Interview Date
                                                  </p>
                                                  <p className="subtitle">
                                                    {moment(
                                                      exam.started_dt
                                                    ).format("Do MMM YYYY")}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>

                                            {/* LAST DATE TO APPLY */}
                                            <div className="col-md-3 col-sm-12">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  event
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="title">
                                                    Last Date to Apply
                                                  </p>
                                                  <p className="subtitle">
                                                    {moment(
                                                      exam.last_dt_apply
                                                    ).format("Do MMM YYYY")}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>

                                            {/* SYLLABUS DOWNLOAD */}
                                            <div className="col-md-6 col-lg-4 col-xl-2">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  library_books
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="st_confirm_label ms-1 ">
                                                    Syllabus
                                                  </p>
                                                  <p className="subtitle ms-1">
                                                    <a
                                                      target="_blank"
                                                      href={`${ImageUrlPrefix}/${exam.syllabus_url}`}
                                                      className="subtitle_testpdf "
                                                    >
                                                      Click here to view
                                                      syllabus
                                                    </a>
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                      {listErrors.batchDetails && (
                        <p className="errors">{listErrors.batchDetails}</p>
                      )}
                    </div>
                  </div>
                </section>
              ) : (
                <section className="  sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Interview Details</p>
                      <div className="row">
                        <div className="col-md-12 mt-3 mb-3">
                          <div className="card  text-dark">
                            <div className="card-body ">
                              <p className="batch_Err">No Batch Found</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              {/* Have You Already Studied for Competitive Examination? */}
              <section className=" sectionSix">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">
                      Have You Already Studied for Competitive Examination?
                    </p>
                    <div className="row mt-3">
                      <div className="col-md-12">
                        <div className="forms ">
                          <label htmlFor="CompetitiveExamination">
                            Have You Already Studied for Competitive
                            Examination?
                          </label>
                          <div className="radioGroup   d-flex flex-row">
                            <div className="formCheck ">
                              <input
                                ref={txtAdExam}
                                className="checkbox_radio"
                                type="radio"
                                name="CompetitiveExamination"
                                id="CompetitiveExamination1"
                                onChange={handleChange}
                                checked={
                                  list.CompetitiveExamination === "Yes"
                                    ? true
                                    : false
                                }
                                value="Yes"
                              />
                              <label
                                className="checkbox-label checkboxLabelMargn"
                                htmlFor="CompetitiveExamination1"
                              >
                                Yes
                              </label>

                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="CompetitiveExamination"
                                id="CompetitiveExamination2"
                                onChange={handleChange}
                                checked={
                                  list.CompetitiveExamination === "NO"
                                    ? true
                                    : false
                                }
                                value="NO"
                              />
                              <label
                                className="checkbox-label "
                                htmlFor="CompetitiveExamination2"
                              >
                                NO
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {list.CompetitiveExamination === "Yes" && (
                        <>
                          <div className="col-md-6 mb-3">
                            <div className="forms ">
                              <label htmlFor="CompetitiveExamName">
                                Name of the Examination
                              </label>
                              <Select
                                ref={txtAdExam}
                                id="CompetitiveExamName"
                                name="CompetitiveExamName"
                                value={
                                  list.CompetitiveExamName !== null &&
                                  list.CompetitiveExamName !== ""
                                    ? {
                                        value: list.CompetitiveExamName,
                                        label: list.CompetitiveExamName,
                                      }
                                    : null
                                }
                                onChange={(option) =>
                                  handleSelectCH(
                                    option,
                                    "CompetitiveExamName",
                                    "CompetitiveExamName"
                                  )
                                }
                                options={
                                  examination
                                    .filter((item) => item && item.label) // Filter out null and undefined elements
                                    .sort((a, b) =>
                                      a.label.localeCompare(b.label)
                                    ) // Sort options alphabetically by label
                                }
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />

                              {listErrors.CompetitiveExamName && (
                                <p className="errors">
                                  {listErrors.CompetitiveExamName}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <div className="forms ">
                              <label htmlFor="Institute">
                                Name of the Institute you studied
                                before(separated by commas)
                              </label>
                              <input
                                ref={txtAdinsu}
                                id="Institute"
                                type="text"
                                name="Institute"
                                className="Inputs"
                                onChange={handleChange}
                                value={list.Institute}
                                placeholder="Name of the Institute(separated by commas)"
                                autoComplete="Institute"
                                required
                              />
                              {listErrors.Institute && (
                                <p className="errors">
                                  {listErrors.Institute || "-"}
                                </p>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </section>
              {/* Have You Cleared Any Exam Previously? */}
              <section className=" sectionSix">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">
                      Have You Cleared Any Exam Previously?
                    </p>
                    <div className="row ">
                      <div className="col-md-6">
                        <div className="forms ">
                          <label htmlFor="ExamPreviously">
                            Have You Cleared Any Exam Previously?
                          </label>
                          <div className="radioGroup d-flex flex-row">
                            <div className="formCheck ">
                              <input
                                ref={txtAdEdetail}
                                className="checkbox_radio"
                                type="radio"
                                name="ExamPreviously"
                                id="ExamPreviously1"
                                onChange={handleChange}
                                checked={
                                  list.ExamPreviously === "Yes" ? true : false
                                }
                                value="Yes"
                              />
                              <label
                                className="checkbox-label checkboxLabelMargn"
                                htmlFor="ExamPreviously1"
                              >
                                Yes
                              </label>

                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="ExamPreviously"
                                id="ExamPreviously2"
                                onChange={handleChange}
                                checked={
                                  list.ExamPreviously === "NO" ? true : false
                                }
                                value="NO"
                              />
                              <label
                                className="checkbox-label"
                                htmlFor="ExamPreviously2"
                              >
                                NO
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {list.ExamPreviously === "Yes" && (
                        <>
                          <div className="col-md-6">
                            <div className="forms ">
                              <label htmlFor="ExamWrite">
                                How many exams have you cleared in the past?
                              </label>
                              <input
                                ref={txtAdEclear}
                                id="ExamWrite"
                                type="number"
                                name="ExamWrite"
                                className="Inputs"
                                onChange={handleChange}
                                value={list.ExamWrite < 0 ? 0 : list.ExamWrite}
                                placeholder="ExamWrite"
                                autoComplete="ExamWrite"
                                required
                              />
                              {listErrors.ExamWrite && (
                                <p className="errors">
                                  {listErrors.ExamWrite || "-"}
                                </p>
                              )}
                            </div>
                          </div>
                          {examDetailsExam.map((detail, index) => (
                            <div className="col-md-6 mb-3" key={index}>
                              <div className="forms ">
                                <label htmlFor={`ExamDetailsRes_${index}`}>
                                  Exam details - {index + 1}
                                </label>
                                <select
                                  ref={txtAdEdetail}
                                  id={`ExamDetailsRes_${index}`}
                                  name={`ExamDetailsRes_${index}`}
                                  className="Inputs"
                                  onChange={(e) => handleExamPrev(e, index)}
                                  value={detail.examvalue}
                                >
                                  <option value="" selected>
                                    Please select
                                  </option>
                                  {previousexam}
                                </select>
                                {detail.error_name_exam && (
                                  <p className="errors">
                                    {detail.error_name_exam}
                                  </p>
                                )}
                              </div>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </section>
              {/* Are You a Government Employee? */}
              <section className=" sectionSix">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Are You a Government Employee?</p>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="forms ">
                          <label htmlFor="workingRes">
                            Are You a Government Employee?
                          </label>
                          <div className="radioGroup d-flex flex-row">
                            <div className="formCheck ">
                              <input
                                ref={txtAdDesg}
                                className="checkbox_radio"
                                type="radio"
                                name="workingRes"
                                id="workingRes1"
                                onChange={handleChange}
                                checked={
                                  list.workingRes === "Yes" ? true : false
                                }
                                value="Yes"
                              />
                              <label
                                className="checkbox-label checkboxLabelMargn"
                                htmlFor="workingRes1"
                              >
                                Yes
                              </label>

                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="workingRes"
                                id="workingRes2"
                                onChange={handleChange}
                                checked={
                                  list.workingRes === "NO" ? true : false
                                }
                                value="NO"
                              />
                              <label
                                className="checkbox-label"
                                htmlFor="workingRes2"
                              >
                                NO
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {list.workingRes === "Yes" && (
                        <div className="row ">
                          <div className="col-md-6">
                            <div className="forms ">
                              <label htmlFor="Designation">Designation</label>
                              <Select
                                ref={txtAdDesg}
                                id="Designation"
                                name="Designation"
                                value={
                                  list.Designation !== null &&
                                  list.Designation !== ""
                                    ? {
                                        value: list.Designation,
                                        label: list.Designation,
                                      }
                                    : null
                                }
                                onChange={(option) =>
                                  handleSelectCH(
                                    option,
                                    "Designation",
                                    "Designation"
                                  )
                                }
                                options={
                                  designation
                                    .filter((item) => item && item.label) // Filter out null and undefined elements
                                    .sort((a, b) =>
                                      a.label.localeCompare(b.label)
                                    ) // Sort options alphabetically by label
                                }
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />
                              {/* <select
                                                      ref={txtAdDesg}
                                                      id="Designation"
                                                      name="Designation"
                                                      className="Inputs"
                                                      onChange={handleChange}
                                                      value={list.Designation}
                                                      required
                                                    >
                                                      <option value="" disabled selected>
                                                        Please select
                                                      </option>
                                                      {designation}
                                                    </select> */}
                              {listErrors.Designation && (
                                <p className="errors">
                                  {listErrors.Designation}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="forms ">
                              <label htmlFor="Department">Department</label>
                              {/* <input
                                                        id="Department"
                                                        type="text"
                                                        name="Department"
                                                        className="Inputs"
                                                        onChange={handleChange}
                                                        value={list.Department}
                                                        placeholder="Department"
                                                        autoComplete="Department"
                                                        required
                                                      /> */}
                              <Select
                                ref={txtAdDep}
                                id="Department"
                                name="Department"
                                value={
                                  list.Department !== null &&
                                  list.Department !== ""
                                    ? {
                                        value: list.Department,
                                        label: list.Department,
                                      }
                                    : null
                                }
                                onChange={(option) =>
                                  handleSelectCH(
                                    option,
                                    "Department",
                                    "Department"
                                  )
                                }
                                options={
                                  department
                                    .filter((item) => item && item.label) // Filter out null and undefined elements
                                    .sort((a, b) =>
                                      a.label.localeCompare(b.label)
                                    ) // Sort options alphabetically by label
                                }
                                isSearchable={true} // Enables search functionality
                                placeholder="Select an option"
                                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                filterOption={(option, searchText) =>
                                  option.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                } // Filter options based on the search text
                                styles={customStyles} // Apply custom styles her
                              />
                              {/* <select
                                                      ref={txtAdDep}
                                                      id="Department"
                                                      name="Department"
                                                      className="Inputs"
                                                      onChange={handleChange}
                                                      value={list.Department}
                                                      required
                                                    >
                                                      <option value="" disabled selected>
                                                        Please select
                                                      </option>
                                                      {department}
                                                    </select> */}
                              {listErrors.Department && (
                                <p className="errors">
                                  {listErrors.Department}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <div className="forms ">
                              <label htmlFor="JoinGovt">
                                Joining Date of Government Job
                              </label>
                              {/* <input
                                                      ref={txtAdDjoin}
                                                      id="JoinGovt"
                                                      type="date"
                                                      name="JoinGovt"
                                                      className="Inputs"
                                                      onChange={handleChange}
                                                      value={list.JoinGovt}
                                                      placeholder="JoinGovt"
                                                      autoComplete="JoinGovt"
                                                      required
                                                      max={currentDate_Join}
                                                    /> */}
                              <DatePickerSample
                                handleYearChange={handleYearChange}
                                handleMonthChange={handleMonthChange}
                                maxDate={currentDate_Join}
                                txtAdMDob={txtAdDjoin}
                                name={"JoinGovt"}
                                handleChange={handleChangeCuDate}
                                fieldInput={list.JoinGovt}
                              />
                              {listErrors.JoinGovt && (
                                <p className="errors">{listErrors.JoinGovt}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </section>
              {/* Are You an AIASA Student? */}
              <section className="sectionSix">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Are You an AIASA Student?</p>
                    <div className="row mb-3">
                      <div className="col-md-12">
                        <div className="forms ">
                          <label htmlFor="AIASAStudent">
                            Are You an AIASA Student?
                            <span id="impo" class="material-icons text-danger">
                              error
                            </span>
                          </label>
                          <div className="radioGroup d-flex flex-row">
                            <div className="formCheck ">
                              <input
                                ref={txtAdayear}
                                className="checkbox_radio"
                                type="radio"
                                name="AIASAStudent"
                                id="AIASAStudent1"
                                onChange={handleChange}
                                checked={
                                  list.AIASAStudent === "Yes" ? true : false
                                }
                                value="Yes"
                              />
                              <label
                                className="checkbox-label checkboxLabelMargn"
                                htmlFor="AIASAStudent1"
                              >
                                Yes
                              </label>

                              <input
                                className="checkbox_radio"
                                type="radio"
                                name="AIASAStudent"
                                id="inlineRadio2"
                                onChange={handleChange}
                                checked={
                                  list.AIASAStudent === "NO" ? true : false
                                }
                                value="NO"
                              />
                              <label
                                className="checkbox-label"
                                htmlFor="inlineRadio2"
                              >
                                NO
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {list.AIASAStudent === "Yes" && (
                        <>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="forms ">
                                <label htmlFor="Year">Year</label>
                                {/* <input
                                                                          id="Year"
                                                                          type="text"
                                                                          name="Year"
                                                                          className="Inputs"
                                                                          onChange={handleChange}
                                                                          value={list.Year}
                                                                          placeholder="Year"
                                                                          autoComplete="Year"
                                                                          required
                                                                        /> */}
                                <select
                                  ref={txtAdayear}
                                  id="Year"
                                  name="Year"
                                  className="Inputs"
                                  onChange={handleChange}
                                  value={list.Year}
                                  required
                                >
                                  <option value="">-- Select Year --</option>
                                  {Array.from({ length: 50 }, (_, index) => {
                                    const year =
                                      new Date().getFullYear() - index;
                                    return (
                                      <option key={year} value={year}>
                                        {year}
                                      </option>
                                    );
                                  })}
                                </select>

                                {listErrors.Year && (
                                  <p className="errors">{listErrors.Year}</p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="forms ">
                                <label htmlFor="CategoryAias">Category</label>
                                <Select
                                  ref={txtAdacate}
                                  id="CategoryAias"
                                  name="CategoryAias"
                                  value={
                                    list.CategoryAias !== null &&
                                    list.CategoryAias !== ""
                                      ? {
                                          value: list.CategoryAias,
                                          label: list.CategoryAias,
                                        }
                                      : null
                                  }
                                  onChange={(option) =>
                                    handleSelectCH(
                                      option,
                                      "CategoryAias",
                                      "CategoryAias"
                                    )
                                  }
                                  options={
                                    cOption
                                      .filter((item) => item && item.label) // Filter out null and undefined elements
                                      .sort((a, b) =>
                                        a.label.localeCompare(b.label)
                                      ) // Sort options alphabetically by label
                                  }
                                  isSearchable={true} // Enables search functionality
                                  placeholder="Select an option"
                                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                  filterOption={(option, searchText) =>
                                    option.label
                                      .toLowerCase()
                                      .includes(searchText.toLowerCase())
                                  } // Filter options based on the search text
                                  styles={customStyles} // Apply custom styles her
                                />
                                {/* <select
                                                                        ref={txtAdacate}
                                                                        id="CategoryAias"
                                                                        name="CategoryAias"
                                                                        className="Inputs"
                                                                        onChange={handleChange}
                                                                        value={list.CategoryAias}
                                                                        required
                                                                      >
                                                                        <option value="" selected>
                                                                          Please select
                                                                        </option>
                                                                        {cOption}
                                                                      </select> */}
                                {listErrors.CategoryAias && (
                                  <p className="errors">
                                    {listErrors.CategoryAias}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="forms ">
                                <label htmlFor="CourseAias">Course</label>
                                <Select
                                  ref={txtAdacourse}
                                  id="CourseAias"
                                  name="CourseAias"
                                  value={
                                    list.CourseAias !== null &&
                                    list.CourseAias !== ""
                                      ? {
                                          value: list.CourseAias,
                                          label: list.CourseAias,
                                        }
                                      : null
                                  }
                                  onChange={(option) =>
                                    handleSelectCH(
                                      option,
                                      "CourseAias",
                                      "CourseAias"
                                    )
                                  }
                                  options={
                                    courseAias
                                      .filter((item) => item && item.label) // Filter out null and undefined elements
                                      .sort((a, b) =>
                                        a.label.localeCompare(b.label)
                                      ) // Sort options alphabetically by label
                                  }
                                  isSearchable={true} // Enables search functionality
                                  placeholder="Select an option"
                                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                                  filterOption={(option, searchText) =>
                                    option.label
                                      .toLowerCase()
                                      .includes(searchText.toLowerCase())
                                  } // Filter options based on the search text
                                  styles={customStyles} // Apply custom styles her
                                />
                                {/* <select
                                                                        ref={txtAdacourse}
                                                                        id="CourseAias"
                                                                        name="CourseAias"
                                                                        className="Inputs"
                                                                        onChange={handleChange}
                                                                        value={list.CourseAias}
                                                                        required
                                                                      >
                                                                        <option value="" disabled selected>
                                                                          Please select
                                                                        </option>
                                                                        {courseAias}
                                                                      </select> */}
                                {listErrors.CourseAias && (
                                  <p className="errors">
                                    {listErrors.CourseAias}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="forms ">
                                <label htmlFor="IDNumber">ID Number</label>
                                <input
                                  ref={txtAdaIdnum}
                                  id="IDNumber"
                                  type="text"
                                  name="IDNumber"
                                  className="Inputs"
                                  onChange={handleChange}
                                  value={list.IDNumber}
                                  placeholder="ID Number"
                                  autoComplete="ID Number"
                                  required
                                  maxLength={10}
                                  minLength={10}
                                />
                                {listErrors.IDNumber && (
                                  <p className="errors">
                                    {listErrors.IDNumber}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="forms ">
                                <label htmlFor="IDPhoto">
                                  Upload ID Card (In pdf/Image format)
                                  {list.IDPhoto !== "" &&
                                    list.IDPhoto !== null && (
                                      <a
                                        href={`${ImageUrlPrefix}/${list.IDPhoto}`}
                                        target="_blank"
                                        download
                                      >
                                        <span className="material-icons download_icon align-middle text-danger">
                                          file_download
                                        </span>
                                      </a>
                                    )}
                                </label>
                                <div className="row">
                                  <div
                                    className={
                                      list.IDPhoto !== "" &&
                                      list.IDPhoto !== null
                                        ? "col-md-3 "
                                        : "col-md-12"
                                    }
                                  >
                                    <input
                                      ref={txtAdafile}
                                      id="IDPhoto"
                                      type="file"
                                      name="IDPhoto"
                                      placeholder="Upload ID Card"
                                      className={
                                        list.IDPhoto !== "" &&
                                        list.IDPhoto !== null
                                          ? "InputsFile nn_upload_width"
                                          : "InputsFile  vv_upload_width"
                                      }
                                      onChange={handleChange}
                                      autoComplete="IDPhoto"
                                      required
                                    />
                                  </div>
                                  {list.IDPhoto !== "" &&
                                    list.IDPhoto !== null && (
                                      <div
                                        className={
                                          "col-md-9 d-flex align-content-center p-0"
                                        }
                                      >
                                        <span className="nn_upload_file">
                                          {list.IDPhoto !== "" &&
                                          list.IDPhoto !== null
                                            ? list.original_aiasa_id_path
                                            : ""}
                                        </span>
                                        <span className="material-icons align-middle text-danger verified_upload">
                                          verified
                                        </span>
                                      </div>
                                    )}
                                </div>

                                {listErrors.IDPhoto && (
                                  <p className="errors">{listErrors.IDPhoto}</p>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="heading  mb-4 dflexbetww ">
                  <div className="">
                    <button
                      type="button"
                      className="SaveButton_Prev"
                      onClick={handlePrevious}
                    >
                      <a href="javascript:void(0)">
                        {" "}
                        Go to Academic Background
                      </a>
                    </button>
                  </div>
                  <div className="d-flex smButton mobiledown">
                    <Link to="/" className="CancelButton">
                      Back to Home
                    </Link>
                    <button
                      type="button"
                      className="SaveButton"
                      disabled={stepperButton}
                      onClick={handleNext}
                    >
                      {" "}
                      <a href="javascript:void(0)">
                        {" "}
                        Save and Review Your Information
                      </a>
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>
        )}

        {/* &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& */}
        {/* {step === 5} */}
        {step === 5 && (
          <div className="row">
            <div className="col-md-12">
              <section className="sectionSix">
                <div className="heading  dflexbetww ">
                  <div className="">
                    <button
                      type="button"
                      className="SaveButton_Prev"
                      onClick={handlePrevious}
                    >
                      <a href="javascript:void(0)">Go to Mock Interview</a>
                    </button>
                  </div>
                  <div className="d-flex smButton mobiledown">
                    <Link to="/" className="CancelButton">
                      Back to Home
                    </Link>
                    <button
                      type="button"
                      className="SaveButton"
                      onClick={handleNext}
                    >
                      <a href="javascript:void(0)">
                        Save and Continue to Payment Info
                      </a>
                    </button>
                  </div>
                </div>

                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Basic Details</p>

                    <div className="row">
                      <div className="col-md-9">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                First Name
                              </label>
                              <span className="ReviewLabel">
                                {list.FirstName || ""}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Last Name
                              </label>
                              <span className="ReviewLabel">
                                {list.LastName || ""}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-12">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Father's Name/Guardian's Name
                              </label>
                              <span className="ReviewLabel">
                                {" "}
                                {list.Fathername || ""}
                              </span>
                            </div>
                          </div>
                          {/* <div className="col-lg-4 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Mother's Name
                              </label>
                              <span className="ReviewLabel">
                                {" "}
                                {list.MotherName || ""}
                              </span>
                            </div>
                          </div> */}

                          <div className="col-lg-4 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Date of Birth
                              </label>
                              <span className="ReviewLabel">
                                {list.DOB || ""}
                              </span>
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Gender
                              </label>
                              <span className="ReviewLabel">
                                {list.gender || ""}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Age
                              </label>
                              <span className="ReviewLabel">
                                {list.age || ""}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Marital Status
                              </label>
                              <span className="ReviewLabel">
                                {" "}
                                {list.MaritalStatus || ""}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-5">
                        <div className="forms mb-2  ">
                          <div id="profilephotos">
                            {list.Profilephoto && (
                              <img
                                src={`${ImageUrlPrefix}/${list.Profilephoto}`}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* place of Birth */}
                <section className="sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Place of Birth</p>

                      <div className="row mb-3">
                        {/* Place of Birth */}
                        <div className="col-lg-3 col-md-6">
                          <div className="forms">
                            <label className="form-label text-muted">
                              Place of Birth
                            </label>
                            <span className="ReviewLabel">
                              {list.place_birth || "-"}
                            </span>
                          </div>
                        </div>

                        {/* District */}
                        <div className="col-lg-3 col-md-6">
                          <div className="forms">
                            <label className="form-label text-muted">
                              District
                            </label>
                            <span className="ReviewLabel">
                              {list.district_name || "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </section>

              <div className="sectionSix">
                <div className="row">
                  <div className="col-md-6">
                    <section className="sectionSix">
                      <div className="row box">
                        <div className="col-md-12">
                          <p className="StepTitle">ID Proofs</p>

                          <div className="row mb-3">
                            <div className="col-lg-4 col-md-12">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  AADHAR Number
                                </label>
                                <span className="ReviewLabel">
                                  {list.aadharNo || "-"}
                                </span>
                              </div>
                            </div>

                            <div className="col-lg-8 col-md-12">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Upload AADHAR Card
                                  {list.aadharCardphoto && (
                                    <a
                                      target="_blank"
                                      href={`${ImageUrlPrefix}/${list.aadharCardphoto}`}
                                    >
                                      {" "}
                                      <Download className="download_icon" />
                                    </a>
                                  )}
                                </label>
                                <span className="ReviewLabel">
                                  {list.original_aadhar_path || "-"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div className="col-md-6">
                    <section className="sectionSix ">
                      <div className="row box">
                        <div className="col-md-12">
                          <p className="StepTitle">
                            Communal Reservation Category
                          </p>

                          <div className="row mb-3">
                            <div className="col-lg-4 col-md-12">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Category
                                </label>
                                <span className="ReviewLabel">
                                  {list.Cast || "-"}
                                </span>
                              </div>
                            </div>

                            <div className="col-lg-8 col-md-12">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted "
                                >
                                  Uploaded Certificate
                                  {list.CastFile && (
                                    <a
                                      target="_blank"
                                      href={`${ImageUrlPrefix}/${list.CastFile}`}
                                    >
                                      {"-"}
                                      <Download className="download_icon" />
                                    </a>
                                  )}
                                </label>
                                <span className="ReviewLabel">
                                  {list.original_caste_path
                                    ? list.original_caste_path
                                    : "-"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>

              <section className="sectionSix ">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">
                      Applicable Special Category Preferences
                    </p>

                    <div className="row mb-3">
                      <div className="col-lg-12 col-md-12">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted "
                          >
                            Category
                          </label>
                          <span className="ReviewLabel">
                            {appCastLable.length > 0
                              ? appCastLable.map((el) => el.label).join(",")
                              : "_" || ""}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section className=" sectionSix">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Contact details</p>

                    <div className="row mb-3">
                      <div className="col-lg-3 col-md-6">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted "
                          >
                            Phone Number
                          </label>
                          <span className="ReviewLabel">
                            {list.Mobile || "-"}
                          </span>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted "
                          >
                            WhatsApp Number
                          </label>
                          <span className="ReviewLabel">
                            {list.ContactNumber === true
                              ? list.Mobile
                              : list.WhatsAppNumber || "-"}
                          </span>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted "
                          >
                            Father/Guardian Phone Number
                          </label>
                          <span className="ReviewLabel">
                            {list.ParentMobileNo || "-"}
                          </span>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted "
                          >
                            Email ID
                          </label>
                          <span className="ReviewLabel">
                            {list.emailaddress || "-"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <div className="sectionSix">
                <div className="row">
                  <div className="col-md-6">
                    <section className="sectionSix">
                      <div className="row box">
                        <div className="col-md-12">
                          <p className="StepTitle">Present Address</p>
                          <div className="row mb-3">
                            <div className="col-md-6">
                              <div className="forms">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted"
                                >
                                  Present Address
                                </label>
                              </div>
                            </div>

                            {[
                              list.BuildingNumberPresent,
                              list.StreetNamePresent,
                              list.AreaPresent,
                              list.LandmarkPresent,
                              list.TalukPresent,
                              list.PostPresent,
                              list.PincodePresent,
                              list.CityPresent,
                              list.districtPresent,
                              list.statePresent,
                            ].some(Boolean) ? (
                              <div className="d-flex flex-column">
                                {[
                                  [
                                    list.BuildingNumberPresent,
                                    list.StreetNamePresent,
                                  ],
                                  [list.AreaPresent, list.LandmarkPresent],
                                  [list.TalukPresent, list.PostPresent],
                                  [list.PincodePresent, list.CityPresent],
                                  [list.districtPresent, list.statePresent],
                                ].map((pair, index) => {
                                  const value = pair.filter(Boolean).join(", ");
                                  return value ? (
                                    <span
                                      key={index}
                                      className="ReviewLabel mb-2"
                                    >
                                      {value}
                                    </span>
                                  ) : null;
                                })}
                              </div>
                            ) : (
                              <p className="text-center mb-0 mt-2">
                                No records to display
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div className="col-md-6">
                    <section className="sectionSix ">
                      <div className="row box">
                        <div className="col-md-12">
                          <p className="StepTitle">Permanent Address</p>
                          {/* <div className="row mb-3">
                              <div className="col-md-12">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    Permanent Address
                                  </label>
                                </div>
                              </div>
                              <span className="ReviewLabel  mb-2">
                                {list.SamePresentAddress === true
                                  ? list.BuildingNumberPresent ||
                                    "-" +
                                      (list.BuildingNumberPresent ? "," : "")
                                  : list.BuildingNumberPermanent ||
                                    "-" +
                                      (list.BuildingNumberPermanent
                                        ? ","
                                        : "") ||
                                    ""}
                                {list.SamePresentAddress === true
                                  ? list.StreetNamePresent ||
                                    "-" + (list.StreetNamePresent ? "," : "")
                                  : list.StreetNamePermanent ||
                                    "-" +
                                      (list.StreetNamePermanent ? "," : "") ||
                                    ""}
                              </span>
                              <span className="ReviewLabel  mb-2">
                                {" "}
                                {list.SamePresentAddress === true
                                  ? list.AreaPresent ||
                                    "-" + (list.AreaPresent ? "," : "")
                                  : list.AreaPermanent ||
                                    "-" + (list.AreaPermanent ? "," : "") ||
                                    ""}
                                {list.SamePresentAddress === true
                                  ? list.LandmarkPresent ||
                                    "-" + (list.LandmarkPresent ? "," : "")
                                  : list.LandmarkPermanent ||
                                    "-" + (list.LandmarkPermanent ? "," : "") ||
                                    ""}
                              </span>
                              <span className="ReviewLabel  mb-2">
                                {" "}
                                {list.SamePresentAddress === true
                                  ? list.TalukPresent ||
                                    "-" + (list.TalukPresent ? "," : "")
                                  : list.TalukPermanent ||
                                    "-" + (list.TalukPermanent ? "," : "") ||
                                    ""}
                                {list.SamePresentAddress === true
                                  ? list.PostPresent ||
                                    "-" + (list.PostPresent ? "," : "")
                                  : list.PostPermanent ||
                                    "-" + (list.PostPermanent ? "," : "") ||
                                    ""}
                              </span>
                              <span className="ReviewLabel  mb-2">
                                {" "}
                                {list.SamePresentAddress === true
                                  ? list.PincodePresent ||
                                    "-" + (list.PincodePresent ? "," : "")
                                  : list.PincodePermanent ||
                                    "-" + (list.PincodePermanent ? "," : "") ||
                                    ""}
                                {list.SamePresentAddress === true
                                  ? list.CityPresent ||
                                    "-" + (list.CityPresent ? "," : "")
                                  : list.CityPermanent ||
                                    "-" + (list.CityPermanent ? "," : "") ||
                                    ""}
                              </span>
                              <span className="ReviewLabel  mb-2">
                                {" "}
                                {list.SamePresentAddress === true
                                  ? list.districtPresent ||
                                    "-" + (list.districtPresent ? "," : "")
                                  : list.districtPermanent ||
                                    "-" + (list.districtPermanent ? "," : "") ||
                                    ""}
                                {list.SamePresentAddress === true
                                  ? list.statePresent ||
                                    "-" + (list.statePresent ? "," : "")
                                  : list.statePermanent ||
                                    "-" + (list.statePermanent ? "," : "") ||
                                    ""}
                              </span>
                            </div> */}
                          <div className="row mb-3">
                            <div className="col-md-12">
                              <div className="forms">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted"
                                >
                                  Permanent Address
                                </label>
                              </div>
                            </div>

                            {(() => {
                              const addressSource = list.SamePresentAddress
                                ? {
                                    BuildingNumber: list.BuildingNumberPresent,
                                    StreetName: list.StreetNamePresent,
                                    Area: list.AreaPresent,
                                    Landmark: list.LandmarkPresent,
                                    Taluk: list.TalukPresent,
                                    Post: list.PostPresent,
                                    Pincode: list.PincodePresent,
                                    City: list.CityPresent,
                                    District: list.districtPresent,
                                    State: list.statePresent,
                                  }
                                : {
                                    BuildingNumber:
                                      list.BuildingNumberPermanent,
                                    StreetName: list.StreetNamePermanent,
                                    Area: list.AreaPermanent,
                                    Landmark: list.LandmarkPermanent,
                                    Taluk: list.TalukPermanent,
                                    Post: list.PostPermanent,
                                    Pincode: list.PincodePermanent,
                                    City: list.CityPermanent,
                                    District: list.districtPermanent,
                                    State: list.statePermanent,
                                  };

                              const addressFields = [
                                [
                                  addressSource.BuildingNumber,
                                  addressSource.StreetName,
                                ],
                                [addressSource.Area, addressSource.Landmark],
                                [addressSource.Taluk, addressSource.Post],
                                [addressSource.Pincode, addressSource.City],
                                [addressSource.District, addressSource.State],
                              ];

                              const hasAnyData =
                                Object.values(addressSource).some(Boolean);

                              return hasAnyData ? (
                                <div className="d-flex flex-column">
                                  {addressFields.map((pair, index) => {
                                    const value = pair
                                      .filter(Boolean)
                                      .join(", ");
                                    return value ? (
                                      <span
                                        key={index}
                                        className="ReviewLabel mb-2"
                                      >
                                        {value}
                                      </span>
                                    ) : null;
                                  })}
                                </div>
                              ) : (
                                <p className="text-center mb-0 mt-2">
                                  No records to display
                                </p>
                              );
                            })()}
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>

              <div className="sectionSix">
                <div className="row">
                  {educationQualification.includes("SSLC") && (
                    <div
                      className={
                        educationQualification.includes("SSLC") &&
                        !educationQualification.includes("HSC")
                          ? " col-md-12"
                          : " col-md-6"
                      }
                    >
                      <section className="sectionSix">
                        <div className="row box">
                          <div className="col-md-12">
                            <p className="StepTitle">SSLC</p>

                            <div className="row mb-3">
                              <div className="col-md-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    Certificate Number
                                  </label>
                                  <span className="ReviewLabel">
                                    {sslcCerficates[0].SSLC_CNo || ""}
                                  </span>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    {" "}
                                    Year of Passing
                                  </label>
                                  <span className="ReviewLabel">
                                    {sslcCerficates[0].SSLC_Year || ""}
                                  </span>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    {" "}
                                    Marks Percentage
                                  </label>
                                  <span className="ReviewLabel">
                                    {sslcCerficates[0].SSLC_Marks || ""}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    {" "}
                                    Medium of Instruction
                                  </label>
                                  <span className="ReviewLabel">
                                    {sslcCerficates[0].SSLC_MI || ""}
                                  </span>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    {" "}
                                    School Name
                                  </label>
                                  <span className="ReviewLabel">
                                    {sslcCerficates[0].SSLC_Scl || ""}
                                  </span>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    {" "}
                                    Uploaded Certificate
                                    {sslcCerficates[0].SSLC_Path && (
                                      <a
                                        target="_blank"
                                        href={`${ImageUrlPrefix}/${sslcCerficates[0].SSLC_Path}`}
                                      >
                                        {" "}
                                        <Download className="download_icon" />
                                      </a>
                                    )}
                                  </label>
                                  <span className="ReviewLabel">
                                    {sslcCerficates[0].SSLC_Path !== null
                                      ? sslcCerficates[0].original_file_path
                                      : "-"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>{" "}
                    </div>
                  )}
                  {educationQualification.includes("HSC") && (
                    <div
                      className={
                        !educationQualification.includes("SSLC") &&
                        educationQualification.includes("HSC")
                          ? " col-md-12"
                          : " col-md-6"
                      }
                    >
                      <section
                        className={`${
                          !educationQualification.includes("SSLC") &&
                          educationQualification.includes("HSC")
                            ? ""
                            : ""
                        } sectionSix`}
                      >
                        <div className="row box">
                          <div className="col-md-12">
                            <p className="StepTitle">HSC</p>

                            <div className="row mb-3">
                              <div className="col-md-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    Certificate Number
                                  </label>
                                  <div className="ReviewLabel">
                                    {sslcCerficates[1].HSC_CNo || ""}
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    {" "}
                                    Year of Passing
                                  </label>
                                  <span className="ReviewLabel">
                                    {sslcCerficates[1].HSC_Year || ""}
                                  </span>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    {" "}
                                    Marks Percentage
                                  </label>
                                  <span className="ReviewLabel">
                                    {sslcCerficates[1].HSC_Marks || ""}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    {" "}
                                    Medium of Instruction
                                  </label>
                                  <span className="ReviewLabel">
                                    {sslcCerficates[1].HSC_MI || ""}
                                  </span>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    {" "}
                                    School Name
                                  </label>
                                  <span className="ReviewLabel">
                                    {sslcCerficates[1].HSC_Scl || ""}
                                  </span>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted "
                                  >
                                    {" "}
                                    Uploaded Certificate
                                    {sslcCerficates[1].HSC_Path && (
                                      <a
                                        target="_blank"
                                        href={`${ImageUrlPrefix}/${sslcCerficates[1].HSC_Path}`}
                                      >
                                        {" "}
                                        <Download className="download_icon" />
                                      </a>
                                    )}
                                  </label>
                                  <span className="ReviewLabel">
                                    {sslcCerficates[1].HSC_Path !== null
                                      ? sslcCerficates[1].original_file_path
                                      : "-"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  )}
                </div>
              </div>
              {educationQualification.includes("UG") && (
                <section className=" sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">UG</p>

                      <div className="row mb-3">
                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Certificate Number
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[2].UGCertificateNumber || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Year of Passing
                            </label>
                            <span className="ReviewLabel">
                              {" "}
                              {sslcCerficates[2].UGYearpassing || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Degree
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[2].UGDegree || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Major
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[2].UGMajor || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Marks Percentage
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[2].UGMarksPercentage || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Class
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[2].UGClassName || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Name of the college / university
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[2].UGNameInstitute || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Uploaded UG Certificate
                              {sslcCerficates[2].UG_Path && (
                                <a
                                  target="_blank"
                                  href={`${ImageUrlPrefix}/${sslcCerficates[2].UG_Path}`}
                                >
                                  {" "}
                                  <Download className="download_icon" />
                                </a>
                              )}
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[2].UG_Path !== null
                                ? sslcCerficates[2].original_file_path
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {educationQualification.includes("PG") && (
                <section className=" sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">PG</p>

                      <div className="row mb-3">
                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Certificate Number
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[3].PGCertificateNumber || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Year of Passing
                            </label>
                            <span className="ReviewLabel">
                              {" "}
                              {sslcCerficates[3].PGYearpassing || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Degree
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[3].PGDegree || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Major
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[3].PGMajor || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Marks Percentage
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[3].PGMarksPercentage || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              class
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[3].PGClassName || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Name of the college / university
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[3].PGNameInstitute || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Uploaded Certificate
                              {sslcCerficates[3].PG_Path && (
                                <a
                                  target="_blank"
                                  href={`${ImageUrlPrefix}/${sslcCerficates[3].PG_Path}`}
                                >
                                  {" "}
                                  <Download className="download_icon" />
                                </a>
                              )}
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[3].PG_Path !== null
                                ? sslcCerficates[3].original_file_path
                                : "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {educationQualification.includes("Integrated PG") && (
                <section className=" sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Integrated PG</p>

                      <div className="row mb-3">
                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Certificate Number
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[4].IPCertificateNumber || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Year of Passing
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[4].IPYearpassing || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Degree
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[4].IPDegree || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Major
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[4].IPMajor || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Marks Percentage
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[4].IPMarksPercentage || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Class
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[4].IPClassName || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Name of the college / university
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[4].IPNameInstitute || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Uploaded Certificate
                              {sslcCerficates[4].IP_Path && (
                                <a
                                  target="_blank"
                                  href={`${ImageUrlPrefix}/${sslcCerficates[4].IP_Path}`}
                                >
                                  {" "}
                                  <Download className="download_icon" />
                                </a>
                              )}
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[4].IP_Path !== null
                                ? sslcCerficates[4].original_file_path
                                : "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {educationQualification.includes("Diploma") && (
                <section className=" sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Diploma</p>

                      <div className="row mb-3">
                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Certificate Number
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[5].DCertificateNumber || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Year of Passing
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[5].DYearpassing || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Degree
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[5].DDegree || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Major
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[5].DMajor || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Marks of percentage
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[5].DMarksPercentage || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Class
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[5].DClassName || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Name of the college / university
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[5].DNameInstitute || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Uploaded Certificate
                              {sslcCerficates[5].D_Path && (
                                <a
                                  target="_blank"
                                  href={`${ImageUrlPrefix}/${sslcCerficates[5].D_Path}`}
                                >
                                  {" "}
                                  <Download className="download_icon" />
                                </a>
                              )}
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[5].D_Path !== null
                                ? sslcCerficates[5].original_file_path
                                : "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {educationQualification.includes("Professional Courses") && (
                <section className=" sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Professional Courses</p>

                      <div className="row mb-3">
                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Certificate Number
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[6].PCCertificateNumber || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Year of Passing
                            </label>
                            <span className="ReviewLabel">
                              {" "}
                              {sslcCerficates[6].PCYearpassing || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Degree
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[6].PCDegree || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Major
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[6].PCMajor || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Marks Percentage
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[6].PCMarksPercentage || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Class
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[6].PCClassName || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Name of the college / university
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[6].PCNameInstitute || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Uploaded Certificate
                              {sslcCerficates[6].PC_Path && (
                                <a
                                  target="_blank"
                                  href={`${ImageUrlPrefix}/${sslcCerficates[6].PC_Path}`}
                                >
                                  {" "}
                                  <Download className="download_icon" />
                                </a>
                              )}
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[6].PC_Path !== null
                                ? sslcCerficates[6].original_file_path
                                : "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {educationQualification.includes("Others") && (
                <section className=" sectionSix">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Others</p>

                      <div className="row mb-3">
                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Certificate Number
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[7].OtCertificateNumber || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Year of Passing
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[7].OtYearpassing || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Degree
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[7].OtDegree || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Major
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[7].OtMajor || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Marks Percentage
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[7].OtMarksPercentage || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Class
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[7].OtClassName || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Name of the college / university
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[7].OtNameInstitute || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Uploaded Certificate
                              {sslcCerficates[7].Ot_Path && (
                                <a
                                  target="_blank"
                                  href={`${ImageUrlPrefix}/${sslcCerficates[7].Ot_Path}`}
                                >
                                  {" "}
                                  <Download className="download_icon" />
                                </a>
                              )}
                            </label>
                            <span className="ReviewLabel">
                              {sslcCerficates[7].Ot_Path !== null
                                ? sslcCerficates[7].original_file_path
                                : "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              <div className=" sectionSix">
                <div className="row">
                  {techQualification.length > 0 &&
                    !(
                      techQualification[0].name === "" &&
                      techQualification[0].level === "" &&
                      techQualification[0].lang === "" &&
                      techQualification[0].Cnum === "" &&
                      techQualification[0].grade === "" &&
                      techQualification[0].year === "" &&
                      techQualification[0].file === ""
                    ) &&
                    techQualification.map((el, index) => (
                      <div
                        className={
                          techQualification.length === 1
                            ? "col-md-12 "
                            : "col-md-12 "
                        }
                        key={index}
                      >
                        <section className=" sectionSix">
                          <div className="row box ">
                            <div className="col-md-12 ">
                              <p className="StepTitle">
                                Technical Qualification{" "}
                                {/* {techQualification.length === 1
                                  ? " "
                                  : `- ${el.id}`} */}
                                {techQualification.length > 1 &&
                                  `- ${index + 1}`}
                              </p>

                              <div className="row mb-3">
                                <div className="col-md-3">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      Technicnal Course
                                    </label>
                                    <span className="ReviewLabel">
                                      {el.name || ""}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-3">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      Typewriting Level
                                    </label>
                                    <span className="ReviewLabel">
                                      {el.level || ""}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-3">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      Language
                                    </label>
                                    <span className="ReviewLabel">
                                      {el.lang || ""}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-3">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      Certificate Number
                                    </label>
                                    <span className="ReviewLabel">
                                      {el.Cnum || ""}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-3">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      Grade
                                    </label>
                                    <span className="ReviewLabel">
                                      {el.grade || ""}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-3">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      Year of Passing
                                    </label>
                                    <span className="ReviewLabel">
                                      {el.year !== "" ? el.year : ""}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-3">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted "
                                    >
                                      Upload Certificate
                                      {el.file && (
                                        <a
                                          target="_blank"
                                          href={`${ImageUrlPrefix}/${el.file}`}
                                        >
                                          {" "}
                                          <Download className="download_icon" />
                                        </a>
                                      )}
                                    </label>
                                    <span className="ReviewLabel">
                                      {el.original_file_path || "-"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    ))}
                </div>
              </div>

              <section className=" sectionSix">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Mock Interview Enrollment</p>

                    <div className="row mb-3">
                      {/* Category */}
                      <div className="col-md-3">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted "
                          >
                            Category
                          </label>
                          <span className="ReviewLabel">
                            {" "}
                            {list.category || "-"}
                          </span>
                        </div>
                      </div>
                      {/* Medium of exam */}
                      <div className="col-md-3">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted "
                          >
                            Medium of Exam
                          </label>
                          <span className="ReviewLabel">
                            {" "}
                            {list.mediumStudied || "-"}
                          </span>
                        </div>
                      </div>
                      {/* Location */}
                      <div className="col-md-3">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted "
                          >
                            Location
                          </label>
                          <span className="ReviewLabel">
                            {list.location || "-"}
                          </span>
                        </div>
                      </div>
                      {/* name of the exam */}
                      <div className="col-md-3">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted "
                          >
                            Name of the Govt. Exam You Passed
                          </label>
                          <span className="ReviewLabel">
                            {list.govtExamName || "-"}
                          </span>
                        </div>
                      </div>
                      {/* registered no */}
                      <div className="col-md-3">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted "
                          >
                            Govt. Exam Registration Number
                          </label>
                          <span className="ReviewLabel">
                            {list.govtExamRegisternumber || "-"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              {/* step5 interview Details */}
              <section className="sectionSix">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Interview Details</p>

                    {batchDetails &&
                    batchDetails.filter((b) => b.is_selected === true).length >
                      0 ? (
                      batchDetails
                        .filter((el) => el.is_selected === true)
                        .map((el, index) => (
                          <div className="row" key={index}>
                            <div className="col-md-12 mt-3 mb-3">
                              <div className="card text-dark">
                                <div className="card-body BatchImage">
                                  <div className="row">
                                    {/* Image */}
                                    <div className="col-lg-2 col-md-6 col-sm-12">
                                      <img
                                        src={`${ImageUrlPrefix}/${el.img_url}`}
                                        alt="Batch"
                                      />
                                    </div>

                                    {/* Batch Name */}
                                    <div className="col-lg-3 col-md-6 col-sm-12 d-flex flex-column justify-content-center">
                                      <p className="title m-0">
                                        {el.course_name || "-"} -{" "}
                                        {el.name || "-"}
                                      </p>
                                    </div>

                                    {/* Fee Details */}
                                    <div className="col-lg-3 col-md-6 col-sm-12 d-flex flex-column justify-content-center">
                                      <li className="IconsImage">
                                        <span className="material-icons">
                                          currency_rupee
                                        </span>
                                        <div className="d-flex flex-column">
                                          <p className="st_confirm_label ms-1">
                                            Interview Fee
                                          </p>
                                          <p className="st_confirm_value ms-1">
                                            {el.exam_fees
                                              ?.filter(
                                                (fee) =>
                                                  fee.fees_count ===
                                                  (
                                                    el.exam_details || []
                                                  ).filter(
                                                    (ex) =>
                                                      ex.is_selected_exam ===
                                                      true
                                                  ).length
                                              )
                                              ?.map((fee, idx) => (
                                                <span key={idx}>
                                                  {fee.fees
                                                    ? Number(fee.fees).toFixed(
                                                        2
                                                      )
                                                    : "0"}
                                                </span>
                                              ))}
                                          </p>
                                        </div>
                                      </li>
                                    </div>
                                  </div>

                                  {/* Interview Details */}
                                  {(el.exam_details || [])
                                    .filter(
                                      (item) => item.is_selected_exam === true
                                    )
                                    .sort(
                                      (a, b) =>
                                        a.exam_title_id - b.exam_title_id
                                    )
                                    .map((interview, idx) => (
                                      <div key={idx}>
                                        <div className="border mt-3 mb-3"></div>

                                        <div className="row">
                                          {/* Interview Title */}
                                          <div className="col-md-3">
                                            <li className="IconsImage">
                                              <span className="material-icons">
                                                format_shapes
                                              </span>
                                              <div className="d-flex flex-column">
                                                <p className="st_confirm_label ms-1">
                                                  Interview Title
                                                </p>
                                                <p className="st_confirm_value ms-1">
                                                  {interview.exam_title || "-"}
                                                </p>
                                              </div>
                                            </li>
                                          </div>

                                          {/* Interview Date */}
                                          <div className="col-md-3">
                                            <li className="IconsImage">
                                              <span className="material-icons">
                                                event
                                              </span>
                                              <div className="d-flex flex-column">
                                                <p className="st_confirm_label ms-1">
                                                  Date
                                                </p>
                                                <p className="st_confirm_value ms-1">
                                                  {interview.started_dt
                                                    ? moment
                                                        .utc(
                                                          interview.started_dt
                                                        )
                                                        .format("Do MMM YYYY")
                                                    : "-"}
                                                </p>
                                              </div>
                                            </li>
                                          </div>

                                          {/* Interview Time */}
                                          {/* <div className="col-md-3">
                                            <li className="IconsImage">
                                              <span className="material-icons-outlined">
                                                schedule
                                              </span>
                                              <div className="d-flex flex-column">
                                                <p className="st_confirm_label ms-1">
                                                  Time
                                                </p>
                                                <p className="st_confirm_value ms-1">
                                                  {interview.batch_time || "-"}
                                                </p>
                                              </div>
                                            </li>
                                          </div> */}

                                          {/* Last Date */}
                                          <div className="col-md-3">
                                            <li className="IconsImage">
                                              <span className="material-icons">
                                                event
                                              </span>
                                              <div className="d-flex flex-column">
                                                <p className="st_confirm_label ms-1">
                                                  Last Date to Apply
                                                </p>
                                                <p className="st_confirm_value ms-1">
                                                  {interview.last_dt_apply
                                                    ? moment(
                                                        interview.last_dt_apply
                                                      ).format("Do MMM YYYY")
                                                    : "-"}
                                                </p>
                                              </div>
                                            </li>
                                          </div>
                                          {/* syllabus */}
                                          <div className="col-md-3">
                                            <li className="IconsImage">
                                              <span className="material-icons">
                                                library_books
                                              </span>
                                              <div className="d-flex flex-column">
                                                <p className="st_confirm_label ms-1">
                                                  Syllabus
                                                </p>
                                                <p className="st_confirm_value ms-1">
                                                  <a
                                                    target="_blank"
                                                    href={`${ImageUrlPrefix}/${interview.syllabus_url}`}
                                                    className="subtitle_testpdf "
                                                  >
                                                    Click here to view syllabus
                                                  </a>
                                                </p>
                                              </div>
                                            </li>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                    ) : (
                      <div className="row">
                        <div className="col-md-12 mt-3 mb-3">
                          <div className="card text-dark">
                            <div className="card-body">
                              <p className="batch_Err">
                                No Mock Interview Selected
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </section>

              <section className=" sectionSix">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">
                      Have You Already Studied for Competitive Examination?
                    </p>
                    <div className="row mt-3 mb-3">
                      <div className="col-lg-3 col-md-6">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted"
                          >
                            Have You Already Studied for Competitive
                            Examination?
                          </label>
                          <span className="ReviewLabel mt-2">
                            {list.CompetitiveExamination || ""}
                          </span>
                        </div>
                      </div>
                      {list.CompetitiveExamination === "Yes" && (
                        <>
                          <div className="col-lg-3 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Name of the Examination
                              </label>
                              <span className="ReviewLabel">
                                {list.CompetitiveExamination === "Yes"
                                  ? list.CompetitiveExamName || "-"
                                  : "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Name of the Institute
                              </label>
                              <span className="ReviewLabel">
                                {list.CompetitiveExamination === "Yes"
                                  ? list.Institute || "-"
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </section>

              <section className=" sectionSix">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">
                      Have You Cleared Any Exam Previously?
                    </p>
                    <div className="row mb-3">
                      <div className="col-lg-3 col-md-6">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted"
                          >
                            Have You Cleared Any Exam Previously?
                          </label>
                          <span className="ReviewLabel mt-2">
                            {list.ExamPreviously || "-"}
                          </span>
                        </div>
                      </div>

                      {list.ExamPreviously === "Yes" && (
                        <>
                          <div className="col-lg-3 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted  oneline"
                              >
                                How many exams have you cleared in the past?
                              </label>
                              <span className="ReviewLabel mt-2">
                                {list.ExamPreviously === "Yes"
                                  ? list.ExamWrite || ""
                                  : "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted  oneline"
                              >
                                Exam details
                              </label>
                              <span className="register_app_val mb-3">
                                {list.ExamPreviously === "Yes"
                                  ? examDetailsExam
                                      .map((item) => item.examvalue)
                                      .join(", ") || "-"
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </section>

              <section className=" sectionSix">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Are You a Government Employee?</p>
                    <div className="row mb-3">
                      <div className="col-lg-3 col-md-6">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted"
                          >
                            Are You a Government Employee?
                          </label>
                          <span className="ReviewLabel">
                            {list.workingRes || "-"}
                          </span>
                        </div>
                      </div>
                      {list.workingRes === "Yes" && (
                        <>
                          <div className="col-lg-3 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Designation
                              </label>
                              <span className="ReviewLabel">
                                {list.workingRes === "Yes"
                                  ? list.Designation || "-"
                                  : "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-3 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Department
                              </label>
                              <span className="ReviewLabel">
                                {list.workingRes === "Yes"
                                  ? list.Department || "-"
                                  : "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-3 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Joining Date of Government Job
                              </label>
                              <span className="ReviewLabel">
                                {list.workingRes === "Yes"
                                  ? list.JoinGovt
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </section>

              <section className="sectionSix">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Are You an AIASA Student?</p>
                    <div className="row mb-3">
                      <div className="col-md-3">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted"
                          >
                            Are You an AIASA Student?
                          </label>
                          <span className="ReviewLabel">
                            {list.AIASAStudent || "-"}
                          </span>
                        </div>
                      </div>
                      {list.AIASAStudent === "Yes" && (
                        <>
                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Year
                              </label>
                              <span className="ReviewLabel">
                                {list.AIASAStudent === "Yes"
                                  ? list.Year || "-"
                                  : "-"}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                category
                              </label>
                              <span className="ReviewLabel">
                                {list.AIASAStudent === "Yes"
                                  ? list.CategoryAias || "-"
                                  : "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                Course
                              </label>
                              <span className="ReviewLabel">
                                {list.AIASAStudent === "Yes"
                                  ? list.CourseAias || "-"
                                  : "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted "
                              >
                                ID Number
                              </label>
                              <span className="ReviewLabel">
                                {list.AIASAStudent === "Yes"
                                  ? list.IDNumber || "-"
                                  : "-"}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-3 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted"
                              >
                                Upload ID Card
                                {list.AIASAStudent === "Yes" &&
                                  list.IDPhoto !== "" &&
                                  list.IDPhoto !== null && (
                                    <a
                                      target="_blank"
                                      href={`${ImageUrlPrefix}/${list.IDPhoto}`}
                                    >
                                      {" "}
                                      <Download className="download_icon" />
                                    </a>
                                  )}
                              </label>
                              <span className="ReviewLabel">
                                {list.AIASAStudent === "Yes"
                                  ? list.IDPhoto !== null && list.IDPhoto !== ""
                                    ? list.original_aiasa_id_path
                                    : ""
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {/* {!edit && ( */}
                <div className="col-md-12">
                  <div
                    className="form-check form-check-inline"
                    id="Verifycheckbox"
                  >
                    <input
                      ref={txtadVerifyHere}
                      className="form-check-input mt-0"
                      type="checkbox"
                      id="Verify"
                      name="Verify"
                      onChange={handleChange}
                      checked={list.Verify === true ? true : false}
                      value="Yes"
                    />
                    <label className="LablePrivacyText" htmlFor="Verify">
                      I hereby certify that the above information are true and
                      correct to the best of my knowledge and belief.
                      <a
                        className="LablePrivacy align-baseline"
                        href={"/AdmissionTermsAndCondition"}
                        // target="_blank"
                      >
                        Terms and Conditions
                      </a>
                    </label>
                    {listErrors.Verify && (
                      <span className="errors align-top ms-3">
                        {listErrors.Verify}
                      </span>
                    )}
                  </div>
                </div>
                {/* )} */}
                {/* {!edit && ( */}
                <div className="heading mt-4  mb-4 dflexbetww ">
                  <div className="">
                    <button
                      type="button"
                      className="SaveButton_Prev"
                      onClick={handlePrevious}
                    >
                      <a href="javascript:void(0)">Go to Course Selection</a>
                    </button>
                  </div>
                  <div className="d-flex smButton mobiledown">
                    <Link to="/" className="CancelButton">
                      Back to Home
                    </Link>
                    <button
                      type="button"
                      className="SaveButton"
                      disabled={stepperButton}
                      onClick={handleNext}
                    >
                      <a href="javascript:void(0)">
                        Save and Continue to Payment Info
                      </a>
                    </button>
                  </div>
                </div>
                {/* )} */}
              </section>
            </div>
          </div>
        )}

        {/* &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& */}
        {/* {step === 6} */}
        {step === 6 && (
          <div className="sectionSix">
            {batchDetails
              .filter((item) => item.is_selected === true)
              .map((itk, index) => (
                <>
                  {" "}
                  <div className="heading mb-4  dflexbetww " key={index}>
                    <div className="">
                      <button
                        type="button"
                        className="SaveButton_Prev"
                        onClick={handlePrevious}
                      >
                        <a href="javascript:void(0)">
                          Go to Review and Confirm
                        </a>
                      </button>
                    </div>
                    <div className="d-flex smButton mobiledown">
                      <Link to="/" className="CancelButton">
                        Back to Home
                      </Link>
                      {list.PPaymentMode === "0" ? (
                        <button
                          type="button"
                          disabled={
                            stepperButton ||
                            itk.exam_fees
                              .filter(
                                (fee) =>
                                  fee.fees_count ===
                                  itk.exam_details.filter(
                                    (el) => el.is_selected_exam
                                  ).length
                              )
                              .map((fee) => fee.fees) -
                              (parseInt(couponApplied.amount) +
                                (dis && offSpl
                                  ? dis < offSpl
                                    ? 0
                                    : dis > offSpl
                                    ? dis
                                    : 0
                                  : dis
                                  ? dis
                                  : 0) +
                                (dis && offSpl
                                  ? dis < offSpl
                                    ? offSpl
                                    : dis > offSpl
                                    ? 0
                                    : 0
                                  : offSpl
                                  ? offSpl
                                  : 0)) +
                              GSTPRICE *
                                (itk.exam_fees
                                  .filter(
                                    (fee) =>
                                      fee.fees_count ===
                                      itk.exam_details.filter(
                                        (el) => el.is_selected_exam
                                      ).length
                                  )
                                  .map((fee) => fee.fees) -
                                  (parseInt(couponApplied.amount) +
                                    (dis && offSpl
                                      ? dis < offSpl
                                        ? 0
                                        : dis > offSpl
                                        ? dis
                                        : 0
                                      : dis
                                      ? dis
                                      : 0) +
                                    (dis && offSpl
                                      ? dis < offSpl
                                        ? offSpl
                                        : dis > offSpl
                                        ? 0
                                        : 0
                                      : offSpl
                                      ? offSpl
                                      : 0))) <=
                              0
                          }
                          className={`primaryButton text-center 
                                                                            ${
                                                                              stepperButton ||
                                                                              itk.exam_fees
                                                                                .filter(
                                                                                  (
                                                                                    fee
                                                                                  ) =>
                                                                                    fee.fees_count ===
                                                                                    itk.exam_details.filter(
                                                                                      (
                                                                                        el
                                                                                      ) =>
                                                                                        el.is_selected_exam
                                                                                    )
                                                                                      .length
                                                                                )
                                                                                .map(
                                                                                  (
                                                                                    fee
                                                                                  ) =>
                                                                                    fee.fees
                                                                                ) -
                                                                                (parseInt(
                                                                                  couponApplied.amount
                                                                                ) +
                                                                                  (dis &&
                                                                                  offSpl
                                                                                    ? dis <
                                                                                      offSpl
                                                                                      ? 0
                                                                                      : dis >
                                                                                        offSpl
                                                                                      ? dis
                                                                                      : 0
                                                                                    : dis
                                                                                    ? dis
                                                                                    : 0) +
                                                                                  (dis &&
                                                                                  offSpl
                                                                                    ? dis <
                                                                                      offSpl
                                                                                      ? offSpl
                                                                                      : dis >
                                                                                        offSpl
                                                                                      ? 0
                                                                                      : 0
                                                                                    : offSpl
                                                                                    ? offSpl
                                                                                    : 0)) +
                                                                                GSTPRICE *
                                                                                  (itk.exam_fees
                                                                                    .filter(
                                                                                      (
                                                                                        fee
                                                                                      ) =>
                                                                                        fee.fees_count ===
                                                                                        itk.exam_details.filter(
                                                                                          (
                                                                                            el
                                                                                          ) =>
                                                                                            el.is_selected_exam
                                                                                        )
                                                                                          .length
                                                                                    )
                                                                                    .map(
                                                                                      (
                                                                                        fee
                                                                                      ) =>
                                                                                        fee.fees
                                                                                    ) -
                                                                                    (parseInt(
                                                                                      couponApplied.amount
                                                                                    ) +
                                                                                      (dis &&
                                                                                      offSpl
                                                                                        ? dis <
                                                                                          offSpl
                                                                                          ? 0
                                                                                          : dis >
                                                                                            offSpl
                                                                                          ? dis
                                                                                          : 0
                                                                                        : dis
                                                                                        ? dis
                                                                                        : 0) +
                                                                                      (dis &&
                                                                                      offSpl
                                                                                        ? dis <
                                                                                          offSpl
                                                                                          ? offSpl
                                                                                          : dis >
                                                                                            offSpl
                                                                                          ? 0
                                                                                          : 0
                                                                                        : offSpl
                                                                                        ? offSpl
                                                                                        : 0))) <=
                                                                                0
                                                                                ? "disabledbtn"
                                                                                : "SaveButtons"
                                                                            }
                                                                          `}
                          onClick={() =>
                            handleSubmitCash(
                              itk.id,
                              dis && offSpl
                                ? dis < offSpl
                                  ? 0
                                  : dis > offSpl
                                  ? dis
                                  : 0
                                : dis
                                ? dis
                                : 0,
                              (dis && offSpl
                                ? dis < offSpl
                                  ? offSpl
                                  : dis > offSpl
                                  ? 0
                                  : 0
                                : offSpl
                                ? offSpl
                                : 0) +
                                couponApplied.amount +
                                (dis && offSpl
                                  ? dis < offSpl
                                    ? 0
                                    : dis > offSpl
                                    ? dis
                                    : 0
                                  : dis
                                  ? dis
                                  : 0),
                              (
                                itk.exam_fees
                                  .filter(
                                    (fee) =>
                                      fee.fees_count ===
                                      itk.exam_details.filter(
                                        (el) => el.is_selected_exam
                                      ).length
                                  )
                                  .map((fee) => fee.fees) -
                                (couponApplied.amount +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? 0
                                      : dis > offSpl
                                      ? dis
                                      : 0
                                    : dis
                                    ? dis
                                    : 0) +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? offSpl
                                      : dis > offSpl
                                      ? 0
                                      : 0
                                    : offSpl
                                    ? offSpl
                                    : 0)) +
                                GSTPRICE *
                                  (itk.exam_fees
                                    .filter(
                                      (fee) =>
                                        fee.fees_count ===
                                        itk.exam_details.filter(
                                          (el) => el.is_selected_exam
                                        ).length
                                    )
                                    .map((fee) => fee.fees) -
                                    (couponApplied.amount +
                                      (dis && offSpl
                                        ? dis < offSpl
                                          ? 0
                                          : dis > offSpl
                                          ? dis
                                          : 0
                                        : dis
                                        ? dis
                                        : 0) +
                                      (dis && offSpl
                                        ? dis < offSpl
                                          ? offSpl
                                          : dis > offSpl
                                          ? 0
                                          : 0
                                        : offSpl
                                        ? offSpl
                                        : 0)))
                              ).toFixed(2),
                              itk.course_name,
                              list.CourseCate,
                              (itk.exam_fees
                                .filter(
                                  (fee) =>
                                    fee.fees_count ===
                                    itk.exam_details.filter(
                                      (el) => el.is_selected_exam
                                    ).length
                                )
                                .map((fee) => fee.fees) -
                                (couponApplied.amount +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? 0
                                      : dis > offSpl
                                      ? dis
                                      : 0
                                    : dis
                                    ? dis
                                    : 0) +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? offSpl
                                      : dis > offSpl
                                      ? 0
                                      : 0
                                    : offSpl
                                    ? offSpl
                                    : 0))) *
                                GSTPRICE
                            )
                          }
                        >
                          {/* <a href="javascript:void(0)"> */}
                          Submit
                          {/* </a> */}
                        </button>
                      ) : (
                        <button
                          type="button"
                          disabled={
                            stepperButton ||
                            itk.exam_fees
                              .filter(
                                (fee) =>
                                  fee.fees_count ===
                                  itk.exam_details.filter(
                                    (el) => el.is_selected_exam
                                  ).length
                              )
                              .map((fee) => fee.fees) -
                              (parseInt(couponApplied.amount) +
                                (dis && offSpl
                                  ? dis < offSpl
                                    ? 0
                                    : dis > offSpl
                                    ? dis
                                    : 0
                                  : dis
                                  ? dis
                                  : 0) +
                                (dis && offSpl
                                  ? dis < offSpl
                                    ? offSpl
                                    : dis > offSpl
                                    ? 0
                                    : 0
                                  : offSpl
                                  ? offSpl
                                  : 0)) +
                              GSTPRICE *
                                (itk.exam_fees
                                  .filter(
                                    (fee) =>
                                      fee.fees_count ===
                                      itk.exam_details.filter(
                                        (el) => el.is_selected_exam
                                      ).length
                                  )
                                  .map((fee) => fee.fees) -
                                  (parseInt(couponApplied.amount) +
                                    (dis && offSpl
                                      ? dis < offSpl
                                        ? 0
                                        : dis > offSpl
                                        ? dis
                                        : 0
                                      : dis
                                      ? dis
                                      : 0) +
                                    (dis && offSpl
                                      ? dis < offSpl
                                        ? offSpl
                                        : dis > offSpl
                                        ? 0
                                        : 0
                                      : offSpl
                                      ? offSpl
                                      : 0))) <=
                              0
                          }
                          className={`primaryButton text-center 
                                                                            ${
                                                                              stepperButton ||
                                                                              itk.exam_fees
                                                                                .filter(
                                                                                  (
                                                                                    fee
                                                                                  ) =>
                                                                                    fee.fees_count ===
                                                                                    itk.exam_details.filter(
                                                                                      (
                                                                                        el
                                                                                      ) =>
                                                                                        el.is_selected_exam
                                                                                    )
                                                                                      .length
                                                                                )
                                                                                .map(
                                                                                  (
                                                                                    fee
                                                                                  ) =>
                                                                                    fee.fees
                                                                                ) -
                                                                                (parseInt(
                                                                                  couponApplied.amount
                                                                                ) +
                                                                                  (dis &&
                                                                                  offSpl
                                                                                    ? dis <
                                                                                      offSpl
                                                                                      ? 0
                                                                                      : dis >
                                                                                        offSpl
                                                                                      ? dis
                                                                                      : 0
                                                                                    : dis
                                                                                    ? dis
                                                                                    : 0) +
                                                                                  (dis &&
                                                                                  offSpl
                                                                                    ? dis <
                                                                                      offSpl
                                                                                      ? offSpl
                                                                                      : dis >
                                                                                        offSpl
                                                                                      ? 0
                                                                                      : 0
                                                                                    : offSpl
                                                                                    ? offSpl
                                                                                    : 0)) +
                                                                                GSTPRICE *
                                                                                  (itk.exam_fees
                                                                                    .filter(
                                                                                      (
                                                                                        fee
                                                                                      ) =>
                                                                                        fee.fees_count ===
                                                                                        itk.exam_details.filter(
                                                                                          (
                                                                                            el
                                                                                          ) =>
                                                                                            el.is_selected_exam
                                                                                        )
                                                                                          .length
                                                                                    )
                                                                                    .map(
                                                                                      (
                                                                                        fee
                                                                                      ) =>
                                                                                        fee.fees
                                                                                    ) -
                                                                                    (parseInt(
                                                                                      couponApplied.amount
                                                                                    ) +
                                                                                      (dis &&
                                                                                      offSpl
                                                                                        ? dis <
                                                                                          offSpl
                                                                                          ? 0
                                                                                          : dis >
                                                                                            offSpl
                                                                                          ? dis
                                                                                          : 0
                                                                                        : dis
                                                                                        ? dis
                                                                                        : 0) +
                                                                                      (dis &&
                                                                                      offSpl
                                                                                        ? dis <
                                                                                          offSpl
                                                                                          ? offSpl
                                                                                          : dis >
                                                                                            offSpl
                                                                                          ? 0
                                                                                          : 0
                                                                                        : offSpl
                                                                                        ? offSpl
                                                                                        : 0))) <=
                                                                                0
                                                                                ? "disabledbtn"
                                                                                : "SaveButtons"
                                                                            }
                                                                          `}
                          onClick={() =>
                            handleSubmit(
                              itk.id,
                              dis && offSpl
                                ? dis < offSpl
                                  ? 0
                                  : dis > offSpl
                                  ? dis
                                  : 0
                                : dis
                                ? dis
                                : 0,
                              (dis && offSpl
                                ? dis < offSpl
                                  ? offSpl
                                  : dis > offSpl
                                  ? 0
                                  : 0
                                : offSpl
                                ? offSpl
                                : 0) +
                                couponApplied.amount +
                                (dis && offSpl
                                  ? dis < offSpl
                                    ? 0
                                    : dis > offSpl
                                    ? dis
                                    : 0
                                  : dis
                                  ? dis
                                  : 0),
                              (
                                itk.exam_fees
                                  .filter(
                                    (fee) =>
                                      fee.fees_count ===
                                      itk.exam_details.filter(
                                        (el) => el.is_selected_exam
                                      ).length
                                  )
                                  .map((fee) => fee.fees) -
                                (couponApplied.amount +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? 0
                                      : dis > offSpl
                                      ? dis
                                      : 0
                                    : dis
                                    ? dis
                                    : 0) +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? offSpl
                                      : dis > offSpl
                                      ? 0
                                      : 0
                                    : offSpl
                                    ? offSpl
                                    : 0)) +
                                GSTPRICE *
                                  (itk.exam_fees
                                    .filter(
                                      (fee) =>
                                        fee.fees_count ===
                                        itk.exam_details.filter(
                                          (el) => el.is_selected_exam
                                        ).length
                                    )
                                    .map((fee) => fee.fees) -
                                    (couponApplied.amount +
                                      (dis && offSpl
                                        ? dis < offSpl
                                          ? 0
                                          : dis > offSpl
                                          ? dis
                                          : 0
                                        : dis
                                        ? dis
                                        : 0) +
                                      (dis && offSpl
                                        ? dis < offSpl
                                          ? offSpl
                                          : dis > offSpl
                                          ? 0
                                          : 0
                                        : offSpl
                                        ? offSpl
                                        : 0)))
                              ).toFixed(2),
                              itk.course_name,
                              list.courseId,
                              (itk.exam_fees
                                .filter(
                                  (fee) =>
                                    fee.fees_count ===
                                    itk.exam_details.filter(
                                      (el) => el.is_selected_exam
                                    ).length
                                )
                                .map((fee) => fee.fees) -
                                (couponApplied.amount +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? 0
                                      : dis > offSpl
                                      ? dis
                                      : 0
                                    : dis
                                    ? dis
                                    : 0) +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? offSpl
                                      : dis > offSpl
                                      ? 0
                                      : 0
                                    : offSpl
                                    ? offSpl
                                    : 0))) *
                                GSTPRICE
                            )
                          }
                        >
                          {/* <a href="javascript:void(0)"> */}
                          Pay Now
                          {/* </a> */}
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row" id={itk.id} key={index}>
                        <div className="col-lg-6 col-md-12">
                          <div className="card h-100">
                            <div className="row">
                              <div className="col-md-6 d-flex flex-column  justify-content-center align-center mt-4">
                                <img
                                  className="payment"
                                  src={`${ImageUrlPrefix}/${itk.img_url}`}
                                  alt="course_book"
                                  style={{
                                    width: "130px",
                                    height: "130px",
                                    alignSelf: "center",
                                  }}
                                />
                                <h5 className="card-title payment_course_name">
                                  {itk.course_name || ""} {"-"} {itk.name || ""}
                                </h5>
                                <p className=" ms-3 text-center payment_batch_name">
                                  {itk.batch_type && itk.batch_details
                                    ? `${itk.batch_type} - ${itk.batch_details}`
                                    : itk.batch_details}
                                </p>
                              </div>
                              {/* <div className="col-md-6">
                                <div
                                  className="d-flex mt-4 flex-column align-items-start payment
"
                                >
                                  <div className="">
                                    <LaptopChromebook className="payment_icon" />
                                    <div className="innerflex_payment">
                                      <h6 className="payment flex_title">
                                        Class Mode
                                      </h6>
                                      <h6 className="payment flex_subtitle">
                                        {itk.class_mode}
                                      </h6>
                                    </div>
                                  </div>

                                  <div className="">
                                    <Today className="payment_icon" />
                                    <div className="innerflex_payment">
                                      <h6 className="payment flex_title">
                                        Date
                                      </h6>
                                      <h6 className="payment flex_subtitle">
                                        {moment
                                          .utc(itk.start_dt)
                                          .format("DD/MM/YYYY")}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              <div className="col-lg-12 mb-4">
                                {itk.paper_type === 0 &&
                                  itk.exam_details.length > 0 &&
                                  itk.exam_details
                                    .filter(
                                      (elll) => elll.is_selected_exam === true
                                    )
                                     .sort(
                                      (a, b) =>
                                        a.exam_title_id - b.exam_title_id
                                    )
                                    .map((oj, index) => (
                                      <div className="row">
                                        <div className="col-md-12 col-sm-12 mx-2">
                                          <div className="row">
                                            <div className="col-md-4 mt-2">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  format_shapes
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="st_confirm_label ms-1">
                                                    Interview Title
                                                  </p>
                                                  <p className="st_confirm_value ms-1">
                                                    {oj.exam_title}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                            {/* New added */}

                                            <div className="col-md-4 mt-2">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  event
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="st_confirm_label ms-1">
                                                    Interview Date
                                                  </p>
                                                  <p className="st_confirm_value ms-1">
                                                    {oj.started_dt
                                                      ? moment(
                                                          oj.started_dt
                                                        ).format("Do MMM YYYY")
                                                      : "_"}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                            <div className="col-md-4 mt-2">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  event
                                                </span>
                                                <div className="d-flex flex-column ">
                                                  <p className="st_confirm_label ms-1">
                                                    Last Date to Apply
                                                  </p>
                                                  <p className="st_confirm_value ms-1">
                                                    {moment
                                                      .utc(oj.last_dt_apply)
                                                      .format("Do MMM YYYY")}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                          </div>
                                        </div>
                                        {itk.exam_details.length > 1 &&
                                          itk.exam_details.map(
                                            (el) => el.is_selected_exam === true
                                          ).length > 1 &&
                                          index <
                                            itk.exam_details.length - 1 && (
                                            <span className="border-exam-short my-2"></span>
                                          )}
                                      </div>
                                    ))}

                                {itk.paper_type === 1 &&
                                  itk.exam_details.length > 0 &&
                                  itk.exam_details
                                    .filter(
                                      (elll) => elll.is_selected_exam === true
                                    )
                                    ?.sort(
                                      (a, b) =>
                                        new Date(a.last_dt_apply) -
                                        new Date(b.last_dt_apply)
                                    )
                                    ?.map((oj, index) => (
                                      <div className="row">
                                        <div className="col-md-12 mt-3 col-sm-12 ">
                                          <div className="row">
                                            <div className="col-md-4 dflex justify-content-center">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  format_shapes
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="st_confirm_label ms-1">
                                                    Interview Title
                                                  </p>
                                                  <p className="st_confirm_value ms-1">
                                                    {oj.exam_title}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                            <div className="col-md-4 dflex justify-content-center">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  event
                                                </span>
                                                <div className="d-flex flex-column ">
                                                  <p className="st_confirm_label ms-1">
                                                    Interview Date
                                                  </p>
                                                  <p className="st_confirm_value ms-1">
                                                    {moment
                                                      .utc(oj.started_dt)
                                                      .format("Do MMM YYYY")}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                            <div className="col-md-4 dflex justify-content-center">
                                              <li className="IconsImage">
                                                <span className="material-icons">
                                                  event
                                                </span>
                                                <div className="d-flex flex-column">
                                                  <p className="st_confirm_label ms-1">
                                                    Last Date to Apply
                                                  </p>
                                                  <p className="st_confirm_value ms-1">
                                                    {moment
                                                      .utc(oj.last_dt_apply)
                                                      .format("Do MMM YYYY")}
                                                  </p>
                                                </div>
                                              </li>
                                            </div>
                                          </div>
                                        </div>
                                        {itk.exam_details.length > 1 &&
                                          itk.exam_details.map(
                                            (el) => el.is_selected_exam === true
                                          ).length > 1 &&
                                          index <
                                            itk.exam_details.length - 1 && (
                                            <span className="border-exam-short my-2"></span>
                                          )}
                                      </div>
                                    ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="card h-100">
                            <div className="row mt-4">
                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                <h6 className="Payment_labelInfo">
                                  Actual Exam Fee
                                </h6>
                              </div>
                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                <h6 className="Payment_labelInfos">
                                  <CurrencyRupee className="payment_currency" />
                                  {itk.exam_fees
                                    .filter(
                                      (fee) =>
                                        fee.fees_count ===
                                        itk.exam_details.filter(
                                          (el) => el.is_selected_exam
                                        ).length
                                    )
                                    .map((fee) => fee.fees)}
                                </h6>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                <h6 className="payment_fees_name">
                                  Special Offer
                                </h6>
                              </div>
                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                <h6 className="payment_fees">
                                  <CurrencyRupee className="payment_currency" />
                                  {dis && offSpl
                                    ? dis < offSpl
                                      ? offSpl
                                      : dis > offSpl
                                      ? 0
                                      : 0
                                    : offSpl
                                    ? offSpl
                                    : 0}
                                </h6>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                <h6 className="payment_fees_name PymentCoun">
                                  Coupon Code
                                </h6>
                              </div>

                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                <div className="d-flex coupon_box mb-1">
                                  <input
                                    type="text"
                                    id="CouponCode"
                                    name="CouponCode"
                                    onChange={handleChange}
                                    value={couponApplied.coupon_code || ""}
                                    className={`payment_fees payment_input gap-2 payment_fees_mobile ${
                                      listErrors.coupon_code ? "mb-0" : ""
                                    }`}
                                    style={{ height: "40px" }}
                                    placeholder="Coupon Code"
                                  />
                                  &nbsp;&nbsp;
                                  <button
                                    className={`btn payment payment_coupen ${
                                      listErrors.coupon_code ? "mb-0" : ""
                                    }`}
                                    type="button"
                                    onClick={(e) =>
                                      handleCouponCode(
                                        e,
                                        itk.exam_fees
                                          .filter(
                                            (fee) =>
                                              fee.fees_count ===
                                              itk.exam_details.filter(
                                                (el) =>
                                                  el.is_selected_exam === true
                                              ).length
                                          )
                                          .map((fee) => fee.fees)[0] || 0,
                                        itk.id
                                      )
                                    }
                                  >
                                    Apply Coupon Code
                                  </button>
                                </div>

                                {/* ---- SINGLE MESSAGE BLOCK (ERROR / SUCCESS) ---- */}
                                {(listErrors.coupon_code || message) && (
                                  <p
                                    className={`mx-0 my-1 ${
                                      couponApplied.status
                                        ? "text-success"
                                        : "errors"
                                    }`}
                                  >
                                    {listErrors.coupon_code || message}
                                  </p>
                                )}
                              </div>
                            </div>

                            {/* ---- Coupon Amount Section ---- */}
                            <div className="row">
                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                {couponApplied.status === true && (
                                  <h6 className="payment_fees_name">
                                    Coupon Amount
                                  </h6>
                                )}
                              </div>

                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                {couponApplied.status === true && (
                                  <h6 className="payment_fees">
                                    <CurrencyRupee className="payment_currency" />
                                    <span className="text-success fw-bold">
                                      {couponApplied.amount}
                                    </span>
                                    <span className="text-success ms-2">
                                      <strike>Coupon applied</strike>
                                    </span>
                                  </h6>
                                )}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                <h6
                                  className="Payment_labelInfo"
                                  style={{ paddingTop: "9px" }}
                                >
                                  Total Discount
                                </h6>
                              </div>
                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                <h6 className="Payment_labelInfos">
                                  <CurrencyRupee className="payment_currency" />
                                  {/* <span>
                                    {parseInt(itk.offer_spl) +
                                      parseInt(couponApplied.amount)}
                                    {/* {getTamount} */}
                                  {/* </span> */}
                                  <span>
                                    {couponApplied.status &&
                                    message ===
                                      "Coupon code applied successfully"
                                      ? (dis && offSpl
                                          ? dis < offSpl
                                            ? offSpl
                                            : dis > offSpl
                                            ? 0
                                            : 0
                                          : offSpl
                                          ? offSpl
                                          : 0) + parseInt(couponApplied.amount)
                                      : 0}
                                  </span>
                                </h6>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                <h6 className="payment_fees_name">
                                  Amount Payable
                                </h6>
                              </div>
                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                <h6 className="payment_fees">
                                  <CurrencyRupee className="payment_currency" />
                                  <span>
                                    {itk.exam_fees
                                      .filter(
                                        (fee) =>
                                          fee.fees_count ===
                                          itk.exam_details.filter(
                                            (el) => el.is_selected_exam
                                          ).length
                                      )
                                      .map((fee) => fee.fees) -
                                      ((dis && offSpl
                                        ? dis < offSpl
                                          ? offSpl
                                          : dis > offSpl
                                          ? 0
                                          : 0
                                        : offSpl
                                        ? offSpl
                                        : 0) +
                                        couponApplied.amount +
                                        (dis && offSpl
                                          ? dis < offSpl
                                            ? 0
                                            : dis > offSpl
                                            ? dis
                                            : 0
                                          : dis
                                          ? dis
                                          : 0)) >
                                    0
                                      ? itk.exam_fees
                                          .filter(
                                            (fee) =>
                                              fee.fees_count ===
                                              itk.exam_details.filter(
                                                (el) => el.is_selected_exam
                                              ).length
                                          )
                                          .map((fee) => fee.fees) -
                                        ((dis && offSpl
                                          ? dis < offSpl
                                            ? offSpl
                                            : dis > offSpl
                                            ? 0
                                            : 0
                                          : offSpl
                                          ? offSpl
                                          : 0) +
                                          couponApplied.amount +
                                          (dis && offSpl
                                            ? dis < offSpl
                                              ? 0
                                              : dis > offSpl
                                              ? dis
                                              : 0
                                            : dis
                                            ? dis
                                            : 0))
                                      : 0}
                                  </span>
                                </h6>
                              </div>
                            </div>
                            {/* <div className="row">
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6 className="payment_fees_name">
                                    GST(0%)
                                  </h6>
                                </div>
                                <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                  <h6 className="payment_fees">
                                    <CurrencyRupee className="payment_currency" />
                                    <span className="">
                                      {" "}
                                      {(
                                        (itk.dis_amt - couponApplied.amount) *
                                        GSTPRICE
                                      ).toFixed(2)}
                                    </span>
                                  </h6>
                                </div>
                              </div> */}
                            <div className="row">
                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                <h6
                                  className="Payment_labelInfo"
                                  id="remain_fee"
                                >
                                  Net Amount to Pay
                                </h6>
                              </div>
                              <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                                <h6 className="Payment_labelInfos">
                                  <CurrencyRupee className="payment_currency" />
                                  <span>
                                    {(
                                      itk.exam_fees
                                        .filter(
                                          (fee) =>
                                            fee.fees_count ===
                                            itk.exam_details.filter(
                                              (el) => el.is_selected_exam
                                            ).length
                                        )
                                        .map((fee) => fee.fees) -
                                      (parseInt(couponApplied.amount) +
                                        (dis && offSpl
                                          ? dis < offSpl
                                            ? 0
                                            : dis > offSpl
                                            ? dis
                                            : 0
                                          : dis
                                          ? dis
                                          : 0) +
                                        (dis && offSpl
                                          ? dis < offSpl
                                            ? offSpl
                                            : dis > offSpl
                                            ? 0
                                            : 0
                                          : offSpl
                                          ? offSpl
                                          : 0)) +
                                      GSTPRICE *
                                        (itk.exam_fees
                                          .filter(
                                            (fee) =>
                                              fee.fees_count ===
                                              itk.exam_details.filter(
                                                (el) => el.is_selected_exam
                                              ).length
                                          )
                                          .map((fee) => fee.fees) -
                                          (parseInt(couponApplied.amount) +
                                            (dis && offSpl
                                              ? dis < offSpl
                                                ? 0
                                                : dis > offSpl
                                                ? dis
                                                : 0
                                              : dis
                                              ? dis
                                              : 0) +
                                            (dis && offSpl
                                              ? dis < offSpl
                                                ? offSpl
                                                : dis > offSpl
                                                ? 0
                                                : 0
                                              : offSpl
                                              ? offSpl
                                              : 0)))
                                    ).toFixed(2)}
                                  </span>
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {dis !== 0 && (
                    <section className="sectionSix">
                      <div className="row box">
                        <div className="col-md-12">
                          <p className="StepTitle">Old Student Discount</p>
                          <div className="row mb-3">
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted"
                                >
                                  Old Student Discount
                                </label>
                                <span className="ReviewLabel align-middle">
                                  <CurrencyRupee className="payment_currency" />{" "}
                                  {dis}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-12 col-lg-12 mt-2 mb-2">
                              <div className="forms ">
                                <span className="ReviewLabel_note alert_info">
                                  <strong> Note :</strong> The Old Student
                                  Discount will be applied to the final
                                  installment only if you select the Partial
                                  Payment option. Alternatively, if you choose
                                  the Full Payment option, the Old Student
                                  Discount amount will be deducted from the
                                  payment immediately.
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  )}
                  <section className="sectionSix">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">Payment Mode</p>
                        <div className="row ">
                          <div className="col-md-6 col-lg-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted"
                              >
                                Payment Mode
                              </label>
                              <div
                                className="d-flex  col-md-12"
                                id="radiobuttons"
                              >
                                <div className="form-check form-check-inline">
                                  <input
                                    ref={txtAdPPaymentMode}
                                    className="checkbox_radio"
                                    type="radio"
                                    name="PPaymentMode"
                                    id="onlinemode"
                                    checked={
                                      list.PPaymentMode === "1" ? true : false
                                    }
                                    value="1"
                                    onChange={handleChange}
                                  />
                                  <label
                                    className="checkbox-label mt-1"
                                    htmlFor="onlinemode"
                                  >
                                    Online
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="checkbox_radio"
                                    type="radio"
                                    name="PPaymentMode"
                                    id="CashMode"
                                    value="0"
                                    checked={
                                      list.PPaymentMode === "0" ? true : false
                                    }
                                    onChange={handleChange}
                                  />
                                  <label
                                    className="checkbox-label mt-1"
                                    htmlFor="CashMode"
                                  >
                                    Cash
                                  </label>
                                </div>
                              </div>
                              {listErrors.PPaymentMode && (
                                <p className="errors">
                                  {listErrors.PPaymentMode}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12 col-lg-12 mt-2 mb-2">
                            <div className="forms ">
                              <span className="ReviewLabel_note alert_info">
                                <strong> NOTE: </strong> If you've chosen cash
                                payment, a unique Order ID will be shared after
                                form submission. Note it down and visit the
                                office reception to pay your specified fees.
                                Contact the finance admin at the reception for
                                assistance.
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  {/* save buttons */}
                  <div className="heading mb-4  dflexbetww " key={index}>
                    <div className="">
                      <button
                        type="button"
                        className="SaveButton_Prev"
                        onClick={handlePrevious}
                      >
                        <a href="javascript:void(0)">
                          Go to Review and Confirm
                        </a>
                      </button>
                    </div>
                    <div className="d-flex smButton mobiledown">
                      <Link to="/" className="CancelButton">
                        Back to Home
                      </Link>
                      {list.PPaymentMode === "0" ? (
                        <button
                          type="button"
                          disabled={
                            stepperButton ||
                            itk.exam_fees
                              .filter(
                                (fee) =>
                                  fee.fees_count ===
                                  itk.exam_details.filter(
                                    (el) => el.is_selected_exam
                                  ).length
                              )
                              .map((fee) => fee.fees) -
                              (parseInt(couponApplied.amount) +
                                (dis && offSpl
                                  ? dis < offSpl
                                    ? 0
                                    : dis > offSpl
                                    ? dis
                                    : 0
                                  : dis
                                  ? dis
                                  : 0) +
                                (dis && offSpl
                                  ? dis < offSpl
                                    ? offSpl
                                    : dis > offSpl
                                    ? 0
                                    : 0
                                  : offSpl
                                  ? offSpl
                                  : 0)) +
                              GSTPRICE *
                                (itk.exam_fees
                                  .filter(
                                    (fee) =>
                                      fee.fees_count ===
                                      itk.exam_details.filter(
                                        (el) => el.is_selected_exam
                                      ).length
                                  )
                                  .map((fee) => fee.fees) -
                                  (parseInt(couponApplied.amount) +
                                    (dis && offSpl
                                      ? dis < offSpl
                                        ? 0
                                        : dis > offSpl
                                        ? dis
                                        : 0
                                      : dis
                                      ? dis
                                      : 0) +
                                    (dis && offSpl
                                      ? dis < offSpl
                                        ? offSpl
                                        : dis > offSpl
                                        ? 0
                                        : 0
                                      : offSpl
                                      ? offSpl
                                      : 0))) <=
                              0
                          }
                          className={`primaryButton text-center 
                                                                            ${
                                                                              stepperButton ||
                                                                              itk.exam_fees
                                                                                .filter(
                                                                                  (
                                                                                    fee
                                                                                  ) =>
                                                                                    fee.fees_count ===
                                                                                    itk.exam_details.filter(
                                                                                      (
                                                                                        el
                                                                                      ) =>
                                                                                        el.is_selected_exam
                                                                                    )
                                                                                      .length
                                                                                )
                                                                                .map(
                                                                                  (
                                                                                    fee
                                                                                  ) =>
                                                                                    fee.fees
                                                                                ) -
                                                                                (parseInt(
                                                                                  couponApplied.amount
                                                                                ) +
                                                                                  (dis &&
                                                                                  offSpl
                                                                                    ? dis <
                                                                                      offSpl
                                                                                      ? 0
                                                                                      : dis >
                                                                                        offSpl
                                                                                      ? dis
                                                                                      : 0
                                                                                    : dis
                                                                                    ? dis
                                                                                    : 0) +
                                                                                  (dis &&
                                                                                  offSpl
                                                                                    ? dis <
                                                                                      offSpl
                                                                                      ? offSpl
                                                                                      : dis >
                                                                                        offSpl
                                                                                      ? 0
                                                                                      : 0
                                                                                    : offSpl
                                                                                    ? offSpl
                                                                                    : 0)) +
                                                                                GSTPRICE *
                                                                                  (itk.exam_fees
                                                                                    .filter(
                                                                                      (
                                                                                        fee
                                                                                      ) =>
                                                                                        fee.fees_count ===
                                                                                        itk.exam_details.filter(
                                                                                          (
                                                                                            el
                                                                                          ) =>
                                                                                            el.is_selected_exam
                                                                                        )
                                                                                          .length
                                                                                    )
                                                                                    .map(
                                                                                      (
                                                                                        fee
                                                                                      ) =>
                                                                                        fee.fees
                                                                                    ) -
                                                                                    (parseInt(
                                                                                      couponApplied.amount
                                                                                    ) +
                                                                                      (dis &&
                                                                                      offSpl
                                                                                        ? dis <
                                                                                          offSpl
                                                                                          ? 0
                                                                                          : dis >
                                                                                            offSpl
                                                                                          ? dis
                                                                                          : 0
                                                                                        : dis
                                                                                        ? dis
                                                                                        : 0) +
                                                                                      (dis &&
                                                                                      offSpl
                                                                                        ? dis <
                                                                                          offSpl
                                                                                          ? offSpl
                                                                                          : dis >
                                                                                            offSpl
                                                                                          ? 0
                                                                                          : 0
                                                                                        : offSpl
                                                                                        ? offSpl
                                                                                        : 0))) <=
                                                                                0
                                                                                ? "disabledbtn"
                                                                                : "SaveButtons"
                                                                            }
                                                                          `}
                          onClick={() =>
                            handleSubmitCash(
                              itk.id,
                              dis && offSpl
                                ? dis < offSpl
                                  ? 0
                                  : dis > offSpl
                                  ? dis
                                  : 0
                                : dis
                                ? dis
                                : 0,
                              (dis && offSpl
                                ? dis < offSpl
                                  ? offSpl
                                  : dis > offSpl
                                  ? 0
                                  : 0
                                : offSpl
                                ? offSpl
                                : 0) +
                                couponApplied.amount +
                                (dis && offSpl
                                  ? dis < offSpl
                                    ? 0
                                    : dis > offSpl
                                    ? dis
                                    : 0
                                  : dis
                                  ? dis
                                  : 0),
                              (
                                itk.exam_fees
                                  .filter(
                                    (fee) =>
                                      fee.fees_count ===
                                      itk.exam_details.filter(
                                        (el) => el.is_selected_exam
                                      ).length
                                  )
                                  .map((fee) => fee.fees) -
                                (couponApplied.amount +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? 0
                                      : dis > offSpl
                                      ? dis
                                      : 0
                                    : dis
                                    ? dis
                                    : 0) +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? offSpl
                                      : dis > offSpl
                                      ? 0
                                      : 0
                                    : offSpl
                                    ? offSpl
                                    : 0)) +
                                GSTPRICE *
                                  (itk.exam_fees
                                    .filter(
                                      (fee) =>
                                        fee.fees_count ===
                                        itk.exam_details.filter(
                                          (el) => el.is_selected_exam
                                        ).length
                                    )
                                    .map((fee) => fee.fees) -
                                    (couponApplied.amount +
                                      (dis && offSpl
                                        ? dis < offSpl
                                          ? 0
                                          : dis > offSpl
                                          ? dis
                                          : 0
                                        : dis
                                        ? dis
                                        : 0) +
                                      (dis && offSpl
                                        ? dis < offSpl
                                          ? offSpl
                                          : dis > offSpl
                                          ? 0
                                          : 0
                                        : offSpl
                                        ? offSpl
                                        : 0)))
                              ).toFixed(2),
                              itk.course_name,
                              list.CourseCate,
                              (itk.exam_fees
                                .filter(
                                  (fee) =>
                                    fee.fees_count ===
                                    itk.exam_details.filter(
                                      (el) => el.is_selected_exam
                                    ).length
                                )
                                .map((fee) => fee.fees) -
                                (couponApplied.amount +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? 0
                                      : dis > offSpl
                                      ? dis
                                      : 0
                                    : dis
                                    ? dis
                                    : 0) +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? offSpl
                                      : dis > offSpl
                                      ? 0
                                      : 0
                                    : offSpl
                                    ? offSpl
                                    : 0))) *
                                GSTPRICE
                            )
                          }
                        >
                          {/* <a href="javascript:void(0)"> */}
                          Submit
                          {/* </a> */}
                        </button>
                      ) : (
                        <button
                          type="button"
                          disabled={
                            stepperButton ||
                            itk.exam_fees
                              .filter(
                                (fee) =>
                                  fee.fees_count ===
                                  itk.exam_details.filter(
                                    (el) => el.is_selected_exam
                                  ).length
                              )
                              .map((fee) => fee.fees) -
                              (parseInt(couponApplied.amount) +
                                (dis && offSpl
                                  ? dis < offSpl
                                    ? 0
                                    : dis > offSpl
                                    ? dis
                                    : 0
                                  : dis
                                  ? dis
                                  : 0) +
                                (dis && offSpl
                                  ? dis < offSpl
                                    ? offSpl
                                    : dis > offSpl
                                    ? 0
                                    : 0
                                  : offSpl
                                  ? offSpl
                                  : 0)) +
                              GSTPRICE *
                                (itk.exam_fees
                                  .filter(
                                    (fee) =>
                                      fee.fees_count ===
                                      itk.exam_details.filter(
                                        (el) => el.is_selected_exam
                                      ).length
                                  )
                                  .map((fee) => fee.fees) -
                                  (parseInt(couponApplied.amount) +
                                    (dis && offSpl
                                      ? dis < offSpl
                                        ? 0
                                        : dis > offSpl
                                        ? dis
                                        : 0
                                      : dis
                                      ? dis
                                      : 0) +
                                    (dis && offSpl
                                      ? dis < offSpl
                                        ? offSpl
                                        : dis > offSpl
                                        ? 0
                                        : 0
                                      : offSpl
                                      ? offSpl
                                      : 0))) <=
                              0
                          }
                          className={`primaryButton text-center 
                                                                            ${
                                                                              stepperButton ||
                                                                              itk.exam_fees
                                                                                .filter(
                                                                                  (
                                                                                    fee
                                                                                  ) =>
                                                                                    fee.fees_count ===
                                                                                    itk.exam_details.filter(
                                                                                      (
                                                                                        el
                                                                                      ) =>
                                                                                        el.is_selected_exam
                                                                                    )
                                                                                      .length
                                                                                )
                                                                                .map(
                                                                                  (
                                                                                    fee
                                                                                  ) =>
                                                                                    fee.fees
                                                                                ) -
                                                                                (parseInt(
                                                                                  couponApplied.amount
                                                                                ) +
                                                                                  (dis &&
                                                                                  offSpl
                                                                                    ? dis <
                                                                                      offSpl
                                                                                      ? 0
                                                                                      : dis >
                                                                                        offSpl
                                                                                      ? dis
                                                                                      : 0
                                                                                    : dis
                                                                                    ? dis
                                                                                    : 0) +
                                                                                  (dis &&
                                                                                  offSpl
                                                                                    ? dis <
                                                                                      offSpl
                                                                                      ? offSpl
                                                                                      : dis >
                                                                                        offSpl
                                                                                      ? 0
                                                                                      : 0
                                                                                    : offSpl
                                                                                    ? offSpl
                                                                                    : 0)) +
                                                                                GSTPRICE *
                                                                                  (itk.exam_fees
                                                                                    .filter(
                                                                                      (
                                                                                        fee
                                                                                      ) =>
                                                                                        fee.fees_count ===
                                                                                        itk.exam_details.filter(
                                                                                          (
                                                                                            el
                                                                                          ) =>
                                                                                            el.is_selected_exam
                                                                                        )
                                                                                          .length
                                                                                    )
                                                                                    .map(
                                                                                      (
                                                                                        fee
                                                                                      ) =>
                                                                                        fee.fees
                                                                                    ) -
                                                                                    (parseInt(
                                                                                      couponApplied.amount
                                                                                    ) +
                                                                                      (dis &&
                                                                                      offSpl
                                                                                        ? dis <
                                                                                          offSpl
                                                                                          ? 0
                                                                                          : dis >
                                                                                            offSpl
                                                                                          ? dis
                                                                                          : 0
                                                                                        : dis
                                                                                        ? dis
                                                                                        : 0) +
                                                                                      (dis &&
                                                                                      offSpl
                                                                                        ? dis <
                                                                                          offSpl
                                                                                          ? offSpl
                                                                                          : dis >
                                                                                            offSpl
                                                                                          ? 0
                                                                                          : 0
                                                                                        : offSpl
                                                                                        ? offSpl
                                                                                        : 0))) <=
                                                                                0
                                                                                ? "disabledbtn"
                                                                                : "SaveButtons"
                                                                            }
                                                                          `}
                          onClick={() =>
                            handleSubmit(
                              itk.id,
                              dis && offSpl
                                ? dis < offSpl
                                  ? 0
                                  : dis > offSpl
                                  ? dis
                                  : 0
                                : dis
                                ? dis
                                : 0,
                              (dis && offSpl
                                ? dis < offSpl
                                  ? offSpl
                                  : dis > offSpl
                                  ? 0
                                  : 0
                                : offSpl
                                ? offSpl
                                : 0) +
                                couponApplied.amount +
                                (dis && offSpl
                                  ? dis < offSpl
                                    ? 0
                                    : dis > offSpl
                                    ? dis
                                    : 0
                                  : dis
                                  ? dis
                                  : 0),
                              (
                                itk.exam_fees
                                  .filter(
                                    (fee) =>
                                      fee.fees_count ===
                                      itk.exam_details.filter(
                                        (el) => el.is_selected_exam
                                      ).length
                                  )
                                  .map((fee) => fee.fees) -
                                (couponApplied.amount +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? 0
                                      : dis > offSpl
                                      ? dis
                                      : 0
                                    : dis
                                    ? dis
                                    : 0) +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? offSpl
                                      : dis > offSpl
                                      ? 0
                                      : 0
                                    : offSpl
                                    ? offSpl
                                    : 0)) +
                                GSTPRICE *
                                  (itk.exam_fees
                                    .filter(
                                      (fee) =>
                                        fee.fees_count ===
                                        itk.exam_details.filter(
                                          (el) => el.is_selected_exam
                                        ).length
                                    )
                                    .map((fee) => fee.fees) -
                                    (couponApplied.amount +
                                      (dis && offSpl
                                        ? dis < offSpl
                                          ? 0
                                          : dis > offSpl
                                          ? dis
                                          : 0
                                        : dis
                                        ? dis
                                        : 0) +
                                      (dis && offSpl
                                        ? dis < offSpl
                                          ? offSpl
                                          : dis > offSpl
                                          ? 0
                                          : 0
                                        : offSpl
                                        ? offSpl
                                        : 0)))
                              ).toFixed(2),
                              itk.course_name,
                              list.courseId,
                              (itk.exam_fees
                                .filter(
                                  (fee) =>
                                    fee.fees_count ===
                                    itk.exam_details.filter(
                                      (el) => el.is_selected_exam
                                    ).length
                                )
                                .map((fee) => fee.fees) -
                                (couponApplied.amount +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? 0
                                      : dis > offSpl
                                      ? dis
                                      : 0
                                    : dis
                                    ? dis
                                    : 0) +
                                  (dis && offSpl
                                    ? dis < offSpl
                                      ? offSpl
                                      : dis > offSpl
                                      ? 0
                                      : 0
                                    : offSpl
                                    ? offSpl
                                    : 0))) *
                                GSTPRICE
                            )
                          }
                        >
                          {/* <a href="javascript:void(0)"> */}
                          Pay Now
                          {/* </a> */}
                        </button>
                      )}
                    </div>
                  </div>
                </>
              ))}
          </div>
        )}

        {/* &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& */}
        {/* {step === 7} */}
        {step === 7 && (
          <div className=" sectionSeven">
            <div className="row">
              <div className="col-md-12 d-flex justify-content-center">
                {list.PPaymentMode === "1" ? (
                  <div className="stepSeven">
                    <p className="psubtitle">{batchMessage || ""}</p>
                  </div>
                ) : (
                  <div className="stepSeven">
                    <p className="psubtitle">{batchMessage || ""}</p>
                    <p className="psubtitle_cash">
                      You've selected cash payment and a unique Order ID has
                      been sent to your email. Note it down and visit the office
                      reception to pay your specified fees.
                    </p>

                    <p className="psubtitle">
                      Contact the finance admin at the office reception for
                      assistance.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </form>
      {/* loader */}
      {isPaymentLoading && (
        <Dialog open={isPaymentLoading}>
          <DialogContent>
            <div style={{ margin: "15px" }}>
              {/* <div className="spinner-border text-danger"></div>{" "} */}
              <p> We are processing your payment. Please wait...</p>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}

export default MockInterview;
